// AUTO-GENERATED translations — 11 languages × 227 keys.
// Edit /app/scripts/translate_all.py and re-run to regenerate.

export const TRANSLATIONS = {
  "en": {
    "nav_features": "Features",
    "nav_dashboard": "Dashboard",
    "nav_comparison": "Compare",
    "nav_pricing": "Pricing",
    "nav_faq": "FAQ",
    "nav_get_access": "Get access",
    "ann_launch_offer": "Launch offer",
    "ann_save_today": "Save {amount} today",
    "ann_left": "left",
    "ann_grab": "Grab it →",
    "hero_badge1": "Built for Gold · 2025+ regime",
    "hero_badge2": "Prop-firm ready",
    "hero_badge_copies": "Only {n} copies left",
    "hero_h1_a": "Pass prop challenges.",
    "hero_h1_b": "Trade Gold",
    "hero_h1_c": "like a disciplined machine.",
    "hero_sub": "Prop Passer Gold EA is a XAUUSD-focused MetaTrader 5 robot engineered around prop-firm rules — drawdown caps, target lock, risk-per-trade guards, and a premium on-chart dashboard. No martingale. No grid. Just rules-first execution.",
    "hero_cta_primary": "Get instant access",
    "hero_cta_secondary": "Free setup help on WhatsApp",
    "hero_save": "launch",
    "hero_pill1": "Gold-focused",
    "hero_pill2": "DD guarded",
    "hero_pill3": "One-time pay",
    "hero_card_buy": "Buy at {price}",
    "hero_card_trust": "Instant delivery · Secure checkout · Lifetime license",
    "hero_card_sym": "Symbol",
    "hero_card_plat": "Platform",
    "hero_card_strat": "Strategy",
    "hero_card_prot": "Protection",
    "hero_card_strat_v": "Structure + Volatility",
    "hero_card_prot_v": "Prop Engine",
    "hero_card_b1": "Daily drawdown + max DD guard",
    "hero_card_b2": "Profit target lock after completion",
    "hero_card_b3": "Friday / weekend protection",
    "hero_card_b4": "Economic calendar news filter",
    "problem_chip": "The prop firm reality",
    "problem_h1_a": "9 out of 10",
    "problem_h1_b": "traders fail challenges. Not because of bad entries.",
    "problem_sub": "Prop firms don't pay for being right. They pay for being inside the rules when you're right. Every single failure below is a behavioural problem, not a market problem — and every single one is what this EA was engineered to remove.",
    "problem_disclaimer": "* Failure rates based on publicly reported prop firm evaluation data.",
    "fail1_title": "Break drawdown rules",
    "fail1_desc": "One emotional trade after a loss breaches daily DD. Challenge over — even if the account was in profit an hour earlier.",
    "fail2_title": "Give back the target",
    "fail2_desc": "Hit 8% profit target, keep trading 'for fun', end the week at 2%. The EA auto-stops new trades after target.",
    "fail3_title": "Overtrade weak sessions",
    "fail3_desc": "Gold chops during rollover, Asian lull, and high-spread windows. The session + spread filters block entries automatically.",
    "fail4_title": "Revenge-size after losses",
    "fail4_desc": "Double lot to 'win it back' → bigger loss → max DD hit. Risk-per-trade cap makes this mathematically impossible.",
    "features_chip": "Risk-first architecture",
    "features_h1_a": "Engineered for the",
    "features_h1_b": "prop challenge reality.",
    "features_sub": "Firms don't pay for gut feel. They pay for discipline inside hard limits. Every module below exists for one reason: keep your account eligible long enough for your edge to play out.",
    "feat1_title": "Prop challenge protection engine",
    "feat1_desc": "Built-in presets + custom rule mode. Tracks daily loss, max drawdown, symbol loss and consistency — so you stay inside the guardrails that pass evaluations.",
    "feat2_title": "Daily & max drawdown guard",
    "feat2_desc": "Supports both static and trailing DD models. Calculates loss floors in real time and blocks new trades that could breach the rule.",
    "feat3_title": "Profit target lock",
    "feat3_desc": "Most traders give back profits after hitting the target. The EA can automatically stop new entries once the target is reached — locking progress.",
    "feat4_title": "Risk-per-trade protection",
    "feat4_desc": "Percent-based or fixed lot sizing with min/max lot limits. Blocks trades whose SL distance would risk more than your cap.",
    "feat5_title": "Market quality filters",
    "feat5_desc": "ATR volatility, spread, session, and news filters keep the EA out of toxic conditions where Gold chops traders.",
    "feat6_title": "Friday & weekend protection",
    "feat6_desc": "Auto-closes positions before Friday cutoff and blocks entries near the weekend risk window — perfect for instant funding rules.",
    "feat7_title": "Consistency monitor",
    "feat7_desc": "Tracks best-day-to-total ratio so you can meet consistency rules some prop firms enforce. No single-day lottery trades.",
    "feat8_title": "No martingale · no grid",
    "feat8_desc": "No averaging into losers. Every trade has a hard stop loss based on market structure — clean logic evaluators like.",
    "feat9_title": "Premium on-chart dashboard",
    "feat9_desc": "See challenge model, DD left, today P/L, target progress, spread, news and session status at a glance — no manual calc.",
    "dashboard_chip": "Premium on-chart intelligence",
    "dashboard_h1_a": "Every rule —",
    "dashboard_h1_b": "visible in real time.",
    "dashboard_sub": "Most bots leave you guessing. Prop Passer Gold shows you exactly what matters: how much drawdown room you have left, how close you are to the profit target, and whether the market is even safe to trade right now. No more mental math. No more rule-break surprises.",
    "dash_b1": "Live daily / max drawdown gauges",
    "dash_b2": "Profit target progress — stops trading when hit",
    "dash_b3": "Risk-per-trade calculator before every entry",
    "dash_b4": "Spread · news · session filters always-on",
    "dash_b5": "Consistency score for strict prop firms",
    "dash_label1": "Main EA dashboard",
    "dash_label2": "Drawdown guard",
    "dash_label3": "Risk meter",
    "dash_label4": "Equity curve",
    "dash_label5": "Prop rules panel",
    "comp_chip": "Side-by-side",
    "comp_h1_a": "Why traders keep",
    "comp_h1_b": "losing accounts.",
    "comp_sub": "The difference between funded and failed isn't entries — it's what happens after the entry. Here's where Prop Passer Gold wins.",
    "comp_yes": "Yes",
    "comp_no": "No",
    "comp_partial": "Partial / depends",
    "comp_capability": "Capability",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "Manual trading",
    "comp_col3": "Generic EAs",
    "comp_row1": "Respects daily drawdown cap",
    "comp_row2": "Blocks trade before SL breach",
    "comp_row3": "Auto-stops after profit target",
    "comp_row4": "No martingale / no grid",
    "comp_row5": "Built-in prop firm presets",
    "comp_row6": "Friday / weekend protection",
    "comp_row7": "Economic calendar news filter",
    "comp_row8": "Consistency monitor",
    "comp_row9": "Emotion-free execution 24/5",
    "comp_row10": "On-chart safety dashboard",
    "how_chip": "Deploy in 15 minutes",
    "how_h1_a": "From checkout to",
    "how_h1_b": "first trade.",
    "how_sub": "No coding. No Telegram groups. No hand-holding needed. The setup guide walks you through every click.",
    "how_cta": "Start now at {price}",
    "step_label": "STEP",
    "step1_t": "Instant download",
    "step1_d": "Pay once — you get the .ex5 file, setup PDF, and prop-firm preset pack immediately in your inbox.",
    "step2_t": "Attach to XAUUSD",
    "step2_d": "Drag onto a Gold chart in MetaTrader 5, choose your challenge preset (FTMO, MyFF, The5ers…) or go custom.",
    "step3_t": "The engine takes over",
    "step3_d": "Every entry runs through the risk guard first — if it can break your rule, it's blocked before it happens.",
    "step4_t": "Hit your target",
    "step4_d": "Auto-stops trading after you reach the profit target. Logs everything. You focus on getting funded.",
    "whofor_chip": "Honest fit check",
    "whofor_h1_a": "Read this",
    "whofor_h1_b": "before you buy.",
    "whofor_sub": "This EA is built for a specific kind of trader. If you're in the left column, you'll love it. If you're in the right — save your money and scroll away.",
    "whofor_for_title": "Built for you if…",
    "whofor_not_title": "Not for you if…",
    "for1": "Prop challenge takers (FTMO, MyFF, The5ers, FundedNext, etc.)",
    "for2": "Funded account holders protecting their capital",
    "for3": "XAUUSD / Gold traders who want disciplined automation",
    "for4": "Traders tired of revenge-trading their own accounts",
    "for5": "Part-time traders who can't watch charts 10 hours a day",
    "for6": "Anyone serious enough to run a VPS",
    "not1": "'Get rich quick' buyers expecting guaranteed profits",
    "not2": "Traders looking for martingale or grid recovery",
    "not3": "People who won't read the setup guide",
    "not4": "Traders who ignore prop firm rule PDFs",
    "not5": "Anyone expecting the EA to print money in 24 hours",
    "proof_chip": "Community",
    "proof_h1_a": "Traders who",
    "proof_h1_b": "stopped gambling.",
    "proof_sub": "Results depend on broker, settings and market conditions — but the playbook is the same: rules first, execution second.",
    "proof_disclaimer": "Disclaimer: Trading involves risk. No Expert Advisor can guarantee profit or guarantee passing any challenge. Past performance does not predict future results. Always test before using on a live or funded account.",
    "stat1_l": "Specialized symbol",
    "stat2_l": "Current Gold regime",
    "stat3_l": "Martingale / grid",
    "stat4_l": "One-time price",
    "test1_role": "Funded · Gold trader",
    "test1_txt": "Finally an EA that respects daily DD. Passed Phase 1 without a single red overtrading day.",
    "test2_role": "Evaluation",
    "test2_txt": "The dashboard alone is worth it. Target lock saved me from giving back a winning week.",
    "test3_role": "Prop challenger",
    "test3_txt": "No martingale, no grid — clean logic. Gold finally feels tradeable on auto-pilot.",
    "test4_role": "Part-time trader",
    "test4_txt": "Setup was 15 minutes on VPS. The spread and news filter keep me out of chop zones.",
    "bonus_chip": "Bundled free",
    "bonus_h1_a": "of bonuses — zero extra cost.",
    "bonus_sub": "Your {price} unlocks the EA plus everything below. Nothing upsold. Nothing gated. All instant-download.",
    "bonus_total": "Total real value",
    "bonus_save": "You save {amount} today",
    "bonus_free": "Free with EA",
    "bonus_worth": "Worth",
    "b1_t": "Setup guide PDF",
    "b1_d": "Broker-by-broker install walkthrough with screenshots.",
    "b2_t": "Prop-firm preset pack",
    "b2_d": "Pre-configured .set files for FTMO, MyFF, The5ers, FundedNext.",
    "b3_t": "XAUUSD rule cheatsheet",
    "b3_d": "One-page PDF with safe risk bands per challenge size.",
    "b4_t": "Lifetime updates",
    "b4_d": "Every future version shipped to you free — forever.",
    "pricing_chip": "Pricing",
    "pricing_h1_a": "One-time.",
    "pricing_h1_b": "No subscriptions.",
    "pricing_sub": "A fraction of one failed prop challenge fee. Pay once, own it for life.",
    "pricing_offer": "Launch offer · {n} copies left",
    "pricing_save": "Save {amount} · one-time",
    "pricing_cta": "Get instant access",
    "pricing_secure": "Secure checkout · Instant file delivery",
    "pricing_what_get": "What you get",
    "pricing_inc1": "Prop Passer Gold EA (.ex5 file for MT5)",
    "pricing_inc2": "Step-by-step setup guide (PDF)",
    "pricing_inc3": "Built-in prop firm presets + custom rules",
    "pricing_inc4": "Premium on-chart dashboard",
    "pricing_inc5": "Lifetime access — no subscription",
    "pricing_inc6": "Free updates as the market evolves",
    "pricing_inc7": "Priority WhatsApp support",
    "faq_chip": "Questions",
    "faq_h1_a": "The stuff",
    "faq_h1_b": "buyers actually ask.",
    "faq1_q": "Is this EA compatible with my prop firm?",
    "faq1_a": "Yes. The EA ships with built-in presets for common challenge styles (FTMO, MyForexFunds, The5ers, FundedNext and similar) and a custom rule mode where you set your own profit target, daily DD, max DD (static or trailing), symbol loss and consistency rules. Always verify against your provider's rule PDF before deploying.",
    "faq2_q": "Does it use martingale, grid or averaging?",
    "faq2_a": "No. Every trade has a hard stop loss and structure-based sizing. No averaging into losers, no grid recovery, no doubling down. Clean logic that evaluators prefer.",
    "faq3_q": "What accounts and brokers work?",
    "faq3_a": "Any reliable MT5 broker with realistic XAUUSD spreads and commissions. ECN / raw-spread brokers are recommended for tight execution. The EA is broker-agnostic — you keep full control of where you trade.",
    "faq4_q": "How is it delivered after purchase?",
    "faq4_a": "Instant download. After payment you receive the .ex5 EA file, the step-by-step setup guide (PDF), and the prop-firm preset pack via email within minutes. No manual onboarding, no waiting.",
    "faq5_q": "Do I need a VPS?",
    "faq5_a": "Recommended for 24/5 operation so the EA keeps running while you sleep. Any standard MT5-compatible VPS works. The setup guide covers VPS basics.",
    "faq6_q": "Is it a one-time payment?",
    "faq6_a": "Yes. One payment, lifetime license. No monthly fees, no hidden renewals, no per-account limits. Future updates are included free.",
    "faq7_q": "Will it guarantee I pass a challenge?",
    "faq7_a": "No — and anyone selling you that guarantee is lying. This EA is a rules-first execution tool that removes the most common behavioural mistakes that fail accounts. Results depend on broker, spread, slippage, your chosen settings, and market conditions.",
    "faq8_q": "Why so cheap when competitors charge {comp}?",
    "faq8_a": "This is a launch price for the first wave of buyers. The full price is {full}. Once the launch window closes, the price returns to regular. Early adopters get the same product — just at a fraction of the cost.",
    "final_chip": "Launch window · Only {n} copies left",
    "final_h1_a": "Stop failing",
    "final_h1_b": "prop challenges.",
    "final_h1_c": "Start trading inside the rules.",
    "final_sub": "One payment. Lifetime access. The same execution engine that passes evaluations — now running on your Gold chart, 24/5, without the emotional mistakes that drain accounts.",
    "final_save": "Save {amount} · 90% off launch",
    "final_cta": "Get instant access",
    "final_trust": "Secure checkout · Instant .ex5 file delivery · Lifetime license",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "A Gold-focused Expert Advisor for MetaTrader 5, engineered around prop challenge rules — drawdown caps, target lock, risk guards, and a premium dashboard.",
    "footer_product": "Product",
    "footer_contact": "Contact",
    "footer_setup": "Free setup help",
    "footer_download": "Download our app",
    "footer_sold_by": "Sold by {seller}",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. All rights reserved.",
    "footer_disclaimer": "Trading involves substantial risk. Past performance does not predict future results. No EA guarantees passing any challenge.",
    "locale_title": "Choose your language",
    "locale_sub": "We've detected your region. Pick your preferred language to continue. You can change this anytime from the menu.",
    "locale_continue_en": "Continue in English",
    "locale_continue_other": "Continue in {lang}",
    "lang_label": "Language",
    "currency_label": "Currency",
    "live_feed": "Live Feed"
  
,
    "seo_chip": "The complete guide",
    "seo_h1_a": "How to pass prop firm challenges with a",
    "seo_h1_b": "Gold EA",
    "seo_intro": "Most traders who sign up for an FTMO, MyForexFunds, The5ers or FundedNext evaluation don't fail because they pick the wrong direction. They fail because they break a rule — usually the daily drawdown rule, the maximum drawdown rule, or the consistency rule — after a single emotional trade. **Prop Passer Gold EA** is engineered around that exact problem. It is a XAUUSD-focused MetaTrader 5 Expert Advisor that turns prop firm rule compliance from a willpower problem into a software setting.",
    "seo_card1_t": "Why XAUUSD (Gold) for prop challenges?",
    "seo_card1_d": "Gold offers what prop traders need: high volatility, deep liquidity, 24-hour London / New York / Asian session activity, and structural patterns that reward rule-based execution. Most prop firms allow XAUUSD with reasonable swap and commission costs — ideal for evaluation accounts from $10K to $200K.",
    "seo_card2_t": "How the EA enforces prop firm rules",
    "seo_card2_d": "Every potential trade runs through a sequential gate-check before order submission. The risk-per-trade calculator sizes the position to fit inside your equity cap (default 0.5–1%). The daily DD guard projects worst-case loss and rejects the trade if it crosses the floor. Max DD guard does the same for static or trailing rules. Profit target lock stops opening new trades once your target is hit.",
    "seo_card3_t": "Prop firm presets included",
    "seo_card3_d": "The launch package ships with pre-configured .set files for FTMO (Phase 1, 2, Funded), MyForexFunds Rapid / Evaluation / Accelerated, The5ers Hyper Growth and Bootcamp, FundedNext Stellar / Express, and several instant-funding firms. Custom mode lets you configure rules manually against any new firm's rule PDF.",
    "seo_card4_t": "No martingale. No grid. No averaging.",
    "seo_card4_d": "Cheap EAs sold on Telegram hide martingale or grid recovery — they look profitable in backtests because they bury risk in account-blowing tail events. Prop firms detect them instantly and disqualify the account. Prop Passer Gold uses only structure-based entries with hard stop losses — the kind of clean logic prop firms openly support.",
    "seo_card5_t": "Who is this EA for?",
    "seo_card5_d": "Built for prop challenge takers, funded account holders protecting capital, and XAUUSD traders who want disciplined automation without watching the chart 10 hours a day. It is not a 'get rich quick' tool — it is a discipline-enforcement tool. If you're looking for guaranteed profits, this is not for you.",
    "seo_card6_t": "Setup and broker requirements",
    "seo_card6_d": "Runs on MetaTrader 5 only. Recommended on a VPS for 24/5 uptime. Any reliable ECN / raw-spread MT5 broker works — including the brokers used by FTMO, MyForexFunds, The5ers, FundedNext, FundingPips, Goat Funded Trader and similar firms. Launch price includes one-time payment, lifetime license, free updates, setup PDF, preset pack, and priority WhatsApp support.",
    "seo_quote": "Trading prop accounts is a numbers game played inside hard limits. Whoever respects the limits longest wins. Prop Passer Gold EA exists to make those limits structural, not emotional. That's the entire pitch.",
    "seo_quote_author": "— The Dhokiyas team"
  },
  "es": {
    "nav_features": "Características",
    "nav_dashboard": "Panel de control",
    "nav_comparison": "Comparar",
    "nav_pricing": "Precios",
    "nav_faq": "Preguntas frecuentes",
    "nav_get_access": "Obtener acceso",
    "ann_launch_offer": "Oferta de lanzamiento",
    "ann_save_today": "Ahorra {amount} hoy",
    "ann_left": "restantes",
    "ann_grab": "Consíguelo →",
    "hero_badge1": "Diseñado para Gold · régimen 2025+",
    "hero_badge2": "Listo para prop firms",
    "hero_badge_copies": "Solo quedan {n} copias",
    "hero_h1_a": "Supera los retos de prop firms.",
    "hero_h1_b": "Opera Gold",
    "hero_h1_c": "como una máquina disciplinada.",
    "hero_sub": "Prop Passer Gold EA es un robot de MetaTrader 5 enfocado en XAUUSD, diseñado en torno a las reglas de las prop firms: límites de drawdown, bloqueo de objetivo, protección de riesgo por operación y un panel de control premium en el gráfico. Sin martingale. Sin grid. Solo ejecución priorizando las reglas.",
    "hero_cta_primary": "Obtén acceso instantáneo",
    "hero_cta_secondary": "Ayuda de configuración gratuita por WhatsApp",
    "hero_save": "lanzamiento",
    "hero_pill1": "Enfocado en Gold",
    "hero_pill2": "DD protegido",
    "hero_pill3": "Pago único",
    "hero_card_buy": "Comprar por {price}",
    "hero_card_trust": "Entrega instantánea · Pago seguro · Licencia de por vida",
    "hero_card_sym": "Símbolo",
    "hero_card_plat": "Plataforma",
    "hero_card_strat": "Estrategia",
    "hero_card_prot": "Protección",
    "hero_card_strat_v": "Estructura + Volatilidad",
    "hero_card_prot_v": "Motor Prop",
    "hero_card_b1": "Protección de drawdown diario + DD máximo",
    "hero_card_b2": "Bloqueo de objetivo de ganancias al completarlo",
    "hero_card_b3": "Protección de viernes / fin de semana",
    "hero_card_b4": "Filtro de noticias del calendario económico",
    "problem_chip": "La realidad de las prop firms",
    "problem_h1_a": "9 de cada 10",
    "problem_h1_b": "traders fallan los retos. No por malas entradas.",
    "problem_sub": "Las prop firms no pagan por acertar. Pagan por estar dentro de las reglas cuando aciertas. Cada fallo a continuación es un problema de comportamiento, no un problema de mercado, y este EA fue diseñado para eliminar cada uno de ellos.",
    "problem_disclaimer": "* Tasas de fallo basadas en datos de evaluación de prop firms publicados.",
    "fail1_title": "Incumplir reglas de drawdown",
    "fail1_desc": "Una operación emocional después de una pérdida incumple el DD diario. Reto terminado, incluso si la cuenta estaba en ganancias una hora antes.",
    "fail2_title": "Devolver el objetivo",
    "fail2_desc": "Alcanzar el 8% de objetivo de ganancias, seguir operando 'por diversión', terminar la semana en 2%. El EA detiene automáticamente las nuevas operaciones después del objetivo.",
    "fail3_title": "Sobreoperar en sesiones débiles",
    "fail3_desc": "Gold se mueve lateralmente durante el rollover, la calma asiática y los momentos de alto spread. Los filtros de sesión + spread bloquean las entradas automáticamente.",
    "fail4_title": "Aumentar el tamaño tras pérdidas",
    "fail4_desc": "Duplicar el lote para 'recuperar' → pérdida mayor → DD máximo alcanzado. El límite de riesgo por operación hace esto matemáticamente imposible.",
    "features_chip": "Arquitectura centrada en el riesgo",
    "features_h1_a": "Diseñado para la",
    "features_h1_b": "realidad de los retos prop.",
    "features_sub": "Las firms no pagan por intuición. Pagan por disciplina dentro de límites estrictos. Cada módulo a continuación existe por una razón: mantener tu cuenta elegible el tiempo suficiente para que tu ventaja se desarrolle.",
    "feat1_title": "Motor de protección para retos prop",
    "feat1_desc": "Presets integrados + modo de reglas personalizadas. Rastrea la pérdida diaria, el drawdown máximo, la pérdida por símbolo y la consistencia, para que te mantengas dentro de los límites que permiten superar las evaluaciones.",
    "feat2_title": "Protección de drawdown diario y máximo",
    "feat2_desc": "Compatible con modelos DD estáticos y trailing. Calcula los límites de pérdida en tiempo real y bloquea nuevas operaciones que podrían incumplir la regla.",
    "feat3_title": "Bloqueo de objetivo de ganancias",
    "feat3_desc": "La mayoría de los traders devuelven las ganancias después de alcanzar el objetivo. El EA puede detener automáticamente las nuevas entradas una vez que se alcanza el objetivo, asegurando el progreso.",
    "feat4_title": "Protección de riesgo por operación",
    "feat4_desc": "Tamaño de lote fijo o basado en porcentaje con límites de lote min/max. Bloquea operaciones cuya distancia de SL arriesgaría más que tu límite.",
    "feat5_title": "Filtros de calidad de mercado",
    "feat5_desc": "Los filtros de volatilidad ATR, spread, sesión y noticias mantienen al EA fuera de condiciones tóxicas donde Gold tritura a los traders.",
    "feat6_title": "Protección de viernes y fin de semana",
    "feat6_desc": "Cierra automáticamente las posiciones antes del cierre del viernes y bloquea las entradas cerca de la ventana de riesgo del fin de semana, perfecto para las reglas de financiación instantánea.",
    "feat7_title": "Monitor de consistencia",
    "feat7_desc": "Rastrea la relación mejor día-total para que puedas cumplir las reglas de consistencia que algunas prop firms exigen. Sin operaciones de lotería de un solo día.",
    "feat8_title": "Sin martingale · sin grid",
    "feat8_desc": "Sin promediar en pérdidas. Cada operación tiene un stop loss estricto basado en la estructura del mercado, una lógica limpia que gusta a los evaluadores.",
    "feat9_title": "Panel de control premium en el gráfico",
    "feat9_desc": "Ve el modelo de reto, el DD restante, P/L de hoy, progreso del objetivo, spread, noticias y estado de la sesión de un vistazo, sin cálculos manuales.",
    "dashboard_chip": "Inteligencia premium en el gráfico",
    "dashboard_h1_a": "Cada regla —",
    "dashboard_h1_b": "visible en tiempo real.",
    "dashboard_sub": "La mayoría de los bots te dejan adivinando. Prop Passer Gold te muestra exactamente lo que importa: cuánto margen de drawdown te queda, cuán cerca estás del objetivo de ganancias y si el mercado es seguro para operar en este momento. Se acabaron los cálculos mentales. Se acabaron las sorpresas por incumplimiento de reglas.",
    "dash_b1": "Indicadores de drawdown diario / máximo en vivo",
    "dash_b2": "Progreso del objetivo de ganancias — detiene la operativa al alcanzarlo",
    "dash_b3": "Calculadora de riesgo por operación antes de cada entrada",
    "dash_b4": "Filtros de spread · noticias · sesión siempre activos",
    "dash_b5": "Puntuación de consistencia para prop firms estrictas",
    "dash_label1": "Panel de control principal del EA",
    "dash_label2": "Protección de Drawdown",
    "dash_label3": "Medidor de Riesgo",
    "dash_label4": "Curva de Equidad",
    "dash_label5": "Panel de reglas Prop",
    "comp_chip": "Comparativa",
    "comp_h1_a": "Por qué los traders siguen",
    "comp_h1_b": "perdiendo cuentas.",
    "comp_sub": "La diferencia entre financiado y fallido no son las entradas, es lo que sucede después de la entrada. Aquí es donde Prop Passer Gold gana.",
    "comp_yes": "Sí",
    "comp_no": "No",
    "comp_partial": "Parcial / depende",
    "comp_capability": "Capacidad",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "Operativa manual",
    "comp_col3": "EAs genéricos",
    "comp_row1": "Respeta el límite de drawdown diario",
    "comp_row2": "Bloquea la operación antes de incumplir el SL",
    "comp_row3": "Se detiene automáticamente después del objetivo de ganancias",
    "comp_row4": "Sin martingale / sin grid",
    "comp_row5": "Presets de prop firm integrados",
    "comp_row6": "Protección de viernes / fin de semana",
    "comp_row7": "Filtro de noticias del calendario económico",
    "comp_row8": "Monitor de consistencia",
    "comp_row9": "Ejecución sin emociones 24/5",
    "comp_row10": "Panel de seguridad en el gráfico",
    "how_chip": "Despliega en 15 minutos",
    "how_h1_a": "Desde la compra hasta",
    "how_h1_b": "la primera operación.",
    "how_sub": "Sin codificación. Sin grupos de Telegram. No necesita asistencia. La guía de configuración te acompaña en cada clic.",
    "how_cta": "Empieza ahora por {price}",
    "step_label": "PASO",
    "step1_t": "Descarga instantánea",
    "step1_d": "Paga una vez: recibes el archivo .ex5, el PDF de configuración y el paquete de presets para prop-firm inmediatamente en tu bandeja de entrada.",
    "step2_t": "Adjunta a XAUUSD",
    "step2_d": "Arrastra a un gráfico de Gold en MetaTrader 5, elige tu preset de reto (FTMO, MyFF, The5ers…) o personaliza.",
    "step3_t": "El motor toma el control",
    "step3_d": "Cada entrada pasa primero por la protección de riesgo; si puede romper tu regla, se bloquea antes de que ocurra.",
    "step4_t": "Alcanza tu objetivo",
    "step4_d": "Detiene automáticamente la operativa una vez que alcanzas el objetivo de ganancias. Registra todo. Tú te enfocas en obtener financiación.",
    "whofor_chip": "Verificación honesta",
    "whofor_h1_a": "Lee esto",
    "whofor_h1_b": "antes de comprar.",
    "whofor_sub": "Este EA está diseñado para un tipo de trader específico. Si estás en la columna izquierda, te encantará. Si estás en la derecha, ahorra tu dinero y pasa de largo.",
    "whofor_for_title": "Hecho para ti si…",
    "whofor_not_title": "No es para ti si…",
    "for1": "Participantes de retos prop (FTMO, MyFF, The5ers, FundedNext, etc.)",
    "for2": "Titulares de cuentas financiadas que protegen su capital",
    "for3": "Traders de XAUUSD / Gold que buscan automatización disciplinada",
    "for4": "Traders cansados de operar por venganza en sus propias cuentas",
    "for5": "Traders a tiempo parcial que no pueden vigilar los gráficos 10 horas al día",
    "for6": "Cualquiera lo suficientemente serio como para usar un VPS",
    "not1": "Compradores de 'hazte rico rápido' que esperan ganancias garantizadas",
    "not2": "Traders que buscan martingale o recuperación por grid",
    "not3": "Personas que no leerán la guía de configuración",
    "not4": "Traders que ignoran los PDF de reglas de prop firms",
    "not5": "Cualquiera que espere que el EA imprima dinero en 24 horas",
    "proof_chip": "Comunidad",
    "proof_h1_a": "Traders que",
    "proof_h1_b": "dejaron de apostar.",
    "proof_sub": "Los resultados dependen del bróker, la configuración y las condiciones del mercado, pero la estrategia es la misma: reglas primero, ejecución después.",
    "proof_disclaimer": "Descargo de responsabilidad: El trading implica riesgos. Ningún Expert Advisor puede garantizar ganancias ni garantizar superar ningún reto. El rendimiento pasado no predice resultados futuros. Siempre prueba antes de usar en una cuenta real o financiada.",
    "stat1_l": "Símbolo especializado",
    "stat2_l": "Régimen actual de Gold",
    "stat3_l": "Martingale / grid",
    "stat4_l": "Precio único",
    "test1_role": "Financiado · Trader de Gold",
    "test1_txt": "Por fin un EA que respeta el DD diario. Pasó la Fase 1 sin un solo día rojo de sobreoperación.",
    "test2_role": "Evaluación",
    "test2_txt": "Solo el panel de control ya vale la pena. El bloqueo de objetivo me salvó de devolver una semana ganadora.",
    "test3_role": "Participante de reto Prop",
    "test3_txt": "Sin martingale, sin grid — lógica limpia. Gold finalmente se siente operable en piloto automático.",
    "test4_role": "Trader a tiempo parcial",
    "test4_txt": "La configuración en VPS fue de 15 minutos. Los filtros de spread y noticias me mantienen fuera de zonas de lateralidad.",
    "bonus_chip": "Incluido gratis",
    "bonus_h1_a": "de bonos — coste cero extra.",
    "bonus_sub": "Tu {price} desbloquea el EA más todo lo que se muestra a continuación. Nada de ventas adicionales. Nada restringido. Todo descarga instantánea.",
    "bonus_total": "Valor real total",
    "bonus_save": "Ahorras {amount} hoy",
    "bonus_free": "Gratis con el EA",
    "bonus_worth": "Valorado en",
    "b1_t": "Guía de configuración PDF",
    "b1_d": "Instrucciones de instalación paso a paso, bróker por bróker, con capturas de pantalla.",
    "b2_t": "Paquete de presets para prop-firm",
    "b2_d": "Archivos .set preconfigurados para FTMO, MyFF, The5ers, FundedNext.",
    "b3_t": "Hoja de trucos de reglas para XAUUSD",
    "b3_d": "PDF de una página con rangos de riesgo seguros por tamaño de reto.",
    "b4_t": "Actualizaciones de por vida",
    "b4_d": "Cada versión futura te será enviada gratis, para siempre.",
    "pricing_chip": "Precios",
    "pricing_h1_a": "Pago único.",
    "pricing_h1_b": "Sin suscripciones.",
    "pricing_sub": "Una fracción del coste de un reto prop fallido. Paga una vez, poséelo de por vida.",
    "pricing_offer": "Oferta de lanzamiento · Quedan {n} copias",
    "pricing_save": "Ahorra {amount} · pago único",
    "pricing_cta": "Obtén acceso instantáneo",
    "pricing_secure": "Pago seguro · Entrega instantánea de archivos",
    "pricing_what_get": "Qué obtienes",
    "pricing_inc1": "Prop Passer Gold EA (archivo .ex5 para MT5)",
    "pricing_inc2": "Guía de configuración paso a paso (PDF)",
    "pricing_inc3": "Presets de prop firm integrados + reglas personalizadas",
    "pricing_inc4": "Panel de control premium en el gráfico",
    "pricing_inc5": "Acceso de por vida — sin suscripción",
    "pricing_inc6": "Actualizaciones gratuitas a medida que el mercado evoluciona",
    "pricing_inc7": "Soporte prioritario por WhatsApp",
    "faq_chip": "Preguntas",
    "faq_h1_a": "Lo que",
    "faq_h1_b": "los compradores realmente preguntan.",
    "faq1_q": "¿Es este EA compatible con mi prop firm?",
    "faq1_a": "Sí. El EA incluye presets integrados para estilos de retos comunes (FTMO, MyForexFunds, The5ers, FundedNext y similares) y un modo de reglas personalizadas donde puedes establecer tu propio objetivo de ganancias, DD diario, DD máximo (estático o trailing), pérdida por símbolo y reglas de consistencia. Siempre verifica con el PDF de reglas de tu proveedor antes de implementarlo.",
    "faq2_q": "¿Usa martingale, grid o promediado?",
    "faq2_a": "No. Cada operación tiene un stop loss estricto y un dimensionamiento basado en la estructura. Sin promediar en pérdidas, sin recuperación por grid, sin duplicar. Lógica limpia que los evaluadores prefieren.",
    "faq3_q": "¿Qué cuentas y brókers funcionan?",
    "faq3_a": "Cualquier bróker MT5 fiable con spreads y comisiones realistas para XAUUSD. Se recomiendan los brókers ECN / de spread crudo para una ejecución ajustada. El EA es agnóstico al bróker: mantienes el control total de dónde operas.",
    "faq4_q": "¿Cómo se entrega después de la compra?",
    "faq4_a": "Descarga instantánea. Después del pago, recibes el archivo .ex5 del EA, la guía de configuración paso a paso (PDF) y el paquete de presets para prop-firm por correo electrónico en cuestión de minutos. Sin procesos manuales, sin esperas.",
    "faq5_q": "¿Necesito un VPS?",
    "faq5_a": "Recomendado para operación 24/5 para que el EA siga funcionando mientras duermes. Cualquier VPS estándar compatible con MT5 funciona. La guía de configuración cubre los conceptos básicos de VPS.",
    "faq6_q": "¿Es un pago único?",
    "faq6_a": "Sí. Un pago, licencia de por vida. Sin tarifas mensuales, sin renovaciones ocultas, sin límites por cuenta. Las futuras actualizaciones están incluidas de forma gratuita.",
    "faq7_q": "¿Garantiza que superaré un reto?",
    "faq7_a": "No, y cualquiera que te venda esa garantía miente. Este EA es una herramienta de ejecución basada en reglas que elimina los errores de comportamiento más comunes que causan el fracaso de las cuentas. Los resultados dependen del bróker, el spread, el slippage, tu configuración elegida y las condiciones del mercado.",
    "faq8_q": "¿Por qué es tan barato cuando los competidores cobran {comp}?",
    "faq8_a": "Este es un precio de lanzamiento para la primera ola de compradores. El precio completo es {full}. Una vez que la ventana de lanzamiento se cierre, el precio volverá a ser el regular. Los primeros en adoptar obtienen el mismo producto, pero a una fracción del coste.",
    "final_chip": "Ventana de lanzamiento · Solo quedan {n} copias",
    "final_h1_a": "Deja de fallar",
    "final_h1_b": "retos prop.",
    "final_h1_c": "Empieza a operar dentro de las reglas.",
    "final_sub": "Un pago. Acceso de por vida. El mismo motor de ejecución que supera las evaluaciones, ahora funcionando en tu gráfico de Gold, 24/5, sin los errores emocionales que agotan las cuentas.",
    "final_save": "Ahorra {amount} · 90% de descuento por lanzamiento",
    "final_cta": "Obtén acceso instantáneo",
    "final_trust": "Pago seguro · Entrega instantánea del archivo .ex5 · Licencia de por vida",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "Un Expert Advisor enfocado en Gold para MetaTrader 5, diseñado en torno a las reglas de los retos prop — límites de drawdown, bloqueo de objetivo, protecciones de riesgo y un panel de control premium.",
    "footer_product": "Producto",
    "footer_contact": "Contacto",
    "footer_setup": "Ayuda de configuración gratuita",
    "footer_download": "Descarga nuestra aplicación",
    "footer_sold_by": "Vendido por {seller}",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. Todos los derechos reservados.",
    "footer_disclaimer": "El trading implica un riesgo sustancial. El rendimiento pasado no predice resultados futuros. Ningún EA garantiza superar ningún reto.",
    "locale_title": "Elige tu idioma",
    "locale_sub": "Hemos detectado tu región. Elige tu idioma preferido para continuar. Puedes cambiarlo en cualquier momento desde el menú.",
    "locale_continue_en": "Continuar en English",
    "locale_continue_other": "Continuar en {lang}",
    "lang_label": "Idioma",
    "currency_label": "Moneda",
    "live_feed": "Noticias en vivo"
  
,
    "seo_chip": "La guía completa",
    "seo_h1_a": "¿Cómo superar los desafíos de las firmas de fondeo con un",
    "seo_h1_b": "**Gold EA**",
    "seo_intro": "La mayoría de los traders que se registran para una evaluación de **FTMO**, **MyForexFunds**, **The5ers** o **FundedNext** no fallan por elegir la dirección equivocada. Fallan porque rompen una regla — normalmente la regla del **drawdown** diario, la regla del **drawdown** máximo, o la regla de consistencia — después de una sola operación emocional. **Prop Passer Gold EA** está diseñado para resolver ese problema exacto. Es un **Expert Advisor** de **MetaTrader 5** centrado en **XAUUSD** que convierte el cumplimiento de las reglas de las firmas de fondeo de un problema de fuerza de voluntad en una configuración de software.",
    "seo_card1_t": "¿Por qué **XAUUSD** (**Oro**) para los desafíos de fondeo?",
    "seo_card1_d": "El **Oro** ofrece lo que los traders de fondeo necesitan: alta volatilidad, liquidez profunda, actividad de sesión 24 horas Londres / Nueva York / Asia, y patrones estructurales que recompensan la ejecución basada en reglas. La mayoría de las firmas de fondeo permiten **XAUUSD** con costos de swap y comisión razonables — ideal para cuentas de evaluación de $10K a $200K.",
    "seo_card2_t": "Cómo el **EA** aplica las reglas de las firmas de fondeo",
    "seo_card2_d": "Cada operación potencial pasa por una verificación secuencial antes del envío de la orden. La calculadora de riesgo por operación dimensiona la posición para ajustarse a tu límite de capital (por defecto 0,5–1%). El guardián de **DD** diario proyecta la pérdida en el peor de los casos y rechaza la operación si supera el límite. El guardián de **DD** máximo hace lo mismo para reglas estáticas o de trailing. El bloqueo de objetivo de ganancias detiene la apertura de nuevas operaciones una vez alcanzado tu objetivo.",
    "seo_card3_t": "Presets de firmas de fondeo incluidos",
    "seo_card3_d": "El paquete de lanzamiento incluye archivos **.set** preconfigurados para **FTMO** (Fase 1, 2, Funded), **MyForexFunds** Rapid / Evaluation / Accelerated, **The5ers** Hyper Growth y Bootcamp, **FundedNext** Stellar / Express, y varias firmas de fondeo instantáneo. El modo personalizado te permite configurar las reglas manualmente frente al **PDF** de reglas de cualquier nueva firma.",
    "seo_card4_t": "Sin martingala. Sin cuadrícula. Sin promediado.",
    "seo_card4_d": "Los **EA** baratos vendidos en **Telegram** ocultan martingalas o recuperación por cuadrícula — parecen rentables en los backtests porque entierran el riesgo en eventos de cola que destruyen cuentas. Las firmas de fondeo los detectan al instante y descalifican la cuenta. **Prop Passer Gold** utiliza solo entradas basadas en estructura con **stop losses** ajustados — el tipo de lógica limpia que las firmas de fondeo apoyan abiertamente.",
    "seo_card5_t": "¿Para quién es este **EA**?",
    "seo_card5_d": "Diseñado para aquellos que toman desafíos de fondeo, titulares de cuentas fondeadas que protegen su capital, y traders de **XAUUSD** que desean automatización disciplinada sin vigilar el gráfico 10 horas al día. No es una herramienta para 'hacerse rico rápidamente' — es una herramienta de cumplimiento de disciplina. Si buscas ganancias garantizadas, esto no es para ti.",
    "seo_card6_t": "Requisitos de configuración y bróker",
    "seo_card6_d": "Funciona solo en **MetaTrader 5**. Recomendado en un **VPS** para un tiempo de actividad 24/5. Cualquier bróker **ECN** / de spreads crudos **MT5** fiable funciona — incluyendo los brókers utilizados por **FTMO**, **MyForexFunds**, **The5ers**, **FundedNext**, **FundingPips**, **Goat Funded Trader** y firmas similares. El precio de lanzamiento incluye pago único, licencia de por vida, actualizaciones gratuitas, **PDF** de configuración, paquete de presets y soporte prioritario por **WhatsApp**.",
    "seo_quote": "Operar cuentas de fondeo es un juego de números que se juega dentro de límites estrictos. Quien respeta los límites por más tiempo, gana. **Prop Passer Gold EA** existe para hacer que esos límites sean estructurales, no emocionales. Esa es toda la propuesta.",
    "seo_quote_author": "— El equipo de Dhokiyas"
  },
  "ru": {
    "nav_features": "Функции",
    "nav_dashboard": "Панель управления",
    "nav_comparison": "Сравнить",
    "nav_pricing": "Цены",
    "nav_faq": "Часто задаваемые вопросы",
    "nav_get_access": "Получить доступ",
    "ann_launch_offer": "Предложение к запуску",
    "ann_save_today": "Сэкономьте {amount} сегодня",
    "ann_left": "осталось",
    "ann_grab": "Забрать →",
    "hero_badge1": "Создан для Gold · Режим 2025+",
    "hero_badge2": "Готов к проп-фирмам",
    "hero_badge_copies": "Осталось всего {n} копий",
    "hero_h1_a": "Проходите проп-челленджи.",
    "hero_h1_b": "Торгуйте Gold",
    "hero_h1_c": "как дисциплинированная машина.",
    "hero_sub": "Prop Passer Gold EA — это робот для MetaTrader 5, ориентированный на XAUUSD, разработанный с учетом правил проп-фирм: ограничения просадки, фиксация цели, контроль риска на сделку и премиальная панель на графике. Без martingale. Без grid. Просто исполнение, ориентированное на правила.",
    "hero_cta_primary": "Получить мгновенный доступ",
    "hero_cta_secondary": "Бесплатная помощь с настройкой в WhatsApp",
    "hero_save": "старт",
    "hero_pill1": "Ориентирован на Gold",
    "hero_pill2": "DD под защитой",
    "hero_pill3": "Единовременная оплата",
    "hero_card_buy": "Купить за {price}",
    "hero_card_trust": "Мгновенная доставка · Безопасная оплата · Пожизненная лицензия",
    "hero_card_sym": "Символ",
    "hero_card_plat": "Платформа",
    "hero_card_strat": "Стратегия",
    "hero_card_prot": "Защита",
    "hero_card_strat_v": "Структура + Волатильность",
    "hero_card_prot_v": "Prop Engine",
    "hero_card_b1": "Дневная просадка + защита от максимальной DD",
    "hero_card_b2": "Фиксация цели прибыли после достижения",
    "hero_card_b3": "Защита в пятницу / выходные",
    "hero_card_b4": "Фильтр новостей экономического календаря",
    "problem_chip": "Реальность проп-фирм",
    "problem_h1_a": "9 из 10",
    "problem_h1_b": "трейдеров проваливают челленджи. Не из-за плохих входов.",
    "problem_sub": "Проп-фирмы не платят за то, что вы правы. Они платят за то, что вы соблюдаете правила, когда вы правы. Каждый сбой ниже — это проблема поведения, а не проблема рынка — и каждый из них был разработан этим EA для устранения.",
    "problem_disclaimer": "* Показатели неудач основаны на публично опубликованных данных оценки проп-фирм.",
    "fail1_title": "Нарушение правил просадки",
    "fail1_desc": "Одна эмоциональная сделка после убытка нарушает дневную DD. Челлендж завершен — даже если час назад счет был в плюсе.",
    "fail2_title": "Слив прибыли после достижения цели",
    "fail2_desc": "Достигли 8% цели прибыли, продолжаете торговать «ради забавы», заканчиваете неделю на 2%. EA автоматически останавливает новые сделки после достижения цели.",
    "fail3_title": "Переторговка в слабые сессии",
    "fail3_desc": "Gold колеблется во время ролловера, азиатского затишья и периодов высокого спреда. Фильтры сессий и спреда автоматически блокируют входы.",
    "fail4_title": "Увеличение объема после убытков",
    "fail4_desc": "Удвоение лота, чтобы «отыграться» → больший убыток → достижение максимальной DD. Ограничение риска на сделку делает это математически невозможным.",
    "features_chip": "Архитектура с приоритетом риска",
    "features_h1_a": "Разработано для",
    "features_h1_b": "реальности проп-челленджей.",
    "features_sub": "Фирмы не платят за интуицию. Они платят за дисциплину в жестких рамках. Каждый модуль ниже существует по одной причине: поддерживать соответствие вашего счета достаточно долго, чтобы ваше преимущество могло проявиться.",
    "feat1_title": "Движок защиты проп-челленджей",
    "feat1_desc": "Встроенные пресеты + режим пользовательских правил. Отслеживает дневные потери, максимальную drawdown, потери по символу и стабильность — чтобы вы оставались в рамках, позволяющих проходить оценки.",
    "feat2_title": "Защита от дневной и максимальной просадки",
    "feat2_desc": "Поддерживает как статическую, так и трейлинговую DD модели. Рассчитывает уровни потерь в реальном времени и блокирует новые сделки, которые могут нарушить правило.",
    "feat3_title": "Блокировка цели прибыли",
    "feat3_desc": "Большинство трейдеров возвращают прибыль после достижения цели. EA может автоматически останавливать новые входы после достижения цели — фиксируя прогресс.",
    "feat4_title": "Защита риска на сделку",
    "feat4_desc": "Размер лота на основе процента или фиксированного значения с ограничениями мин/макс лота. Блокирует сделки, чье расстояние SL будет рисковать больше, чем ваш лимит.",
    "feat5_title": "Фильтры качества рынка",
    "feat5_desc": "Фильтры волатильности ATR, спреда, сессий и новостей удерживают EA от токсичных условий, в которых Gold «пилит» трейдеров.",
    "feat6_title": "Защита в пятницу и выходные",
    "feat6_desc": "Автоматически закрывает позиции до окончания пятницы и блокирует входы вблизи окна риска выходных — идеально подходит для правил мгновенного финансирования.",
    "feat7_title": "Монитор стабильности",
    "feat7_desc": "Отслеживает соотношение лучшего дня к общей сумме, чтобы вы могли соответствовать правилам стабильности, которые применяют некоторые проп-фирмы. Никаких «лотерейных» сделок одного дня.",
    "feat8_title": "Без martingale · без grid",
    "feat8_desc": "Без усреднения убыточных позиций. Каждая сделка имеет жесткий stop loss, основанный на рыночной структуре — чистая логика, которая нравится оценщикам.",
    "feat9_title": "Премиальная панель на графике",
    "feat9_desc": "Мгновенно просматривайте модель челленджа, оставшуюся DD, сегодняшнюю P/L, прогресс цели, спред, новости и статус сессии — без ручных расчетов.",
    "dashboard_chip": "Премиальный интеллект на графике",
    "dashboard_h1_a": "Каждое правило —",
    "dashboard_h1_b": "видно в реальном времени.",
    "dashboard_sub": "Большинство ботов заставляют вас гадать. Prop Passer Gold показывает вам именно то, что важно: сколько места для drawdown у вас осталось, насколько вы близки к цели прибыли и безопасно ли вообще торговать на рынке прямо сейчас. Больше никаких расчетов в уме. Больше никаких сюрпризов из-за нарушения правил.",
    "dash_b1": "Показатели дневной / максимальной drawdown в реальном времени",
    "dash_b2": "Прогресс к цели прибыли — остановка торговли при достижении",
    "dash_b3": "Калькулятор риска на сделку перед каждым входом",
    "dash_b4": "Фильтры спреда · новостей · сессий всегда включены",
    "dash_b5": "Показатель стабильности для строгих проп-фирм",
    "dash_label1": "Главная панель EA",
    "dash_label2": "Защита от просадки",
    "dash_label3": "Измеритель риска",
    "dash_label4": "Кривая доходности",
    "dash_label5": "Панель правил проп-фирм",
    "comp_chip": "Сравнение",
    "comp_h1_a": "Почему трейдеры продолжают",
    "comp_h1_b": "терять счета.",
    "comp_sub": "Разница между успешным и проваленным счетом не во входах, а в том, что происходит после входа. Вот где Prop Passer Gold побеждает.",
    "comp_yes": "Да",
    "comp_no": "Нет",
    "comp_partial": "Частично / зависит",
    "comp_capability": "Возможность",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "Ручная торговля",
    "comp_col3": "Обычные EAs",
    "comp_row1": "Соблюдает лимит дневной drawdown",
    "comp_row2": "Блокирует сделку до пробития SL",
    "comp_row3": "Автоматически останавливается после цели прибыли",
    "comp_row4": "Без martingale / без grid",
    "comp_row5": "Встроенные пресеты проп-фирм",
    "comp_row6": "Защита в пятницу / выходные",
    "comp_row7": "Фильтр новостей экономического календаря",
    "comp_row8": "Монитор стабильности",
    "comp_row9": "Исполнение без эмоций 24/5",
    "comp_row10": "Панель безопасности на графике",
    "how_chip": "Разверните за 15 минут",
    "how_h1_a": "От покупки до",
    "how_h1_b": "первой сделки.",
    "how_sub": "Без кодирования. Без групп Telegram. Без необходимости в ручной помощи. Руководство по настройке проведет вас через каждый шаг.",
    "how_cta": "Начать сейчас за {price}",
    "step_label": "ШАГ",
    "step1_t": "Мгновенная загрузка",
    "step1_d": "Оплатите один раз — вы сразу получите файл .ex5, PDF-руководство по настройке и набор пресетов для проп-фирм на вашу электронную почту.",
    "step2_t": "Прикрепить к XAUUSD",
    "step2_d": "Перетащите на график Gold в MetaTrader 5, выберите свой пресет для челленджа (FTMO, MyFF, The5ers…) или настройте вручную.",
    "step3_t": "Движок берет управление",
    "step3_d": "Каждый вход сначала проходит через защиту риска — если он может нарушить ваше правило, он блокируется до того, как произойдет.",
    "step4_t": "Достигните своей цели",
    "step4_d": "Автоматически останавливает торговлю после достижения цели прибыли. Записывает всё. Вы сосредоточитесь на получении финансирования.",
    "whofor_chip": "Честная проверка соответствия",
    "whofor_h1_a": "Прочтите это",
    "whofor_h1_b": "прежде чем купить.",
    "whofor_sub": "Этот EA создан для определенного типа трейдеров. Если вы в левой колонке, вам понравится. Если в правой — сэкономьте свои деньги и прокрутите дальше.",
    "whofor_for_title": "Создано для вас, если…",
    "whofor_not_title": "Не для вас, если…",
    "for1": "Участники проп-челленджей (FTMO, MyFF, The5ers, FundedNext и т.д.)",
    "for2": "Владельцы финансируемых счетов, защищающие свой капитал",
    "for3": "Трейдеры XAUUSD / Gold, желающие дисциплинированной автоматизации",
    "for4": "Трейдеры, уставшие от мести рынку на своих счетах",
    "for5": "Трейдеры на полставки, которые не могут следить за графиками по 10 часов в день",
    "for6": "Любой, кто достаточно серьезен, чтобы использовать VPS",
    "not1": "Покупатели, которые хотят 'быстро разбогатеть' и ожидают гарантированной прибыли",
    "not2": "Трейдеры, ищущие martingale или grid восстановления",
    "not3": "Люди, которые не будут читать руководство по настройке",
    "not4": "Трейдеры, игнорирующие PDF-файлы правил проп-фирм",
    "not5": "Любой, кто ожидает, что EA будет печатать деньги за 24 часа",
    "proof_chip": "Сообщество",
    "proof_h1_a": "Трейдеры, которые",
    "proof_h1_b": "перестали играть.",
    "proof_sub": "Результаты зависят от брокера, настроек и рыночных условий — но стратегия та же: сначала правила, потом исполнение.",
    "proof_disclaimer": "Отказ от ответственности: Торговля связана с риском. Ни один Expert Advisor не может гарантировать прибыль или прохождение какого-либо челленджа. Прошлые результаты не предсказывают будущих. Всегда тестируйте перед использованием на реальном или финансируемом счете.",
    "stat1_l": "Специализированный символ",
    "stat2_l": "Текущий режим Gold",
    "stat3_l": "Martingale / grid",
    "stat4_l": "Единовременная цена",
    "test1_role": "Финансируемый · Gold трейдер",
    "test1_txt": "Наконец-то EA, который соблюдает дневную DD. Прошел Фазу 1 без единого дня переторговки в минус.",
    "test2_role": "Оценка",
    "test2_txt": "Одна только панель стоит того. Блокировка цели спасла меня от слива прибыли после успешной недели.",
    "test3_role": "Участник проп-челленджа",
    "test3_txt": "Без martingale, без grid — чистая логика. Gold наконец-то ощущается торгуемым на автопилоте.",
    "test4_role": "Трейдер на полставки",
    "test4_txt": "Настройка заняла 15 минут на VPS. Фильтры спреда и новостей удерживают меня от зон флета.",
    "bonus_chip": "В комплекте бесплатно",
    "bonus_h1_a": "бонусов — без дополнительных затрат.",
    "bonus_sub": "Ваша {price} открывает доступ к EA и всему, что ниже. Без дополнительных продаж. Без ограничений. Все доступно для мгновенной загрузки.",
    "bonus_total": "Общая реальная стоимость",
    "bonus_save": "Вы экономите {amount} сегодня",
    "bonus_free": "Бесплатно с EA",
    "bonus_worth": "Стоимость",
    "b1_t": "Руководство по настройке (PDF)",
    "b1_d": "Пошаговая инструкция по установке для каждого брокера со скриншотами.",
    "b2_t": "Набор пресетов для проп-фирм",
    "b2_d": "Предварительно настроенные файлы .set для FTMO, MyFF, The5ers, FundedNext.",
    "b3_t": "Шпаргалка по правилам XAUUSD",
    "b3_d": "Одностраничный PDF-файл с безопасными диапазонами риска для каждого размера челленджа.",
    "b4_t": "Пожизненные обновления",
    "b4_d": "Каждая будущая версия будет отправлена вам бесплатно — навсегда.",
    "pricing_chip": "Цены",
    "pricing_h1_a": "Единоразово.",
    "pricing_h1_b": "Без подписок.",
    "pricing_sub": "Это лишь малая часть стоимости одного проваленного проп-челленджа. Заплатите один раз, владейте пожизненно.",
    "pricing_offer": "Предложение к запуску · Осталось {n} копий",
    "pricing_save": "Сэкономьте {amount} · единоразово",
    "pricing_cta": "Получить мгновенный доступ",
    "pricing_secure": "Безопасная оплата · Мгновенная доставка файлов",
    "pricing_what_get": "Что вы получаете",
    "pricing_inc1": "Prop Passer Gold EA (файл .ex5 для MT5)",
    "pricing_inc2": "Пошаговое руководство по настройке (PDF)",
    "pricing_inc3": "Встроенные пресеты проп-фирм + пользовательские правила",
    "pricing_inc4": "Премиальная панель на графике",
    "pricing_inc5": "Пожизненный доступ — без подписки",
    "pricing_inc6": "Бесплатные обновления по мере развития рынка",
    "pricing_inc7": "Приоритетная поддержка в WhatsApp",
    "faq_chip": "Вопросы",
    "faq_h1_a": "То, о чем",
    "faq_h1_b": "на самом деле спрашивают покупатели.",
    "faq1_q": "Совместим ли этот EA с моей проп-фирмой?",
    "faq1_a": "Да. EA поставляется со встроенными пресетами для распространенных стилей челленджей (FTMO, MyForexFunds, The5ers, FundedNext и аналогичных), а также с пользовательским режимом правил, где вы устанавливаете свои собственные цели по прибыли, дневной DD, максимальной DD (статической или трейлинговой), убыткам по символу и правилам стабильности. Всегда сверяйтесь с PDF-файлом правил вашего провайдера перед развертыванием.",
    "faq2_q": "Использует ли он martingale, grid или усреднение?",
    "faq2_a": "Нет. Каждая сделка имеет жесткий stop loss и расчет размера на основе структуры рынка. Без усреднения убыточных позиций, без grid восстановления, без удвоения. Чистая логика, которую предпочитают оценщики.",
    "faq3_q": "Какие счета и брокеры подходят?",
    "faq3_a": "Любой надежный MT5 брокер с реалистичными XAUUSD спредами и комиссиями. Для точного исполнения рекомендуются ECN / raw-spread брокеры. EA не зависит от брокера — вы сохраняете полный контроль над тем, где вы торгуете.",
    "faq4_q": "Как он доставляется после покупки?",
    "faq4_a": "Мгновенная загрузка. После оплаты вы получите файл EA .ex5, пошаговое руководство по настройке (PDF) и набор пресетов для проп-фирм по электронной почте в течение нескольких минут. Без ручной настройки, без ожидания.",
    "faq5_q": "Нужен ли мне VPS?",
    "faq5_a": "Рекомендуется для работы 24/5, чтобы EA продолжал работать, пока вы спите. Подойдет любой стандартный MT5-совместимый VPS. Руководство по настройке охватывает основы VPS.",
    "faq6_q": "Это единовременная оплата?",
    "faq6_a": "Да. Один платеж, пожизненная лицензия. Без ежемесячных платежей, без скрытых продлений, без ограничений по количеству счетов. Будущие обновления включены бесплатно.",
    "faq7_q": "Гарантирует ли он прохождение челленджа?",
    "faq7_a": "Нет — и любой, кто продает вам такую гарантию, лжет. Этот EA является инструментом исполнения, ориентированным на правила, который устраняет наиболее распространенные поведенческие ошибки, приводящие к провалу счетов. Результаты зависят от брокера, спреда, slippage, выбранных вами настроек и рыночных условий.",
    "faq8_q": "Почему так дешево, когда конкуренты берут {comp}?",
    "faq8_a": "Это стартовая цена для первой волны покупателей. Полная цена — {full}. После закрытия окна запуска цена вернется к обычной. Ранние пользователи получают тот же продукт — но за часть стоимости.",
    "final_chip": "Окно запуска · Осталось всего {n} копий",
    "final_h1_a": "Прекратите проваливать",
    "final_h1_b": "проп-челленджи.",
    "final_h1_c": "Начните торговать по правилам.",
    "final_sub": "Один платеж. Пожизненный доступ. Тот же движок исполнения, который проходит оценки — теперь работает на вашем графике Gold, 24/5, без эмоциональных ошибок, которые истощают счета.",
    "final_save": "Сэкономьте {amount} · 90% скидка на запуск",
    "final_cta": "Получить мгновенный доступ",
    "final_trust": "Безопасная оплата · Мгновенная доставка файла .ex5 · Пожизненная лицензия",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "Экспертный советник для MetaTrader 5, ориентированный на Gold, разработанный с учетом правил проп-челленджей — ограничения просадки, фиксация цели, контроль риска и премиальная панель.",
    "footer_product": "Продукт",
    "footer_contact": "Контакты",
    "footer_setup": "Бесплатная помощь с настройкой",
    "footer_download": "Скачать наше приложение",
    "footer_sold_by": "Продавец: {seller}",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. Все права защищены.",
    "footer_disclaimer": "Торговля связана со значительным риском. Прошлые результаты не предсказывают будущих. Ни один EA не гарантирует прохождение какого-либо челленджа.",
    "locale_title": "Выберите ваш язык",
    "locale_sub": "Мы определили ваш регион. Выберите предпочитаемый язык для продолжения. Вы можете изменить его в любое время из меню.",
    "locale_continue_en": "Продолжить на английском",
    "locale_continue_other": "Продолжить на {lang}",
    "lang_label": "Язык",
    "currency_label": "Валюта",
    "live_feed": "Лента в реальном времени"
  
,
    "seo_chip": "Полное руководство",
    "seo_h1_a": "Как пройти испытания проп-фирм с помощью",
    "seo_h1_b": "Золотого советника",
    "seo_intro": "Большинство трейдеров, проходящих оценки в FTMO, MyForexFunds, The5ers или FundedNext, терпят неудачу не потому, что выбирают неверное направление. Они терпят неудачу, потому что нарушают правило — обычно правило дневной просадки, правило максимальной просадки или правило последовательности — после одной эмоциональной сделки. **Prop Passer Gold EA** разработан именно для решения этой проблемы. Это ориентированный на XAUUSD советник для MetaTrader 5, который превращает соблюдение правил проп-фирм из проблемы силы воли в настройку программного обеспечения.",
    "seo_card1_t": "Почему XAUUSD (золото) для проп-испытаний?",
    "seo_card1_d": "Золото предлагает то, что нужно проп-трейдерам: высокую волатильность, глубокую ликвидность, 24-часовую активность в Лондонской / Нью-Йоркской / Азиатской сессиях и структурные паттерны, которые вознаграждают за исполнение, основанное на правилах. Большинство проп-фирм допускают XAUUSD с разумными затратами на свопы и комиссии — идеально для оценочных счетов от $10K до $200K.",
    "seo_card2_t": "Как советник обеспечивает соблюдение правил проп-фирм",
    "seo_card2_d": "Каждая потенциальная сделка проходит последовательную проверку перед отправкой ордера. Калькулятор риска на сделку определяет размер позиции, чтобы она соответствовала вашему лимиту капитала (по умолчанию 0.5–1%). Защита дневного DD прогнозирует наихудший убыток и отклоняет сделку, если он превышает допустимый уровень. Защита максимального DD делает то же самое для статических или плавающих правил. Блокировка целевой прибыли прекращает открытие новых сделок после достижения вашей цели.",
    "seo_card3_t": "Включены пресеты для проп-фирм",
    "seo_card3_d": "Стартовый пакет поставляется с преднастроенными .set-файлами для FTMO (Фаза 1, 2, Funded), MyForexFunds Rapid / Evaluation / Accelerated, The5ers Hyper Growth и Bootcamp, FundedNext Stellar / Express, а также для нескольких фирм с мгновенным финансированием. Пользовательский режим позволяет настраивать правила вручную для правил любой новой фирмы из её PDF.",
    "seo_card4_t": "Без мартингейла. Без сетки. Без усреднения.",
    "seo_card4_d": "Дешевые советники, продаваемые в Telegram, скрывают мартингейл или восстановление по сетке — они выглядят прибыльными в бэктестах, потому что зарывают риск в критические для счета события. Проп-фирмы мгновенно их обнаруживают и дисквалифицируют счет. Prop Passer Gold использует только структурные входы с жесткими стоп-лоссами — чистую логику, которую проп-фирмы открыто поддерживают.",
    "seo_card5_t": "Для кого этот советник?",
    "seo_card5_d": "Создан для тех, кто принимает вызовы проп-фирм, владельцев финансируемых счетов, защищающих капитал, и XAUUSD-трейдеров, желающих дисциплинированной автоматизации без необходимости смотреть на график 10 часов в день. Это не инструмент для «быстрого обогащения» — это инструмент для обеспечения дисциплины. Если вы ищете гарантированную прибыль, то это не для вас.",
    "seo_card6_t": "Требования к установке и брокеру",
    "seo_card6_d": "Работает только на MetaTrader 5. Рекомендуется использовать на VPS для круглосуточной работы (24/5). Подойдет любой надежный ECN / raw-spread MT5 брокер — включая брокеров, используемых FTMO, MyForexFunds, The5ers, FundedNext, FundingPips, Goat Funded Trader и аналогичными фирмами. Цена запуска включает единоразовый платеж, пожизненную лицензию, бесплатные обновления, PDF-руководство по настройке, пакет пресетов и приоритетную поддержку в WhatsApp.",
    "seo_quote": "Торговля на проп-счетах — это игра чисел, ограниченная жесткими рамками. Побеждает тот, кто дольше всех соблюдает эти ограничения. Prop Passer Gold EA существует, чтобы сделать эти ограничения структурными, а не эмоциональными. В этом вся суть.",
    "seo_quote_author": "— Команда The Dhokiyas"
  },
  "zh": {
    "nav_features": "功能特色",
    "nav_dashboard": "仪表盘",
    "nav_comparison": "对比",
    "nav_pricing": "定价",
    "nav_faq": "常见问题",
    "nav_get_access": "立即获取",
    "ann_launch_offer": "上线特惠",
    "ann_save_today": "今日立省 {amount}",
    "ann_left": "剩余",
    "ann_grab": "立即抢购 →",
    "hero_badge1": "专为 Gold 打造 · 2025+ 交易环境",
    "hero_badge2": "适应资管公司规则",
    "hero_badge_copies": "仅剩 {n} 份",
    "hero_h1_a": "通过资管公司挑战。",
    "hero_h1_b": "像一台严谨的机器",
    "hero_h1_c": "交易 Gold。",
    "hero_sub": "Prop Passer Gold EA 是一款专注于 XAUUSD 的 MetaTrader 5 智能交易系统，专为资管公司规则设计——包含回撤限制、目标锁定、每笔交易风险控制以及高级图表仪表盘。没有 martingale，没有 grid。只有规则至上的执行力。",
    "hero_cta_primary": "立即获取",
    "hero_cta_secondary": "通过 WhatsApp 免费获取设置帮助",
    "hero_save": "首发",
    "hero_pill1": "专注 Gold",
    "hero_pill2": "DD 保护",
    "hero_pill3": "一次性支付",
    "hero_card_buy": "购买价格 {price}",
    "hero_card_trust": "即时交付 · 安全支付 · 终身授权",
    "hero_card_sym": "交易品种",
    "hero_card_plat": "平台",
    "hero_card_strat": "策略",
    "hero_card_prot": "保护机制",
    "hero_card_strat_v": "结构 + 波动性",
    "hero_card_prot_v": "资管引擎",
    "hero_card_b1": "每日回撤 + 最大 DD 保护",
    "hero_card_b2": "达成目标后锁定利润",
    "hero_card_b3": "周五 / 周末保护",
    "hero_card_b4": "财经日历新闻过滤",
    "problem_chip": "资管公司的真实挑战",
    "problem_h1_a": "十有八九的",
    "problem_h1_b": "交易者挑战失败。并非因为入场糟糕。",
    "problem_sub": "资管公司不为您的正确判断买单。他们只在您正确判断且遵守规则时支付。以下每一个失败案例都源于行为问题，而非市场问题——而这款 EA 的设计宗旨，就是为了解决这些问题。",
    "problem_disclaimer": "* 失败率基于公开报道的资管公司评估数据计算。",
    "fail1_title": "突破回撤规则",
    "fail1_desc": "一次亏损后的情绪化交易导致触及每日 DD。挑战失败——即使账户在一小时前仍处于盈利状态。",
    "fail2_title": "回吐目标利润",
    "fail2_desc": "达到 8% 盈利目标后，继续“娱乐性”交易，结果周末账户只剩 2%。本 EA 在达到目标后自动停止新交易。",
    "fail3_title": "在弱势时段过度交易",
    "fail3_desc": "Gold 在换仓期、亚洲清淡时段以及高点差窗口期间波动剧烈。交易时段 + 点差过滤器自动阻止入场。",
    "fail4_title": "亏损后报复性加仓",
    "fail4_desc": "双倍仓位“扳回一城” → 亏损更大 → 触及最大 DD。每笔交易风险限制使其在数学上不可能发生。",
    "features_chip": "风险至上架构",
    "features_h1_a": "专为",
    "features_h1_b": "资管挑战的现实而设计。",
    "features_sub": "公司不为直觉买单。他们为严格限制内的纪律买单。以下每个模块的存在都有一个原因：让您的账户在足够长的时间内保持资格，从而让您的优势得以发挥。",
    "feat1_title": "资管挑战保护引擎",
    "feat1_desc": "内置预设 + 自定义规则模式。追踪每日亏损、最大 drawdown、交易品种亏损和一致性——确保您在通过评估的保护范围内。",
    "feat2_title": "每日和最大 drawdown 保护",
    "feat2_desc": "支持固定和追踪 DD 模型。实时计算亏损下限，并阻止可能违反规则的新交易。",
    "feat3_title": "盈利目标锁定",
    "feat3_desc": "大多数交易者在达到目标后会回吐利润。EA 可以在达到目标后自动停止新入场——锁定盈利进度。",
    "feat4_title": "每笔交易风险保护",
    "feat4_desc": "基于百分比或固定手数的仓位大小，并设置最小/最大手数限制。阻止 SL 距离会使风险超过您上限的交易。",
    "feat5_title": "市场质量过滤器",
    "feat5_desc": "ATR 波动性、点差、交易时段和新闻过滤器使 EA 避免在 Gold 震荡交易者的不利条件下进行交易。",
    "feat6_title": "周五和周末保护",
    "feat6_desc": "在周五截止时间前自动平仓，并阻止在周末风险窗口附近入场——非常适合即时注资规则。",
    "feat7_title": "一致性监控器",
    "feat7_desc": "追踪最佳单日收益与总收益的比例，帮助您满足某些资管公司强制执行的一致性规则。杜绝单日暴富的投机交易。",
    "feat8_title": "无 martingale · 无 grid",
    "feat8_desc": "不会对亏损头寸进行均摊。每笔交易都有基于市场结构的硬 SL——评估员青睐的清晰逻辑。",
    "feat9_title": "高级图表仪表盘",
    "feat9_desc": "一目了然地查看挑战模型、剩余 DD、今日 P/L、目标进度、点差、新闻和交易时段状态——无需手动计算。",
    "dashboard_chip": "高级图表智能",
    "dashboard_h1_a": "每条规则——",
    "dashboard_h1_b": "实时可见。",
    "dashboard_sub": "大多数机器人让您猜测。Prop Passer Gold 向您精确展示最重要的信息：您还有多少 drawdown 空间，距离盈利目标还有多近，以及市场现在是否安全可交易。不再需要心算。不再有违反规则的意外。",
    "dash_b1": "实时每日 / 最大 drawdown 指示器",
    "dash_b2": "盈利目标进度——达到即停止交易",
    "dash_b3": "每次入场前的每笔交易风险计算器",
    "dash_b4": "点差 · 新闻 · 交易时段过滤器始终开启",
    "dash_b5": "针对严格资管公司的一致性评分",
    "dash_label1": "主 EA 仪表盘",
    "dash_label2": "Drawdown 保护",
    "dash_label3": "风险计量表",
    "dash_label4": "净值曲线",
    "dash_label5": "资管规则面板",
    "comp_chip": "并排对比",
    "comp_h1_a": "交易者为何",
    "comp_h1_b": "持续亏损账户。",
    "comp_sub": "获得注资和挑战失败的区别不在于入场点——而在于入场后发生的事情。这就是 Prop Passer Gold 的优势所在。",
    "comp_yes": "是",
    "comp_no": "否",
    "comp_partial": "部分 / 视情况而定",
    "comp_capability": "功能",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "手动交易",
    "comp_col3": "通用 EAs",
    "comp_row1": "遵守每日 drawdown 上限",
    "comp_row2": "在 SL 突破前阻止交易",
    "comp_row3": "达到盈利目标后自动停止",
    "comp_row4": "无 martingale / 无 grid",
    "comp_row5": "内置资管公司预设",
    "comp_row6": "周五 / 周末保护",
    "comp_row7": "财经日历新闻过滤",
    "comp_row8": "一致性监控",
    "comp_row9": "24/5 无情绪执行",
    "comp_row10": "图表安全仪表盘",
    "how_chip": "15 分钟内完成部署",
    "how_h1_a": "从购买到",
    "how_h1_b": "首次交易。",
    "how_sub": "无需编码。无需 Telegram 群组。无需手把手指导。设置指南将引导您完成每一个步骤。",
    "how_cta": "现在以 {price} 价格开始",
    "step_label": "步骤",
    "step1_t": "即时下载",
    "step1_d": "一次性支付——您将立即在收件箱中收到 .ex5 文件、设置 PDF 和资管公司预设包。",
    "step2_t": "绑定到 XAUUSD",
    "step2_d": "拖放到 MetaTrader 5 的 Gold 图表上，选择您的挑战预设 (FTMO, MyFF, The5ers…) 或自定义设置。",
    "step3_t": "引擎接管",
    "step3_d": "每个入场都会首先通过风险防护——如果可能违反您的规则，它会在发生前被阻止。",
    "step4_t": "达到您的目标",
    "step4_d": "达到盈利目标后自动停止交易。记录一切。您只需专注于获得注资。",
    "whofor_chip": "坦诚的适用性检查",
    "whofor_h1_a": "购买前请",
    "whofor_h1_b": "务必阅读。",
    "whofor_sub": "此 EA 专为特定类型的交易者而设计。如果您属于左栏人群，您会爱上它。如果您属于右栏人群——请省下您的钱，并划走。",
    "whofor_for_title": "适合您，如果…",
    "whofor_not_title": "不适合您，如果…",
    "for1": "资管挑战参与者 (FTMO, MyFF, The5ers, FundedNext 等)",
    "for2": "已获得注资并保护其资本的账户持有者",
    "for3": "寻求纪律性自动化的 XAUUSD / Gold 交易者",
    "for4": "厌倦了报复性交易自己账户的交易者",
    "for5": "无法每天盯盘 10 小时的兼职交易者",
    "for6": "认真对待交易并愿意使用 VPS 的人",
    "not1": "期望“快速致富”并保证盈利的买家",
    "not2": "寻求 martingale 或 grid 恢复的交易者",
    "not3": "不阅读设置指南的人",
    "not4": "忽视资管公司规则 PDF 的交易者",
    "not5": "期望 EA 在 24 小时内印钞的人",
    "proof_chip": "社区",
    "proof_h1_a": "那些",
    "proof_h1_b": "不再赌博的交易者。",
    "proof_sub": "结果取决于经纪商、设置和市场条件——但策略是相同的：规则优先，执行次之。",
    "proof_disclaimer": "免责声明：交易涉及风险。任何 Expert Advisor 都不能保证盈利或保证通过任何挑战。过往业绩不预示未来结果。在真实账户或注资账户上使用前请务必进行测试。",
    "stat1_l": "专业交易品种",
    "stat2_l": "当前 Gold 交易环境",
    "stat3_l": "Martingale / grid",
    "stat4_l": "一次性价格",
    "test1_role": "已注资 · Gold 交易者",
    "test1_txt": "终于有了一款遵守每日 DD 的 EA。顺利通过第一阶段，没有一天因过度交易而亏损。",
    "test2_role": "评估中",
    "test2_txt": "光是仪表盘就物有所值。目标锁定功能避免我回吐了盈利周的利润。",
    "test3_role": "资管挑战者",
    "test3_txt": "无 martingale，无 grid——逻辑清晰。Gold 终于可以自动交易了。",
    "test4_role": "兼职交易者",
    "test4_txt": "在 VPS 上设置仅需 15 分钟。点差和新闻过滤器让我远离震荡区。",
    "bonus_chip": "免费捆绑",
    "bonus_h1_a": "额外奖励——零附加费用。",
    "bonus_sub": "您的 {price} 即可解锁 EA 及以下所有内容。无追加销售。无限制。全部即时下载。",
    "bonus_total": "总真实价值",
    "bonus_save": "今日立省 {amount}",
    "bonus_free": "随 EA 免费赠送",
    "bonus_worth": "价值",
    "b1_t": "设置指南 PDF",
    "b1_d": "包含截图的各经纪商安装教程。",
    "b2_t": "资管公司预设包",
    "b2_d": "为 FTMO, MyFF, The5ers, FundedNext 预配置的 .set 文件。",
    "b3_t": "XAUUSD 规则速查表",
    "b3_d": "包含每种挑战规模安全风险范围的单页 PDF。",
    "b4_t": "终身更新",
    "b4_d": "未来所有版本均免费提供——永久有效。",
    "pricing_chip": "定价",
    "pricing_h1_a": "一次性支付。",
    "pricing_h1_b": "无订阅费。",
    "pricing_sub": "仅为一次资管挑战失败费用的零头。一次支付，终身拥有。",
    "pricing_offer": "上线特惠 · 仅剩 {n} 份",
    "pricing_save": "立省 {amount} · 一次性",
    "pricing_cta": "立即获取",
    "pricing_secure": "安全支付 · 即时文件交付",
    "pricing_what_get": "您将获得什么",
    "pricing_inc1": "Prop Passer Gold EA (MT5 的 .ex5 文件)",
    "pricing_inc2": "分步设置指南 (PDF)",
    "pricing_inc3": "内置资管公司预设 + 自定义规则",
    "pricing_inc4": "高级图表仪表盘",
    "pricing_inc5": "终身访问——无订阅费",
    "pricing_inc6": "市场发展时的免费更新",
    "pricing_inc7": "优先 WhatsApp 支持",
    "faq_chip": "疑问",
    "faq_h1_a": "买家真正",
    "faq_h1_b": "关心的问题。",
    "faq1_q": "这款 EA 与我的资管公司兼容吗？",
    "faq1_a": "是的。本 EA 内置了适用于常见挑战模式的预设（FTMO, MyForexFunds, The5ers, FundedNext 及类似公司），并支持自定义规则模式，您可以自行设置盈利目标、每日 DD、最大 DD（固定或追踪）、交易品种亏损和一致性规则。部署前请务必与您的提供商规则 PDF 进行核对。",
    "faq2_q": "它使用 martingale、grid 或均摊吗？",
    "faq2_a": "不。每笔交易都有严格 SL 和基于结构的仓位管理。没有对亏损头寸进行均摊，没有 grid 恢复，没有加倍下注。评估员更青睐这种清晰的逻辑。",
    "faq3_q": "哪些账户和经纪商可用？",
    "faq3_a": "任何提供可靠 XAUUSD 点差和佣金的 MT5 经纪商。建议使用 ECN / 原始点差经纪商以获得紧密执行。本 EA 与经纪商无关——您可以完全控制您的交易地点。",
    "faq4_q": "购买后如何交付？",
    "faq4_a": "即时下载。付款后，您将在几分钟内通过电子邮件收到 .ex5 EA 文件、分步设置指南 (PDF) 和资管公司预设包。无需手动引导，无需等待。",
    "faq5_q": "我需要 VPS 吗？",
    "faq5_a": "推荐用于 24/5 运行，以便您睡觉时 EA 也能持续运行。任何标准 MT5 兼容的 VPS 均可。设置指南涵盖了 VPS 基础知识。",
    "faq6_q": "这是一次性支付吗？",
    "faq6_a": "是的。一次性支付，终身授权。无月费，无隐藏续费，无每账户限制。未来的更新也免费包含在内。",
    "faq7_q": "它能保证我通过挑战吗？",
    "faq7_a": "不能——任何向您承诺这一点的都是谎言。这款 EA 是一款规则至上的执行工具，旨在消除导致账户失败的最常见行为错误。结果取决于经纪商、点差、滑点、您选择的设置以及市场条件。",
    "faq8_q": "为什么这么便宜，而竞争对手收费 {comp}？",
    "faq8_a": "这是首批买家的首发价格。全价为 {full}。首发窗口关闭后，价格将恢复正常。早期用户以更低的价格获得相同的产品。",
    "final_chip": "上线特惠期 · 仅剩 {n} 份",
    "final_h1_a": "不再失败",
    "final_h1_b": "资管公司挑战。",
    "final_h1_c": "开始在规则内交易。",
    "final_sub": "一次支付。终身访问。相同的执行引擎，可帮助您通过评估——现在在您的 Gold 图表上 24/5 运行，避免因情绪化错误而导致账户亏损。",
    "final_save": "立省 {amount} · 首发 9 折优惠",
    "final_cta": "立即获取",
    "final_trust": "安全支付 · 即时 .ex5 文件交付 · 终身授权",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "一款专注于 Gold 的 MetaTrader 5 智能交易系统，围绕资管挑战规则设计——回撤上限、目标锁定、风险控制和高级仪表盘。",
    "footer_product": "产品",
    "footer_contact": "联系方式",
    "footer_setup": "免费设置帮助",
    "footer_download": "下载我们的应用程序",
    "footer_sold_by": "由 {seller} 出售",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. 版权所有。",
    "footer_disclaimer": "交易涉及重大风险。过往业绩不预示未来结果。任何 EA 都不能保证通过任何挑战。",
    "locale_title": "选择您的语言",
    "locale_sub": "我们已检测到您的地区。请选择您的首选语言继续。您可以随时从菜单中更改此设置。",
    "locale_continue_en": "继续使用 English",
    "locale_continue_other": "继续使用 {lang}",
    "lang_label": "语言",
    "currency_label": "货币",
    "live_feed": "实时动态"
  
,
    "seo_chip": "完整指南",
    "seo_h1_a": "如何用一款",
    "seo_h1_b": "**Gold EA** 通过自营交易挑战",
    "seo_intro": "大多数参与 FTMO, MyForexFunds, The5ers 或 FundedNext 评估的交易者并非因判断方向失误而失败。他们失败是因为一次情绪化的交易打破了规则——通常是日最大亏损规则、最大回撤规则或一致性规则。**Prop Passer Gold EA** 正是围绕这一问题而设计。它是一款专注于 XAUUSD 的 MetaTrader 5 智能交易系统，能将自营交易公司的合规性从意志力挑战转化为软件设置。",
    "seo_card1_t": "为何选择 XAUUSD (黄金) 进行自营交易挑战？",
    "seo_card1_d": "黄金为自营交易者提供了所需的一切：高波动性、深度流动性、24 小时伦敦/纽约/亚洲交易时段活跃性，以及能奖励基于规则执行的结构性模式。大多数自营交易公司允许交易 XAUUSD，且点差和佣金成本合理——这对于 1 万到 20 万美元的评估账户来说是理想选择。",
    "seo_card2_t": "智能交易系统如何执行自营交易规则",
    "seo_card2_d": "每笔潜在交易在提交订单前都会经过一系列的门控检查。每笔交易风险计算器会调整仓位大小，使其符合您的资金上限（默认 0.5–1%）。日最大 DD 保护会预测最坏情况下的损失，并在触及下限时拒绝交易。最大 DD 保护对静态或追踪规则执行相同操作。止盈目标锁定功能在达到目标后停止开立新交易。",
    "seo_card3_t": "内含自营交易公司预设",
    "seo_card3_d": "发布包中包含预配置的 .set 文件，适用于 FTMO (阶段 1, 2, 已入金)、MyForexFunds Rapid / Evaluation / Accelerated、The5ers Hyper Growth 和 Bootcamp、FundedNext Stellar / Express，以及多家即时入金公司。自定义模式允许您根据任何新公司的规则 PDF 手动配置规则。",
    "seo_card4_t": "无 martingale。无 grid。无 averaging。",
    "seo_card4_d": "在 Telegram 上出售的廉价 EAs 隐藏了 martingale 或 grid 恢复策略——它们在回测中看起来有利可图，因为它们将风险埋藏在导致爆仓的极端事件中。自营交易公司会立即检测到并取消账户资格。Prop Passer Gold 仅使用基于结构并带有硬性 stop losses 的入场策略——这是自营交易公司公开支持的那种清晰逻辑。",
    "seo_card5_t": "这款智能交易系统适合谁？",
    "seo_card5_d": "专为自营挑战参与者、保护资金的已入金账户持有人，以及希望实现纪律性自动化交易而无需每天盯盘 10 小时的 XAUUSD 交易者打造。它不是一个“快速致富”工具——它是一个纪律执行工具。如果您正在寻找有保障的利润，那么这不适合您。",
    "seo_card6_t": "设置和经纪商要求",
    "seo_card6_d": "仅支持 MetaTrader 5。建议在 VPS 上运行以确保 24/5 正常运行时间。任何可靠的 ECN / 原始点差 MT5 经纪商均可使用——包括 FTMO, MyForexFunds, The5ers, FundedNext, FundingPips, Goat Funded Trader 等公司使用的经纪商。发布价格包括一次性付款、终身许可证、免费更新、设置 PDF、预设包和优先 WhatsApp 支持。",
    "seo_quote": "交易自营账户是一场在严格限制内进行的数字游戏。谁最长时间地遵守这些限制，谁就赢。Prop Passer Gold EA 的存在是为了让这些限制成为结构性的，而非情绪性的。这就是全部卖点。",
    "seo_quote_author": "— Dhokiyas 团队"
  },
  "pt": {
    "nav_features": "Funcionalidades",
    "nav_dashboard": "Painel de Controlo",
    "nav_comparison": "Comparar",
    "nav_pricing": "Preços",
    "nav_faq": "FAQ",
    "nav_get_access": "Obter acesso",
    "ann_launch_offer": "Oferta de lançamento",
    "ann_save_today": "Poupe {amount} hoje",
    "ann_left": "restantes",
    "ann_grab": "Aproveite →",
    "hero_badge1": "Feito para Gold · Regime 2025+",
    "hero_badge2": "Pronto para prop firms",
    "hero_badge_copies": "Apenas {n} cópias restantes",
    "hero_h1_a": "Supere desafios de prop firms.",
    "hero_h1_b": "Negocie Gold",
    "hero_h1_c": "como uma máquina disciplinada.",
    "hero_sub": "O Prop Passer Gold EA é um robô para MetaTrader 5 focado em XAUUSD, concebido em torno das regras das prop firms — limites de drawdown, bloqueio de alvo, proteção de risco por negociação e um painel de controlo premium no gráfico. Sem martingale. Sem grid. Apenas execução que prioriza as regras.",
    "hero_cta_primary": "Obtenha acesso instantâneo",
    "hero_cta_secondary": "Ajuda de configuração grátis no WhatsApp",
    "hero_save": "lançamento",
    "hero_pill1": "Focado em Gold",
    "hero_pill2": "DD protegido",
    "hero_pill3": "Pagamento único",
    "hero_card_buy": "Compre por {price}",
    "hero_card_trust": "Entrega instantânea · Pagamento seguro · Licença vitalícia",
    "hero_card_sym": "Símbolo",
    "hero_card_plat": "Plataforma",
    "hero_card_strat": "Estratégia",
    "hero_card_prot": "Proteção",
    "hero_card_strat_v": "Estrutura + Volatilidade",
    "hero_card_prot_v": "Prop Engine",
    "hero_card_b1": "Drawdown diário + proteção máxima de DD",
    "hero_card_b2": "Bloqueio do alvo de lucro após conclusão",
    "hero_card_b3": "Proteção de sexta-feira / fim de semana",
    "hero_card_b4": "Filtro de notícias do calendário económico",
    "problem_chip": "A realidade das prop firms",
    "problem_h1_a": "9 em cada 10",
    "problem_h1_b": "traders falham desafios. Não por más entradas.",
    "problem_sub": "As prop firms não pagam por ter razão. Pagam por estar dentro das regras quando tem razão. Cada falha abaixo é um problema comportamental, não um problema de mercado — e cada uma delas é o que este EA foi projetado para eliminar.",
    "problem_disclaimer": "* Taxas de falha baseadas em dados de avaliação de prop firms publicamente divulgados.",
    "fail1_title": "Quebrar regras de drawdown",
    "fail1_desc": "Uma negociação emocional após uma perda viola o DD diário. Desafio terminado — mesmo que a conta estivesse com lucro uma hora antes.",
    "fail2_title": "Devolver o alvo",
    "fail2_desc": "Atinge o alvo de lucro de 8%, continua a negociar 'por diversão', termina a semana com 2%. O EA para automaticamente novas negociações após atingir o alvo.",
    "fail3_title": "Negociar em excesso em sessões fracas",
    "fail3_desc": "Gold oscila durante a transição, a calmaria asiática e períodos de spread elevado. Os filtros de sessão + spread bloqueiam entradas automaticamente.",
    "fail4_title": "Aumentar o tamanho da posição após perdas",
    "fail4_desc": "Duplicar o lote para 'recuperar' → perda maior → DD máximo atingido. O limite de risco por negociação torna isso matematicamente impossível.",
    "features_chip": "Arquitetura com risco em primeiro lugar",
    "features_h1_a": "Projetado para a",
    "features_h1_b": "realidade dos desafios de prop firms.",
    "features_sub": "As empresas não pagam por intuição. Pagam por disciplina dentro de limites rigorosos. Cada módulo abaixo existe por uma razão: manter a sua conta elegível tempo suficiente para a sua vantagem se manifestar.",
    "feat1_title": "Motor de proteção para desafios de prop firms",
    "feat1_desc": "Predefinições incorporadas + modo de regra personalizada. Monitoriza perda diária, drawdown máximo, perda de símbolo e consistência — para que permaneça dentro dos limites que permitem passar as avaliações.",
    "feat2_title": "Proteção de drawdown diário e máximo",
    "feat2_desc": "Suporta modelos de DD estático e trailing. Calcula os limites de perda em tempo real e bloqueia novas negociações que possam violar a regra.",
    "feat3_title": "Bloqueio de alvo de lucro",
    "feat3_desc": "A maioria dos traders devolve os lucros após atingir o alvo. O EA pode parar automaticamente novas entradas assim que o alvo é atingido — bloqueando o progresso.",
    "feat4_title": "Proteção de risco por negociação",
    "feat4_desc": "Dimensionamento de lote baseado em percentagem ou fixo, com limites mínimo/máximo de lote. Bloqueia negociações cuja distância do SL arriscaria mais do que o seu limite.",
    "feat5_title": "Filtros de qualidade de mercado",
    "feat5_desc": "Filtros de volatilidade ATR, spread, sessão e notícias mantêm o EA fora de condições tóxicas onde Gold elimina traders.",
    "feat6_title": "Proteção de sexta-feira e fim de semana",
    "feat6_desc": "Fecha automaticamente posições antes do fecho de sexta-feira e bloqueia entradas perto da janela de risco do fim de semana — perfeito para regras de financiamento instantâneo.",
    "feat7_title": "Monitor de consistência",
    "feat7_desc": "Monitoriza a relação melhor dia/total para que possa cumprir as regras de consistência que algumas prop firms impõem. Sem negociações de lotaria de um único dia.",
    "feat8_title": "Sem martingale · sem grid",
    "feat8_desc": "Sem média em perdas. Cada negociação tem um stop loss rígido baseado na estrutura do mercado — lógica limpa que os avaliadores apreciam.",
    "feat9_title": "Painel de controlo premium no gráfico",
    "feat9_desc": "Veja o modelo do desafio, DD restante, P/L de hoje, progresso do alvo, spread, notícias e status da sessão num relance — sem cálculo manual.",
    "dashboard_chip": "Inteligência premium no gráfico",
    "dashboard_h1_a": "Cada regra —",
    "dashboard_h1_b": "visível em tempo real.",
    "dashboard_sub": "A maioria dos bots deixa-o na incerteza. O Prop Passer Gold mostra-lhe exatamente o que importa: quanto espaço de drawdown lhe resta, quão perto está do alvo de lucro e se o mercado está seguro para negociar agora. Sem mais cálculos mentais. Sem mais surpresas de quebra de regras.",
    "dash_b1": "Medidores de drawdown diário / máximo em tempo real",
    "dash_b2": "Progresso do alvo de lucro — para de negociar quando atingido",
    "dash_b3": "Calculadora de risco por negociação antes de cada entrada",
    "dash_b4": "Filtros de spread · notícias · sessão sempre ativos",
    "dash_b5": "Pontuação de consistência para prop firms rigorosas",
    "dash_label1": "Painel de controlo principal do EA",
    "dash_label2": "Proteção de Drawdown",
    "dash_label3": "Medidor de risco",
    "dash_label4": "Curva de capital",
    "dash_label5": "Painel de regras de prop firms",
    "comp_chip": "Lado a lado",
    "comp_h1_a": "Porque os traders continuam a",
    "comp_h1_b": "perder contas.",
    "comp_sub": "A diferença entre ter fundos e falhar não está nas entradas — é o que acontece após a entrada. É aqui que o Prop Passer Gold ganha.",
    "comp_yes": "Sim",
    "comp_no": "Não",
    "comp_partial": "Parcial / depende",
    "comp_capability": "Capacidade",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "Negociação manual",
    "comp_col3": "EAs Genéricos",
    "comp_row1": "Respeita o limite de drawdown diário",
    "comp_row2": "Bloqueia negociação antes da violação do SL",
    "comp_row3": "Para automaticamente após o alvo de lucro",
    "comp_row4": "Sem martingale / sem grid",
    "comp_row5": "Predefinições incorporadas para prop firms",
    "comp_row6": "Proteção de sexta-feira / fim de semana",
    "comp_row7": "Filtro de notícias do calendário económico",
    "comp_row8": "Monitor de consistência",
    "comp_row9": "Execução sem emoção 24/5",
    "comp_row10": "Painel de segurança no gráfico",
    "how_chip": "Implemente em 15 minutos",
    "how_h1_a": "Do checkout à",
    "how_h1_b": "primeira negociação.",
    "how_sub": "Sem codificação. Sem grupos de Telegram. Não precisa de ser acompanhado. O guia de configuração explica cada clique.",
    "how_cta": "Comece agora por {price}",
    "step_label": "PASSO",
    "step1_t": "Download instantâneo",
    "step1_d": "Pague uma vez — recebe o ficheiro .ex5, o PDF de configuração e o pacote de predefinições para prop firms imediatamente na sua caixa de entrada.",
    "step2_t": "Anexar a XAUUSD",
    "step2_d": "Arraste para um gráfico de Gold no MetaTrader 5, escolha a sua predefinição de desafio (FTMO, MyFF, The5ers…) ou personalize.",
    "step3_t": "O motor assume o controlo",
    "step3_d": "Cada entrada passa primeiro pela proteção de risco — se puder quebrar a sua regra, é bloqueada antes que aconteça.",
    "step4_t": "Atingir o seu alvo",
    "step4_d": "Para automaticamente de negociar depois de atingir o alvo de lucro. Regista tudo. Você foca-se em obter financiamento.",
    "whofor_chip": "Verificação honesta de adequação",
    "whofor_h1_a": "Leia isto",
    "whofor_h1_b": "antes de comprar.",
    "whofor_sub": "Este EA é feito para um tipo específico de trader. Se está na coluna da esquerda, vai adorá-lo. Se está na direita — poupe o seu dinheiro e continue a rolar.",
    "whofor_for_title": "Feito para si se…",
    "whofor_not_title": "Não é para si se…",
    "for1": "Participantes em desafios de prop firms (FTMO, MyFF, The5ers, FundedNext, etc.)",
    "for2": "Detentores de contas financiadas que protegem o seu capital",
    "for3": "Traders de XAUUSD / Gold que querem automação disciplinada",
    "for4": "Traders cansados de fazer 'revenge-trading' nas suas próprias contas",
    "for5": "Traders a tempo parcial que não conseguem monitorizar gráficos 10 horas por dia",
    "for6": "Qualquer pessoa suficientemente séria para usar um VPS",
    "not1": "Compradores de 'fique rico rápido' que esperam lucros garantidos",
    "not2": "Traders à procura de martingale ou recuperação por grid",
    "not3": "Pessoas que não vão ler o guia de configuração",
    "not4": "Traders que ignoram os PDFs de regras das prop firms",
    "not5": "Qualquer pessoa que espere que o EA 'imprima' dinheiro em 24 horas",
    "proof_chip": "Comunidade",
    "proof_h1_a": "Traders que",
    "proof_h1_b": "pararam de apostar.",
    "proof_sub": "Os resultados dependem do broker, configurações e condições de mercado — mas o manual é o mesmo: regras primeiro, execução segundo.",
    "proof_disclaimer": "Aviso: A negociação envolve riscos. Nenhum Expert Advisor pode garantir lucros ou garantir que passe qualquer desafio. O desempenho passado não prevê resultados futuros. Teste sempre antes de usar numa conta real ou financiada.",
    "stat1_l": "Símbolo especializado",
    "stat2_l": "Regime atual de Gold",
    "stat3_l": "Martingale / grid",
    "stat4_l": "Preço único",
    "test1_role": "Funded · Trader de Gold",
    "test1_txt": "Finalmente um EA que respeita o DD diário. Passei a Fase 1 sem um único dia de 'overtrading' negativo.",
    "test2_role": "Avaliação",
    "test2_txt": "Só o dashboard já vale a pena. O bloqueio de alvo salvou-me de devolver os lucros de uma semana vencedora.",
    "test3_role": "Desafiador de Prop Firms",
    "test3_txt": "Sem martingale, sem grid — lógica limpa. Gold finalmente parece negociável em modo automático.",
    "test4_role": "Trader a tempo parcial",
    "test4_txt": "A configuração demorou 15 minutos no VPS. O filtro de spread e notícias mantém-me fora das zonas de 'chop'.",
    "bonus_chip": "Incluído gratuitamente",
    "bonus_h1_a": "de bónus — sem custos extra.",
    "bonus_sub": "O seu {price} desbloqueia o EA mais tudo o que está abaixo. Nada de vendas adicionais. Nada de bloqueios. Tudo para download instantâneo.",
    "bonus_total": "Valor real total",
    "bonus_save": "Poupe {amount} hoje",
    "bonus_free": "Grátis com o EA",
    "bonus_worth": "Valor",
    "b1_t": "Guia de configuração PDF",
    "b1_d": "Guia de instalação passo a passo por broker, com screenshots.",
    "b2_t": "Pacote de predefinições para prop firms",
    "b2_d": "Ficheiros .set pré-configurados para FTMO, MyFF, The5ers, FundedNext.",
    "b3_t": "XAUUSD rule cheatsheet",
    "b3_d": "PDF de uma página com bandas de risco seguras por tamanho de desafio.",
    "b4_t": "Atualizações vitalícias",
    "b4_d": "Cada versão futura enviada para si gratuitamente — para sempre.",
    "pricing_chip": "Preços",
    "pricing_h1_a": "Pagamento único.",
    "pricing_h1_b": "Sem subscrições.",
    "pricing_sub": "Uma fração da taxa de um desafio de prop firm falhado. Pague uma vez, seja seu para sempre.",
    "pricing_offer": "Oferta de lançamento · {n} cópias restantes",
    "pricing_save": "Poupe {amount} · pagamento único",
    "pricing_cta": "Obtenha acesso instantâneo",
    "pricing_secure": "Pagamento seguro · Entrega instantânea do ficheiro",
    "pricing_what_get": "O que inclui",
    "pricing_inc1": "Prop Passer Gold EA (ficheiro .ex5 para MT5)",
    "pricing_inc2": "Guia de configuração passo a passo (PDF)",
    "pricing_inc3": "Predefinições de prop firm incorporadas + regras personalizadas",
    "pricing_inc4": "Painel de controlo premium no gráfico",
    "pricing_inc5": "Acesso vitalício — sem subscrição",
    "pricing_inc6": "Atualizações gratuitas à medida que o mercado evolui",
    "pricing_inc7": "Suporte prioritário via WhatsApp",
    "faq_chip": "Perguntas",
    "faq_h1_a": "O que os",
    "faq_h1_b": "compradores realmente perguntam.",
    "faq1_q": "Este EA é compatível com a minha prop firm?",
    "faq1_a": "Sim. O EA inclui predefinições para estilos de desafio comuns (FTMO, MyForexFunds, The5ers, FundedNext e similares) e um modo de regra personalizada onde define o seu próprio alvo de lucro, DD diário, DD máximo (estático ou trailing), perda de símbolo e regras de consistência. Verifique sempre com o PDF de regras do seu fornecedor antes de implementar.",
    "faq2_q": "Utiliza martingale, grid ou média?",
    "faq2_a": "Não. Cada negociação tem um stop loss rígido e dimensionamento baseado na estrutura. Sem média em perdas, sem recuperação por grid, sem duplicação de posições. Lógica limpa que os avaliadores preferem.",
    "faq3_q": "Que contas e brokers funcionam?",
    "faq3_a": "Qualquer broker MT5 fiável com spreads e comissões realistas para XAUUSD. Brokers ECN / raw-spread são recomendados para execução precisa. O EA é agnóstico em relação ao broker — mantém total controlo sobre onde negocia.",
    "faq4_q": "Como é entregue após a compra?",
    "faq4_a": "Download instantâneo. Após o pagamento, receberá o ficheiro .ex5 do EA, o guia de configuração passo a passo (PDF) e o pacote de predefinições para prop firms por email em poucos minutos. Sem integração manual, sem esperas.",
    "faq5_q": "Preciso de um VPS?",
    "faq5_a": "Recomendado para operação 24/5, para que o EA continue a funcionar enquanto dorme. Qualquer VPS compatível com MT5 funciona. O guia de configuração abrange os conceitos básicos de VPS.",
    "faq6_q": "É um pagamento único?",
    "faq6_a": "Sim. Um pagamento, licença vitalícia. Sem mensalidades, sem renovações ocultas, sem limites por conta. Atualizações futuras incluídas gratuitamente.",
    "faq7_q": "Garante que passo um desafio?",
    "faq7_a": "Não — e qualquer pessoa que lhe venda essa garantia está a mentir. Este EA é uma ferramenta de execução que prioriza as regras e que elimina os erros comportamentais mais comuns que levam as contas ao fracasso. Os resultados dependem do broker, spread, slippage, das suas configurações escolhidas e das condições de mercado.",
    "faq8_q": "Porque é tão barato quando os concorrentes cobram {comp}?",
    "faq8_a": "Este é um preço de lançamento para a primeira vaga de compradores. O preço total é {full}. Assim que a janela de lançamento fechar, o preço volta ao normal. Os primeiros a adquirir recebem o mesmo produto — apenas por uma fração do custo.",
    "final_chip": "Janela de lançamento · Apenas {n} cópias restantes",
    "final_h1_a": "Pare de falhar",
    "final_h1_b": "desafios de prop firms.",
    "final_h1_c": "Comece a negociar dentro das regras.",
    "final_sub": "Um pagamento. Acesso vitalício. O mesmo motor de execução que passa avaliações — agora a funcionar no seu gráfico de Gold, 24/5, sem os erros emocionais que esgotam as contas.",
    "final_save": "Poupe {amount} · 90% de desconto de lançamento",
    "final_cta": "Obtenha acesso instantâneo",
    "final_trust": "Pagamento seguro · Entrega instantânea do ficheiro .ex5 · Licença vitalícia",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "Um Expert Advisor focado em Gold para MetaTrader 5, projetado em torno das regras dos desafios de prop firms — limites de drawdown, bloqueio de alvo, proteção de risco e um painel de controlo premium.",
    "footer_product": "Produto",
    "footer_contact": "Contacto",
    "footer_setup": "Ajuda de configuração grátis",
    "footer_download": "Descarregue a nossa app",
    "footer_sold_by": "Vendido por {seller}",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. Todos os direitos reservados.",
    "footer_disclaimer": "A negociação envolve risco substancial. O desempenho passado não prevê resultados futuros. Nenhum EA garante passar qualquer desafio.",
    "locale_title": "Escolha o seu idioma",
    "locale_sub": "Detetamos a sua região. Escolha o seu idioma preferido para continuar. Pode alterar isto a qualquer momento no menu.",
    "locale_continue_en": "Continuar em Inglês",
    "locale_continue_other": "Continuar em {lang}",
    "lang_label": "Idioma",
    "currency_label": "Moeda",
    "live_feed": "Feed em Direto"
  
,
    "seo_chip": "O guia completo",
    "seo_h1_a": "Como passar desafios de prop firms com um",
    "seo_h1_b": "Gold EA",
    "seo_intro": "A maioria dos traders que se inscrevem numa avaliação da FTMO, MyForexFunds, The5ers ou FundedNext não falha por escolherem a direção errada. Eles falham porque quebram uma regra — geralmente a regra de drawdown diário, a regra de drawdown máximo, ou a regra de consistência — após uma única negociação emocional. O **Prop Passer Gold EA** foi desenvolvido a pensar exatamente nesse problema. É um Expert Advisor de MetaTrader 5 focado em XAUUSD que transforma a conformidade com as regras das prop firms de um problema de força de vontade numa configuração de software.",
    "seo_card1_t": "Porquê XAUUSD (Gold) para desafios de prop firms?",
    "seo_card1_d": "O Gold oferece o que os traders de prop firms precisam: alta volatilidade, liquidez profunda, atividade de sessão de Londres / Nova Iorque / Asiática 24 horas, e padrões estruturais que recompensam a execução baseada em regras. A maioria das prop firms permite XAUUSD com custos de swap e comissão razoáveis — ideal para contas de avaliação de $10K a $200K.",
    "seo_card2_t": "Como o EA impõe as regras das prop firms",
    "seo_card2_d": "Cada potencial negociação passa por uma verificação sequencial antes da submissão da ordem. A calculadora de risco por negociação dimensiona a posição para se ajustar ao seu limite de capital (padrão 0.5–1%). O guarda DD diário projeta a pior perda possível e rejeita a negociação se ela cruzar o limite. O guarda DD máximo faz o mesmo para regras estáticas ou móveis. O bloqueio de objetivo de lucro impede a abertura de novas negociações assim que o seu objetivo é atingido.",
    "seo_card3_t": "Presets de prop firm incluídos",
    "seo_card3_d": "O pacote de lançamento inclui ficheiros .set pré-configurados para FTMO (Fase 1, 2, Funded), MyForexFunds Rapid / Evaluation / Accelerated, The5ers Hyper Growth e Bootcamp, FundedNext Stellar / Express, e várias firms de financiamento instantâneo. O modo personalizado permite-lhe configurar regras manualmente contra o PDF de regras de qualquer nova firm.",
    "seo_card4_t": "Sem martingale. Sem grid. Sem média.",
    "seo_card4_d": "EAs baratos vendidos no Telegram escondem martingale ou recuperação por grid — parecem lucrativos em backtests porque enterram o risco em eventos de cauda que destroem a conta. As prop firms detetam-nos instantaneamente e desqualificam a conta. O Prop Passer Gold usa apenas entradas baseadas em estrutura com stop losses rígidos — o tipo de lógica limpa que as prop firms apoiam abertamente.",
    "seo_card5_t": "Para quem é este EA?",
    "seo_card5_d": "Construído para participantes de desafios de prop firms, detentores de contas financiadas que protegem o capital, e traders de XAUUSD que desejam automação disciplinada sem observar o gráfico 10 horas por dia. Não é uma ferramenta para 'ficar rico rapidamente' — é uma ferramenta de imposição de disciplina. Se procura lucros garantidos, isto não é para si.",
    "seo_card6_t": "Requisitos de configuração e broker",
    "seo_card6_d": "Executa apenas em MetaTrader 5. Recomendado num VPS para disponibilidade 24/5. Qualquer broker MT5 ECN / raw-spread fiável funciona — incluindo os brokers usados por FTMO, MyForexFunds, The5ers, FundedNext, FundingPips, Goat Funded Trader e firms similares. O preço de lançamento inclui pagamento único, licença vitalícia, atualizações gratuitas, PDF de configuração, pacote de presets, e suporte prioritário via WhatsApp.",
    "seo_quote": "Negociar contas de prop firm é um jogo de números jogado dentro de limites rígidos. Quem respeitar os limites por mais tempo, ganha. O Prop Passer Gold EA existe para tornar esses limites estruturais, não emocionais. Essa é toda a proposta.",
    "seo_quote_author": "— Equipa Dhokiyas"
  },
  "ja": {
    "nav_features": "機能",
    "nav_dashboard": "ダッシュボード",
    "nav_comparison": "比較",
    "nav_pricing": "料金",
    "nav_faq": "よくある質問",
    "nav_get_access": "アクセスする",
    "ann_launch_offer": "ローンチ特別価格",
    "ann_save_today": "今すぐ{amount}お得に",
    "ann_left": "残り",
    "ann_grab": "お見逃しなく →",
    "hero_badge1": "Gold特化型 · 2025年以降の市場に対応",
    "hero_badge2": "プロップファーム対応",
    "hero_badge_copies": "残り{n}個限定",
    "hero_h1_a": "プロップファームのチャレンジに",
    "hero_h1_b": "Gold取引を",
    "hero_h1_c": "規律あるマシンのように。",
    "hero_sub": "Prop Passer Gold EAは、XAUUSDに特化したMetaTrader 5ロボットです。ドローダウン制限、目標達成時のロック、取引ごとのリスクガード、そしてプレミアムなオンチャートダッシュボードといったプロップファームのルールに基づいて設計されています。マルチンゲールもグリッドもありません。ただルールを最優先した実行のみです。",
    "hero_cta_primary": "今すぐアクセス",
    "hero_cta_secondary": "WhatsAppで無料セットアップサポート",
    "hero_save": "ローンチ",
    "hero_pill1": "Gold特化",
    "hero_pill2": "DD保護",
    "hero_pill3": "一度払い",
    "hero_card_buy": "{price}で購入",
    "hero_card_trust": "即時納品 · 安全なチェックアウト · 生涯ライセンス",
    "hero_card_sym": "通貨ペア",
    "hero_card_plat": "プラットフォーム",
    "hero_card_strat": "戦略",
    "hero_card_prot": "保護機能",
    "hero_card_strat_v": "構造 + ボラティリティ",
    "hero_card_prot_v": "プロップエンジン",
    "hero_card_b1": "日次DD + 最大DD保護",
    "hero_card_b2": "目標達成後、利益をロック",
    "hero_card_b3": "金曜 / 週末保護",
    "hero_card_b4": "経済指標ニュースフィルター",
    "problem_chip": "プロップファームの現実",
    "problem_h1_a": "10人中9人",
    "problem_h1_b": "のトレーダーがチャレンジに失敗。エントリーの悪さだけが原因ではありません。",
    "problem_sub": "プロップファームは、正しいことに対して報酬を支払うわけではありません。あなたが正しいときに、ルール内にいることに対して報酬を支払うのです。以下の失敗はすべて行動上の問題であり、市場の問題ではありません。そして、これらすべてをなくすためにこのEAは設計されました。",
    "problem_disclaimer": "* 失敗率は、プロップファームが公表している評価データに基づいています。",
    "fail1_title": "ドローダウンルールを破る",
    "fail1_desc": "損失後の感情的な1回の取引で日次DDを破る。1時間前まで口座が利益を出していても、チャレンジは終了です。",
    "fail2_title": "達成した目標を失う",
    "fail2_desc": "8%の利益目標を達成しても、『遊びで』取引を続け、週末には2%で終わってしまう。このEAは目標達成後、新規取引を自動停止します。",
    "fail3_title": "弱いセッションでの過剰取引",
    "fail3_desc": "Goldはロールオーバー時、アジア時間の静けさ、高スプレッド時間帯にレンジ相場になりやすい。セッションとスプレッドフィルターが自動的にエントリーをブロックします。",
    "fail4_title": "損失後のリベンジ取引",
    "fail4_desc": "『取り戻す』ためにロットを倍増 → より大きな損失 → 最大DD到達。取引ごとのリスク上限により、これは数学的に不可能です。",
    "features_chip": "リスク優先アーキテクチャ",
    "features_h1_a": "プロップチャレンジの",
    "features_h1_b": "現実のために設計されました。",
    "features_sub": "ファームは直感に報酬を支払いません。厳しい制限内の規律に報酬を支払います。以下の各モジュールは、あなたの優位性が発揮されるまで、アカウントを十分な期間、適格な状態に保つためだけに存在します。",
    "feat1_title": "プロップチャレンジ保護エンジン",
    "feat1_desc": "内蔵プリセット + カスタムルールモード。日次損失、最大ドローダウン、通貨ペアごとの損失、一貫性を追跡し、評価をパスするためのガードレール内に留まるようにします。",
    "feat2_title": "日次および最大ドローダウンガード",
    "feat2_desc": "静的DDモデルとトレーリングDDモデルの両方に対応。リアルタイムで損失下限を計算し、ルールを破る可能性のある新規取引をブロックします。",
    "feat3_title": "利益目標ロック",
    "feat3_desc": "ほとんどのトレーダーは目標達成後に利益を失います。このEAは目標達成後、新規エントリーを自動的に停止し、進捗をロックします。",
    "feat4_title": "取引ごとのリスク保護",
    "feat4_desc": "パーセンテージベースまたは固定ロットサイズ（最小/最大ロット制限付き）。SL距離が上限を超えるリスクのある取引をブロックします。",
    "feat5_title": "市場品質フィルター",
    "feat5_desc": "ATRボラティリティ、スプレッド、セッション、ニュースフィルターが、Goldがトレーダーを翻弄する危険な状況からEAを遠ざけます。",
    "feat6_title": "金曜・週末保護",
    "feat6_desc": "金曜日の締め切り前にポジションを自動的にクローズし、週末のリスク時間帯近くのエントリーをブロックします。即時ファンディングルールに最適です。",
    "feat7_title": "一貫性モニター",
    "feat7_desc": "最高日対合計比率を追跡し、一部のプロップファームが課す一貫性ルールを満たせるようにします。一発勝負の取引は行いません。",
    "feat8_title": "マルチンゲールなし · グリッドなし",
    "feat8_desc": "負けトレードにナンピンしません。すべての取引には市場構造に基づいた厳格なストップロスがあり、評価者好みのクリーンなロジックです。",
    "feat9_title": "プレミアムオンチャートダッシュボード",
    "feat9_desc": "チャレンジモデル、残りDD、本日のP/L、目標達成状況、スプレッド、ニュース、セッションステータスが一目で分かります。手動計算は不要です。",
    "dashboard_chip": "プレミアムオンチャートインテリジェンス",
    "dashboard_h1_a": "すべてのルールを",
    "dashboard_h1_b": "リアルタイムで可視化。",
    "dashboard_sub": "ほとんどのbotは推測に任せます。Prop Passer Goldは、残りのドローダウン枠、利益目標達成までの距離、そして今市場が取引に安全かどうかなど、本当に重要なことを正確に表示します。暗算は不要。ルール違反の不意打ちもありません。",
    "dash_b1": "日次 / 最大ドローダウンをライブ表示",
    "dash_b2": "利益目標の進捗状況 — 達成時に取引停止",
    "dash_b3": "すべてのエントリー前の取引ごとのリスク計算機",
    "dash_b4": "スプレッド · ニュース · セッションフィルター常時オン",
    "dash_b5": "厳格なプロップファーム向け一貫性スコア",
    "dash_label1": "メインEAダッシュボード",
    "dash_label2": "ドローダウンガード",
    "dash_label3": "リスクメーター",
    "dash_label4": "資産曲線",
    "dash_label5": "プロップルールパネル",
    "comp_chip": "比較",
    "comp_h1_a": "なぜトレーダーは",
    "comp_h1_b": "口座を失い続けるのか。",
    "comp_sub": "資金提供を受けるトレーダーと失敗するトレーダーの違いはエントリーではありません。エントリー後に何が起こるかです。ここにProp Passer Goldの優位性があります。",
    "comp_yes": "はい",
    "comp_no": "いいえ",
    "comp_partial": "一部対応 / 状況による",
    "comp_capability": "機能",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "裁量取引",
    "comp_col3": "一般的なEA",
    "comp_row1": "日次ドローダウン上限を遵守",
    "comp_row2": "SL違反前に取引をブロック",
    "comp_row3": "利益目標達成後に自動停止",
    "comp_row4": "マルチンゲールなし / グリッドなし",
    "comp_row5": "内蔵プロップファームプリセット",
    "comp_row6": "金曜 / 週末保護",
    "comp_row7": "経済指標ニュースフィルター",
    "comp_row8": "一貫性モニター",
    "comp_row9": "感情に左右されない24時間5日取引",
    "comp_row10": "オンチャート安全ダッシュボード",
    "how_chip": "15分で導入",
    "how_h1_a": "チェックアウトから",
    "how_h1_b": "最初の取引まで。",
    "how_sub": "コーディング不要。Telegramグループも不要。手取り足取りの指導も不要。セットアップガイドがすべてのクリックを案内します。",
    "how_cta": "今すぐ{price}で始める",
    "step_label": "ステップ",
    "step1_t": "即時ダウンロード",
    "step1_d": "一度支払うだけ — .ex5ファイル、セットアップPDF、プロップファームプリセットパックがすぐにあなたの受信トレイに届きます。",
    "step2_t": "XAUUSDに適用",
    "step2_d": "MetaTrader 5のGoldチャートにドラッグし、チャレンジプリセット（FTMO, MyFF, The5ersなど）を選択するか、カスタム設定を行います。",
    "step3_t": "エンジンが引き継ぎます",
    "step3_d": "すべてのエントリーは最初にリスクガードを通過します — もしルールを破る可能性がある場合、それが起こる前にブロックされます。",
    "step4_t": "目標を達成する",
    "step4_d": "利益目標達成後に自動的に取引を停止します。すべてを記録。あなたは資金獲得に集中できます。",
    "whofor_chip": "正直な適合性チェック",
    "whofor_h1_a": "購入前に",
    "whofor_h1_b": "こちらをお読みください。",
    "whofor_sub": "このEAは特定の種類のトレーダーのために作られています。左の列に当てはまるなら、きっと気に入るでしょう。右の列に当てはまるなら — お金を節約して他のものをご覧ください。",
    "whofor_for_title": "こんなあなたにぴったり…",
    "whofor_not_title": "こんなあなたには不向き…",
    "for1": "プロップチャレンジ参加者 (FTMO, MyFF, The5ers, FundedNextなど)",
    "for2": "資金提供を受けた口座で資本を保護したい方",
    "for3": "規律ある自動化を求めるXAUUSD / Goldトレーダー",
    "for4": "自分自身の口座でリベンジトレードに疲れたトレーダー",
    "for5": "1日10時間もチャートを見られないパートタイムトレーダー",
    "for6": "VPSを運用するほど真剣な方",
    "not1": "『一攫千金』を期待し、利益を保証されていると考える購入者",
    "not2": "マルチンゲールやグリッドによるリカバリーを求めるトレーダー",
    "not3": "セットアップガイドを読まない方",
    "not4": "プロップファームのルールPDFを無視するトレーダー",
    "not5": "EAが24時間でお金を印刷すると期待する方",
    "proof_chip": "コミュニティ",
    "proof_h1_a": "ギャンブルを",
    "proof_h1_b": "やめたトレーダーたち。",
    "proof_sub": "結果はブローカー、設定、市場状況によって異なりますが、基本戦略は同じです。ルール第一、実行は第二です。",
    "proof_disclaimer": "免責事項: 取引にはリスクが伴います。いかなるExpert Advisorも利益やチャレンジの通過を保証するものではありません。過去のパフォーマンスは将来の結果を予測するものではありません。ライブ口座や資金提供された口座で使用する前に、必ずテストしてください。",
    "stat1_l": "特化通貨ペア",
    "stat2_l": "現在のGold市場環境",
    "stat3_l": "マルチンゲール / グリッド",
    "stat4_l": "一度払いの価格",
    "test1_role": "資金提供者 · Goldトレーダー",
    "test1_txt": "ついに日次DDを尊重するEAが登場しました。オーバー取引による赤字日なしでフェーズ1をパスしました。",
    "test2_role": "評価者",
    "test2_txt": "ダッシュボードだけでも価値があります。目標ロック機能のおかげで、勝利した週の利益を失わずに済みました。",
    "test3_role": "プロップチャレンジャー",
    "test3_txt": "マルチンゲールなし、グリッドなし — クリーンなロジック。Goldがようやく自動パイロットで取引可能だと感じています。",
    "test4_role": "パートタイムトレーダー",
    "test4_txt": "VPSでのセットアップは15分でした。スプレッドとニュースフィルターが私をレンジ相場から遠ざけてくれます。",
    "bonus_chip": "無料バンドル",
    "bonus_h1_a": "のボーナス — 追加費用は一切なし。",
    "bonus_sub": "{price}でEAと以下のすべてをアンロックします。追加販売なし。制限なし。すべて即時ダウンロード可能です。",
    "bonus_total": "総実質価値",
    "bonus_save": "今すぐ{amount}節約",
    "bonus_free": "EAに付属（無料）",
    "bonus_worth": "価値",
    "b1_t": "セットアップガイドPDF",
    "b1_d": "ブローカーごとのインストール手順をスクリーンショット付きで解説。",
    "b2_t": "プロップファームプリセットパック",
    "b2_d": "FTMO, MyFF, The5ers, FundedNext向けに事前設定された.setファイル。",
    "b3_t": "XAUUSDルールチートシート",
    "b3_d": "チャレンジサイズごとの安全なリスク帯域をまとめた1ページPDF。",
    "b4_t": "生涯アップデート",
    "b4_d": "将来のすべてのバージョンが永続的に無料で提供されます。",
    "pricing_chip": "料金",
    "pricing_h1_a": "一度払い。",
    "pricing_h1_b": "サブスクリプションなし。",
    "pricing_sub": "失敗したプロップチャレンジ料金のほんの一部です。一度支払えば、一生あなたのものです。",
    "pricing_offer": "ローンチ特別価格 · 残り{n}個",
    "pricing_save": "{amount}お得 · 一度払い",
    "pricing_cta": "今すぐアクセス",
    "pricing_secure": "安全なチェックアウト · ファイル即時配信",
    "pricing_what_get": "内容",
    "pricing_inc1": "Prop Passer Gold EA (MT5用.ex5ファイル)",
    "pricing_inc2": "ステップバイステップのセットアップガイド (PDF)",
    "pricing_inc3": "内蔵プロップファームプリセット + カスタムルール",
    "pricing_inc4": "プレミアムオンチャートダッシュボード",
    "pricing_inc5": "生涯アクセス — サブスクリプションなし",
    "pricing_inc6": "市場の変化に応じた無料アップデート",
    "pricing_inc7": "優先WhatsAppサポート",
    "faq_chip": "質問",
    "faq_h1_a": "購入者が",
    "faq_h1_b": "実際に尋ねる事柄。",
    "faq1_q": "このEAは私のプロップファームと互換性がありますか？",
    "faq1_a": "はい。このEAは、一般的なチャレンジスタイル（FTMO, MyForexFunds, The5ers, FundedNextなど）に対応した組み込みプリセットと、独自の利益目標、日次DD、最大DD（静的またはトレーリング）、通貨ペアごとの損失、一貫性ルールを設定できるカスタムルールモードを備えています。導入前に必ずプロバイダーのルールPDFと照合してください。",
    "faq2_q": "マルチンゲール、グリッド、またはナンピンを使用しますか？",
    "faq2_a": "いいえ。すべての取引には厳格なストップロスと構造に基づいたサイズ設定があります。負けトレードにナンピンすることなく、グリッドリカバリーも、倍賭けもありません。評価者が好むクリーンなロジックです。",
    "faq3_q": "どのような口座とブローカーで機能しますか？",
    "faq3_a": "現実的なXAUUSDスプレッドと手数料を持つ信頼できるMT5ブローカーであれば、どこでも機能します。ECN / ロースプレッドブローカーはタイトな実行のために推奨されます。このEAはブローカーに依存せず — どこで取引するかは完全にあなたのコントロール下にあります。",
    "faq4_q": "購入後、どのように配送されますか？",
    "faq4_a": "即時ダウンロードです。支払い後、数分以内に.ex5 EAファイル、ステップバイステップのセットアップガイド (PDF)、プロップファームプリセットパックがメールで届きます。手動での案内や待ち時間はありません。",
    "faq5_q": "VPSは必要ですか？",
    "faq5_a": "24時間5日稼働させるためには推奨されます。これにより、あなたが寝ている間もEAが稼働し続けます。標準的なMT5互換のVPSであればどれでも動作します。セットアップガイドにはVPSの基本も記載されています。",
    "faq6_q": "一度払いの料金ですか？",
    "faq6_a": "はい。一度の支払いで、生涯ライセンスです。月額料金、隠れた更新料、口座ごとの制限はありません。将来のアップデートも無料で含まれます。",
    "faq7_q": "チャレンジ合格を保証しますか？",
    "faq7_a": "いいえ — そしてその保証を売る者は嘘つきです。このEAは、口座を破綻させる最も一般的な行動上の間違いを取り除く、ルール優先の実行ツールです。結果はブローカー、スプレッド、スリッページ、選択した設定、および市場状況に依存します。",
    "faq8_q": "競合他社が{comp}を請求するのに、なぜこんなに安いのですか？",
    "faq8_a": "これは初期購入者向けのローンチ価格です。通常価格は{full}です。ローンチ期間が終了すると、価格は通常に戻ります。早期導入者は、同じ製品をほんの一部費用で手に入れることができます。",
    "final_chip": "ローンチ期間 · 残り{n}個限定",
    "final_h1_a": "プロップチャレンジでの",
    "final_h1_b": "失敗をやめましょう。",
    "final_h1_c": "ルールに沿った取引を始めましょう。",
    "final_sub": "一度の支払い。生涯アクセス。評価をパスするのと同じ実行エンジンが、感情的な間違いで口座を枯渇させることなく、あなたのGoldチャート上で24時間5日稼働します。",
    "final_save": "{amount}お得 · ローンチ特別価格90%オフ",
    "final_cta": "今すぐアクセス",
    "final_trust": "安全なチェックアウト · .ex5ファイル即時配信 · 生涯ライセンス",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "MetaTrader 5向けのGold特化型Expert Advisor。ドローダウン制限、目標達成時のロック、リスクガード、プレミアムダッシュボードといったプロップチャレンジのルールに基づいて設計されています。",
    "footer_product": "製品",
    "footer_contact": "お問い合わせ",
    "footer_setup": "無料セットアップサポート",
    "footer_download": "アプリをダウンロード",
    "footer_sold_by": "{seller}が販売",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. 無断転載を禁じます。",
    "footer_disclaimer": "取引には多大なリスクが伴います。過去のパフォーマンスは将来の結果を予測するものではありません。いかなるEAもチャレンジの通過を保証するものではありません。",
    "locale_title": "言語を選択",
    "locale_sub": "お住まいの地域を検出しました。続行するにはご希望の言語を選択してください。メニューからいつでも変更できます。",
    "locale_continue_en": "英語で続行",
    "locale_continue_other": "{lang}で続行",
    "lang_label": "言語",
    "currency_label": "通貨",
    "live_feed": "ライブフィード"
  
,
    "seo_chip": "完全ガイド",
    "seo_h1_a": "プロップファームのチャレンジをパスする方法",
    "seo_h1_b": "**Gold EA**で",
    "seo_intro": "FTMO、MyForexFunds、The5ers、またはFundedNextの評価に申し込むトレーダーのほとんどは、方向性の選択ミスで失敗するのではありません。彼らは、たった一度の感情的な取引の後で、通常は日次ドローダウン、最大ドローダウン、または一貫性に関するルールを破って失敗します。**Prop Passer Gold EA**は、この正確な問題を中心に設計されています。これは**XAUUSD**に特化した**MetaTrader 5 Expert Advisor**であり、プロップファームのルール遵守を意志力の問題からソフトウェアの設定へと変えます。",
    "seo_card1_t": "なぜプロップチャレンジに**XAUUSD**（ゴールド）なのか？",
    "seo_card1_d": "ゴールドは、プロップトレーダーが必要とするものを提供します。高いボラティリティ、深い流動性、24時間ロンドン／ニューヨーク／アジアセッションでの活動、そしてルールに基づいた実行に報いる構造的なパターンです。ほとんどのプロップファームは、妥当なスワップと手数料で**XAUUSD**を許可しており、$10Kから$200Kまでの評価口座に理想的です。",
    "seo_card2_t": "**EA**がプロップファームのルールをどのように執行するか",
    "seo_card2_d": "すべての潜在的な取引は、注文送信前に連続的なゲートチェックを通過します。取引ごとのリスク計算機は、あなたの証拠金上限（デフォルト0.5～1%）に合わせてポジションサイズを決定します。日次**DD**ガードは最悪の損失を予測し、それを下回る場合に取引を拒否します。最大**DD**ガードも、静的またはトレーリングルールに対して同様の処理を行います。利益目標ロックは、目標達成後に新規取引の開始を停止します。",
    "seo_card3_t": "プロップファームのプリセットが含まれています",
    "seo_card3_d": "ローンチパッケージには、FTMO（Phase 1, 2, Funded）、MyForexFunds Rapid / Evaluation / Accelerated、The5ers Hyper Growth and Bootcamp、FundedNext Stellar / Express、およびいくつかの即時資金調達ファーム向けの事前設定された**.set**ファイルが同梱されています。カスタムモードでは、新しいファームのルール**PDF**に対して手動でルールを設定できます。",
    "seo_card4_t": "マーチンゲールなし。グリッドなし。ナンピンなし。",
    "seo_card4_d": "**Telegram**で販売されている安価な**EA**は、マーチンゲールやグリッドリカバリーを隠しています — バックテストでは利益が出ているように見えますが、それは口座を破綻させるようなテールイベントにリスクを隠しているからです。プロップファームはそれらを即座に検出し、口座を失格とします。**Prop Passer Gold**は、厳格な**SL**を伴う構造に基づいたエントリーのみを使用します — これはプロップファームが公然とサポートするクリーンなロジックです。",
    "seo_card5_t": "この**EA**は誰のためですか？",
    "seo_card5_d": "プロップチャレンジの挑戦者、資金を保護したい資金提供された口座保持者、そして1日10時間チャートを見ることなく規律ある自動化を望む**XAUUSD**トレーダーのために作られました。これは「一攫千金」のツールではありません — 規律を強制するためのツールです。もしあなたが保証された利益を求めているなら、これはあなたには向きません。",
    "seo_card6_t": "セットアップとブローカーの要件",
    "seo_card6_d": "**MetaTrader 5**のみで動作します。24時間週5日の稼働のために**VPS**での使用を推奨します。FTMO、MyForexFunds、The5ers、FundedNext、FundingPips、Goat Funded Traderなどの企業が使用するブローカーを含め、信頼できる**ECN** / 生スプレッドの**MT5**ブローカーであれば動作します。発売価格には、一括払い、永久ライセンス、無料アップデート、セットアップ**PDF**、プリセットパック、および優先**WhatsApp**サポートが含まれます。",
    "seo_quote": "プロップアカウントでの取引は、厳格な制限の中で行われる数字のゲームです。最も長くその制限を尊重する者が勝ちます。**Prop Passer Gold EA**は、その制限を感情的なものではなく、構造的なものにするために存在します。それが私たちの提案のすべてです。",
    "seo_quote_author": "— The Dhokiyas team"
  },
  "de": {
    "nav_features": "Funktionen",
    "nav_dashboard": "Dashboard",
    "nav_comparison": "Vergleich",
    "nav_pricing": "Preise",
    "nav_faq": "FAQ",
    "nav_get_access": "Zugang erhalten",
    "ann_launch_offer": "Startangebot",
    "ann_save_today": "Heute {amount} sparen",
    "ann_left": "verbleibend",
    "ann_grab": "Jetzt sichern →",
    "hero_badge1": "Entwickelt für Gold · Regime 2025+",
    "hero_badge2": "Bereit für Prop-Firms",
    "hero_badge_copies": "Nur noch {n} Exemplare verfügbar",
    "hero_h1_a": "Bestehen Sie Prop-Challenges.",
    "hero_h1_b": "Handeln Sie Gold",
    "hero_h1_c": "wie eine disziplinierte Maschine.",
    "hero_sub": "Prop Passer Gold EA ist ein auf XAUUSD fokussierter MetaTrader 5 Roboter, entwickelt für die Regeln von Prop-Firms — Drawdown-Limits, Ziel-Sperre, Risikoschutz pro Trade und ein Premium On-Chart-Dashboard. Kein Martingale. Kein Grid. Nur regelbasierte Ausführung.",
    "hero_cta_primary": "Sofortigen Zugang erhalten",
    "hero_cta_secondary": "Kostenlose Einrichtungshilfe auf WhatsApp",
    "hero_save": "Einführung",
    "hero_pill1": "Gold-fokussiert",
    "hero_pill2": "DD geschützt",
    "hero_pill3": "Einmalzahlung",
    "hero_card_buy": "Kaufen für {price}",
    "hero_card_trust": "Sofortige Lieferung · Sichere Zahlung · Lebenslange Lizenz",
    "hero_card_sym": "Symbol",
    "hero_card_plat": "Plattform",
    "hero_card_strat": "Strategie",
    "hero_card_prot": "Schutz",
    "hero_card_strat_v": "Struktur + Volatilität",
    "hero_card_prot_v": "Prop Engine",
    "hero_card_b1": "Täglicher Drawdown + max. DD Schutz",
    "hero_card_b2": "Gewinnziel-Sperre nach Erreichen",
    "hero_card_b3": "Freitag- / Wochenendschutz",
    "hero_card_b4": "Wirtschaftskalender-Nachrichtenfilter",
    "problem_chip": "Die Realität der Prop-Firms",
    "problem_h1_a": "9 von 10",
    "problem_h1_b": "Tradern scheitern an Challenges. Nicht wegen schlechter Einstiege.",
    "problem_sub": "Prop-Firms zahlen nicht fürs Richtigliegen. Sie zahlen dafür, dass man sich an die Regeln hält, wenn man richtig liegt. Jeder einzelne Misserfolg unten ist ein Verhaltensproblem, kein Marktproblem — und jeder einzelne davon wurde von diesem EA entwickelt, um ihn zu beseitigen.",
    "problem_disclaimer": "* Ausfallraten basierend auf öffentlich gemeldeten Bewertungsdaten von Prop-Firms.",
    "fail1_title": "Drawdown-Regeln brechen",
    "fail1_desc": "Ein emotionaler Trade nach einem Verlust führt zum Bruch des täglichen DD. Challenge beendet — selbst wenn das Konto eine Stunde zuvor im Plus war.",
    "fail2_title": "Gewinnziel zurückgeben",
    "fail2_desc": "8% Gewinnziel erreicht, weiter handeln 'zum Spaß', die Woche bei 2% beenden. Der EA stoppt neue Trades automatisch nach Zielerreichung.",
    "fail3_title": "Schwache Sessions überhandeln",
    "fail3_desc": "Gold schwankt während Rollover, Asien-Flaute und bei hohen Spreads. Die Session- + Spread-Filter blockieren Einstiege automatisch.",
    "fail4_title": "Revanche-Größe nach Verlusten",
    "fail4_desc": "Losgröße verdoppeln, um 'es zurückzugewinnen' → größerer Verlust → max. DD erreicht. Der Risikoschutz pro Trade macht dies mathematisch unmöglich.",
    "features_chip": "Risiko-orientierte Architektur",
    "features_h1_a": "Entwickelt für die",
    "features_h1_b": "Prop-Challenge-Realität.",
    "features_sub": "Firmen zahlen nicht für Bauchgefühl. Sie zahlen für Disziplin innerhalb harter Grenzen. Jedes Modul unten existiert aus einem Grund: Ihr Konto lange genug qualifiziert zu halten, damit Ihr Vorteil zum Tragen kommt.",
    "feat1_title": "Prop-Challenge-Schutz-Engine",
    "feat1_desc": "Integrierte Presets + benutzerdefinierter Regelmodus. Überwacht täglichen Verlust, maximalen Drawdown, Symbolverlust und Konsistenz — damit Sie innerhalb der Leitplanken bleiben, die Bewertungen bestehen.",
    "feat2_title": "Täglicher & max. Drawdown-Schutz",
    "feat2_desc": "Unterstützt sowohl statische als auch trailing DD-Modelle. Berechnet Verlustgrenzen in Echtzeit und blockiert neue Trades, die die Regel verletzen könnten.",
    "feat3_title": "Gewinnziel-Sperre",
    "feat3_desc": "Die meisten Trader geben Gewinne nach Erreichen des Ziels wieder zurück. Der EA kann neue Einstiege automatisch stoppen, sobald das Ziel erreicht ist — und den Fortschritt sichern.",
    "feat4_title": "Risikoschutz pro Trade",
    "feat4_desc": "Prozentuale oder feste Losgrößenbestimmung mit Min-/Max-Lot-Limits. Blockiert Trades, deren SL-Abstand mehr riskieren würde als Ihr Limit.",
    "feat5_title": "Marktqualitätsfilter",
    "feat5_desc": "ATR Volatilitäts-, Spread-, Session- und Nachrichtenfilter halten den EA aus toxischen Bedingungen heraus, in denen Gold Trader zerschlägt.",
    "feat6_title": "Freitag- & Wochenendschutz",
    "feat6_desc": "Schließt Positionen automatisch vor Freitags-Schluss und blockiert Einstiege nahe des Wochenend-Risikofensters — perfekt für Instant-Funding-Regeln.",
    "feat7_title": "Konsistenz-Monitor",
    "feat7_desc": "Verfolgt das Verhältnis vom besten Tag zum Gesamtgewinn, damit Sie Konsistenzregeln einhalten können, die einige Prop-Firms durchsetzen. Keine eintägigen Lotterie-Trades.",
    "feat8_title": "Kein Martingale · kein Grid",
    "feat8_desc": "Kein Durchschnittsberechnung bei Verlusten. Jeder Trade hat einen harten Stop Loss basierend auf der Marktstruktur — saubere Logik, die Gutachter mögen.",
    "feat9_title": "Premium On-Chart-Dashboard",
    "feat9_desc": "Sehen Sie Challenge-Modell, verbleibenden DD, heutigen P/L, Zielfortschritt, Spread, Nachrichten und Session-Status auf einen Blick — keine manuelle Berechnung.",
    "dashboard_chip": "Premium On-Chart-Intelligenz",
    "dashboard_h1_a": "Jede Regel —",
    "dashboard_h1_b": "in Echtzeit sichtbar.",
    "dashboard_sub": "Die meisten Bots lassen Sie raten. Prop Passer Gold zeigt Ihnen genau, was wichtig ist: wie viel Drawdown-Spielraum Sie noch haben, wie nah Sie am Gewinnziel sind und ob der Markt im Moment überhaupt sicher zu handeln ist. Keine Kopfrechnen mehr. Keine Regelbruch-Überraschungen mehr.",
    "dash_b1": "Live tägliche / maximale Drawdown-Anzeigen",
    "dash_b2": "Gewinnziel-Fortschritt — stoppt den Handel bei Erreichen",
    "dash_b3": "Risiko-pro-Trade-Rechner vor jedem Einstieg",
    "dash_b4": "Spread · Nachrichten · Session-Filter immer aktiv",
    "dash_b5": "Konsistenz-Score für strenge Prop-Firms",
    "dash_label1": "Haupt-EA-Dashboard",
    "dash_label2": "Drawdown-Schutz",
    "dash_label3": "Risikometer",
    "dash_label4": "Equity-Kurve",
    "dash_label5": "Prop-Regeln-Panel",
    "comp_chip": "Im direkten Vergleich",
    "comp_h1_a": "Warum Trader immer wieder",
    "comp_h1_b": "Konten verlieren.",
    "comp_sub": "Der Unterschied zwischen finanziert und gescheitert liegt nicht bei den Einstiegen — sondern dem, was nach dem Einstieg passiert. Hier gewinnt Prop Passer Gold.",
    "comp_yes": "Ja",
    "comp_no": "Nein",
    "comp_partial": "Teilweise / abhängig",
    "comp_capability": "Fähigkeit",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "Manuelles Trading",
    "comp_col3": "Generische EAs",
    "comp_row1": "Respektiert das tägliche Drawdown-Limit",
    "comp_row2": "Blockiert Trades vor SL-Verletzung",
    "comp_row3": "Stoppt automatisch nach Gewinnziel",
    "comp_row4": "Kein Martingale / kein Grid",
    "comp_row5": "Integrierte Prop-Firm-Presets",
    "comp_row6": "Freitag- / Wochenendschutz",
    "comp_row7": "Wirtschaftskalender-Nachrichtenfilter",
    "comp_row8": "Konsistenz-Monitor",
    "comp_row9": "Emotionsfreie Ausführung 24/5",
    "comp_row10": "On-Chart-Sicherheits-Dashboard",
    "how_chip": "In 15 Minuten einsatzbereit",
    "how_h1_a": "Vom Kauf zur",
    "how_h1_b": "ersten Trade.",
    "how_sub": "Kein Coding. Keine Telegram-Gruppen. Keine Anleitung von Hand nötig. Der Einrichtungsleitfaden führt Sie durch jeden Klick.",
    "how_cta": "Jetzt starten für {price}",
    "step_label": "SCHRITT",
    "step1_t": "Sofortiger Download",
    "step1_d": "Einmal zahlen — Sie erhalten die .ex5 Datei, das Setup-PDF und das Prop-Firm-Preset-Paket sofort in Ihren Posteingang.",
    "step2_t": "An XAUUSD anhängen",
    "step2_d": "Auf ein Gold-Chart in MetaTrader 5 ziehen, Ihr Challenge-Preset auswählen (FTMO, MyFF, The5ers…) oder eigene Einstellungen verwenden.",
    "step3_t": "Die Engine übernimmt",
    "step3_d": "Jeder Einstieg läuft zuerst durch den Risikoschutz — wenn er Ihre Regel verletzen könnte, wird er blockiert, bevor es passiert.",
    "step4_t": "Ihr Ziel erreichen",
    "step4_d": "Stoppt den Handel automatisch, nachdem Sie das Gewinnziel erreicht haben. Protokolliert alles. Sie konzentrieren sich darauf, finanziert zu werden.",
    "whofor_chip": "Ehrlicher Eignungscheck",
    "whofor_h1_a": "Lesen Sie dies",
    "whofor_h1_b": "bevor Sie kaufen.",
    "whofor_sub": "Dieser EA wurde für einen bestimmten Tradertyp entwickelt. Wenn Sie in der linken Spalte sind, werden Sie ihn lieben. Wenn Sie in der rechten sind — sparen Sie Ihr Geld und scrollen Sie weiter.",
    "whofor_for_title": "Für Sie gemacht, wenn…",
    "whofor_not_title": "Nicht für Sie, wenn…",
    "for1": "Teilnehmer an Prop-Challenges (FTMO, MyFF, The5ers, FundedNext, etc.)",
    "for2": "Inhaber von finanzierten Konten, die ihr Kapital schützen",
    "for3": "XAUUSD / Gold-Trader, die disziplinierte Automatisierung wünschen",
    "for4": "Trader, die es satt haben, ihre eigenen Konten zu Revance-Traden",
    "for5": "Teilzeit-Trader, die nicht 10 Stunden am Tag Charts beobachten können",
    "for6": "Jeder, der ernsthaft genug ist, einen VPS zu betreiben",
    "not1": "„Schnell reich werden“-Käufer, die garantierte Gewinne erwarten",
    "not2": "Trader, die Martingale- oder Grid-Erholung suchen",
    "not3": "Personen, die den Einrichtungsleitfaden nicht lesen werden",
    "not4": "Trader, die Prop-Firm-Regel-PDFs ignorieren",
    "not5": "Jeder, der erwartet, dass der EA innerhalb von 24 Stunden Geld druckt",
    "proof_chip": "Community",
    "proof_h1_a": "Trader, die",
    "proof_h1_b": "aufgehört haben zu zocken.",
    "proof_sub": "Ergebnisse hängen von Broker, Einstellungen und Marktbedingungen ab — aber die Strategie ist dieselbe: Regeln zuerst, Ausführung danach.",
    "proof_disclaimer": "Disclaimer: Trading birgt Risiken. Kein Expert Advisor kann Gewinne oder das Bestehen einer Challenge garantieren. Vergangene Performance ist kein Indikator für zukünftige Ergebnisse. Immer testen, bevor Sie auf einem Live- oder finanzierten Konto verwenden.",
    "stat1_l": "Spezialisiertes Symbol",
    "stat2_l": "Aktuelles Gold-Regime",
    "stat3_l": "Martingale / Grid",
    "stat4_l": "Einmaliger Preis",
    "test1_role": "Finanziert · Gold-Trader",
    "test1_txt": "Endlich ein EA, der täglichen DD respektiert. Phase 1 ohne einen einzigen roten Übertrading-Tag bestanden.",
    "test2_role": "Evaluation",
    "test2_txt": "Allein das Dashboard ist es wert. Die Ziel-Sperre hat mich davor bewahrt, eine Gewinnwoche wieder abzugeben.",
    "test3_role": "Prop-Challenger",
    "test3_txt": "Kein Martingale, kein Grid — saubere Logik. Gold fühlt sich endlich im Autopilot handelbar an.",
    "test4_role": "Teilzeit-Trader",
    "test4_txt": "Das Setup auf dem VPS dauerte 15 Minuten. Der Spread- und Nachrichtenfilter hält mich aus Chop-Zonen fern.",
    "bonus_chip": "Kostenlos im Paket",
    "bonus_h1_a": "Jede Menge Boni — null zusätzliche Kosten.",
    "bonus_sub": "Ihr {price} schaltet den EA und alles darunter frei. Nichts wird hochverkauft. Nichts ist versteckt. Alles zum sofortigen Download.",
    "bonus_total": "Gesamter realer Wert",
    "bonus_save": "Sie sparen heute {amount}",
    "bonus_free": "Kostenlos mit EA",
    "bonus_worth": "Wert",
    "b1_t": "Setup-Anleitung PDF",
    "b1_d": "Broker-für-Broker Installationsanleitung mit Screenshots.",
    "b2_t": "Prop-Firm-Preset-Paket",
    "b2_d": "Vorkonfigurierte .set-Dateien für FTMO, MyFF, The5ers, FundedNext.",
    "b3_t": "XAUUSD Regel-Spickzettel",
    "b3_d": "Einseitiges PDF mit sicheren Risikobereichen pro Challenge-Größe.",
    "b4_t": "Lebenslange Updates",
    "b4_d": "Jede zukünftige Version kostenlos an Sie geliefert — für immer.",
    "pricing_chip": "Preise",
    "pricing_h1_a": "Einmalig.",
    "pricing_h1_b": "Keine Abonnements.",
    "pricing_sub": "Ein Bruchteil einer einzigen fehlgeschlagenen Prop-Challenge-Gebühr. Einmal zahlen, lebenslang besitzen.",
    "pricing_offer": "Startangebot · Noch {n} Exemplare verfügbar",
    "pricing_save": "Sparen Sie {amount} · einmalig",
    "pricing_cta": "Sofortigen Zugang erhalten",
    "pricing_secure": "Sichere Zahlung · Sofortige Dateilieferung",
    "pricing_what_get": "Was Sie erhalten",
    "pricing_inc1": "Prop Passer Gold EA (.ex5 Datei für MT5)",
    "pricing_inc2": "Schritt-für-Schritt-Einrichtungsleitfaden (PDF)",
    "pricing_inc3": "Integrierte Prop-Firm-Presets + benutzerdefinierte Regeln",
    "pricing_inc4": "Premium On-Chart-Dashboard",
    "pricing_inc5": "Lebenslanger Zugang — kein Abonnement",
    "pricing_inc6": "Kostenlose Updates mit Marktentwicklung",
    "pricing_inc7": "Priorisierter WhatsApp-Support",
    "faq_chip": "Fragen",
    "faq_h1_a": "Die Dinge,",
    "faq_h1_b": "die Käufer tatsächlich fragen.",
    "faq1_q": "Ist dieser EA mit meiner Prop-Firm kompatibel?",
    "faq1_a": "Ja. Der EA wird mit integrierten Presets für gängige Challenge-Stile (FTMO, MyForexFunds, The5ers, FundedNext und ähnliche) sowie einem benutzerdefinierten Regelmodus geliefert, in dem Sie Ihr eigenes Gewinnziel, täglichen DD, max. DD (statisch oder trailing), Symbolverlust und Konsistenzregeln festlegen können. Vergleichen Sie immer mit dem Regel-PDF Ihres Anbieters, bevor Sie ihn einsetzen.",
    "faq2_q": "Verwendet es Martingale, Grid oder Averaging?",
    "faq2_a": "Nein. Jeder Trade hat einen harten Stop Loss und eine strukturbasierte Positionsgröße. Kein Averaging bei Verlusten, keine Grid-Erholung, kein Nachkaufen. Saubere Logik, die Gutachter bevorzugen.",
    "faq3_q": "Welche Konten und Broker funktionieren?",
    "faq3_a": "Jeder zuverlässige MT5-Broker mit realistischen XAUUSD-Spreads und Provisionen. ECN / Raw-Spread-Broker werden für eine präzise Ausführung empfohlen. Der EA ist brokerunabhängig — Sie behalten die volle Kontrolle darüber, wo Sie handeln.",
    "faq4_q": "Wie wird es nach dem Kauf geliefert?",
    "faq4_a": "Sofortiger Download. Nach der Zahlung erhalten Sie die .ex5 EA-Datei, den Schritt-für-Schritt-Einrichtungsleitfaden (PDF) und das Prop-Firm-Preset-Paket innerhalb weniger Minuten per E-Mail. Kein manuelles Onboarding, kein Warten.",
    "faq5_q": "Benötige ich einen VPS?",
    "faq5_a": "Empfohlen für den 24/5-Betrieb, damit der EA weiterläuft, während Sie schlafen. Jeder standardmäßige MT5-kompatible VPS funktioniert. Der Einrichtungsleitfaden behandelt die Grundlagen des VPS.",
    "faq6_q": "Ist es eine einmalige Zahlung?",
    "faq6_a": "Ja. Eine Zahlung, lebenslange Lizenz. Keine monatlichen Gebühren, keine versteckten Verlängerungen, keine pro-Konto-Limits. Zukünftige Updates sind kostenlos enthalten.",
    "faq7_q": "Garantiert es, dass ich eine Challenge bestehe?",
    "faq7_a": "Nein — und jeder, der Ihnen diese Garantie verkauft, lügt. Dieser EA ist ein regelbasiertes Ausführungstool, das die häufigsten Verhaltensfehler eliminiert, die zum Scheitern von Konten führen. Ergebnisse hängen von Broker, Spread, Slippage, Ihren gewählten Einstellungen und Marktbedingungen ab.",
    "faq8_q": "Warum so günstig, wenn Wettbewerber {comp} verlangen?",
    "faq8_a": "Dies ist ein Einführungspreis für die erste Käuferwelle. Der volle Preis beträgt {full}. Sobald das Einführungsfenster schließt, kehrt der Preis zum regulären zurück. Frühkäufer erhalten dasselbe Produkt — nur zu einem Bruchteil der Kosten.",
    "final_chip": "Startfenster · Nur noch {n} Exemplare verfügbar",
    "final_h1_a": "Hören Sie auf zu scheitern",
    "final_h1_b": "an Prop-Challenges.",
    "final_h1_c": "Beginnen Sie, innerhalb der Regeln zu handeln.",
    "final_sub": "Eine Zahlung. Lebenslanger Zugang. Dieselbe Ausführungs-Engine, die Bewertungen besteht — jetzt auf Ihrem Gold-Chart, 24/5, ohne die emotionalen Fehler, die Konten leeren.",
    "final_save": "Sparen Sie {amount} · 90% Rabatt zur Einführung",
    "final_cta": "Sofortigen Zugang erhalten",
    "final_trust": "Sichere Zahlung · Sofortige .ex5 Dateilieferung · Lebenslange Lizenz",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "Ein Gold-fokussierter Expert Advisor für MetaTrader 5, entwickelt für Prop-Challenge-Regeln — Drawdown-Limits, Ziel-Sperre, Risikoschutz und ein Premium-Dashboard.",
    "footer_product": "Produkt",
    "footer_contact": "Kontakt",
    "footer_setup": "Kostenlose Einrichtungshilfe",
    "footer_download": "Unsere App herunterladen",
    "footer_sold_by": "Verkauft von {seller}",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. Alle Rechte vorbehalten.",
    "footer_disclaimer": "Trading birgt erhebliche Risiken. Vergangene Performance ist kein Indikator für zukünftige Ergebnisse. Kein EA garantiert das Bestehen einer Challenge.",
    "locale_title": "Wählen Sie Ihre Sprache",
    "locale_sub": "Wir haben Ihre Region erkannt. Wählen Sie Ihre bevorzugte Sprache, um fortzufahren. Sie können dies jederzeit über das Menü ändern.",
    "locale_continue_en": "Auf Englisch fortfahren",
    "locale_continue_other": "In {lang} fortfahren",
    "lang_label": "Sprache",
    "currency_label": "Währung",
    "live_feed": "Live-Feed"
  
,
    "seo_chip": "Der vollständige Leitfaden",
    "seo_h1_a": "Wie man Prop Firm Challenges mit einem",
    "seo_h1_b": "Gold EA besteht",
    "seo_intro": "Die meisten Trader, die sich für eine FTMO, MyForexFunds, The5ers oder FundedNext Evaluierung anmelden, scheitern nicht, weil sie die falsche Richtung wählen. Sie scheitern, weil sie nach einem einzigen emotionalen Trade eine Regel brechen — meist die Daily Drawdown Rule, die Maximum Drawdown Rule oder die Consistency Rule. Der **Prop Passer Gold EA** wurde genau für dieses Problem entwickelt. Es ist ein XAUUSD-fokussierter MetaTrader 5 Expert Advisor, der die Einhaltung der Prop Firm Regeln von einem Willensproblem in eine Software-Einstellung verwandelt.",
    "seo_card1_t": "Warum XAUUSD (Gold) für Prop Challenges?",
    "seo_card1_d": "Gold bietet, was Prop Trader brauchen: hohe Volatilität, tiefe Liquidität, 24-Stunden-Aktivität in den Londoner / New Yorker / Asiatischen Sessions und strukturelle Muster, die eine regelbasierte Ausführung belohnen. Die meisten Prop Firms erlauben XAUUSD mit angemessenen Swap- und Kommissionskosten — ideal für Evaluierungskonten von $10K bis $200K.",
    "seo_card2_t": "Wie der EA Prop Firm Regeln durchsetzt",
    "seo_card2_d": "Jeder potenzielle Trade durchläuft eine sequentielle Prüfung, bevor er platziert wird. Der Risk-per-Trade-Rechner dimensioniert die Position so, dass sie in Ihr Eigenkapitallimit passt (Standard 0,5–1%). Der Daily DD Guard projiziert den schlimmsten Verlustfall und lehnt den Trade ab, wenn er die Untergrenze überschreitet. Der Max DD Guard macht dasselbe für statische oder nachlaufende Regeln. Der Profit Target Lock verhindert das Eröffnen neuer Trades, sobald Ihr Ziel erreicht ist.",
    "seo_card3_t": "Prop Firm Presets enthalten",
    "seo_card3_d": "Das Launch-Paket wird mit vorkonfigurierten .set-Dateien für FTMO (Phase 1, 2, Funded), MyForexFunds Rapid / Evaluation / Accelerated, The5ers Hyper Growth und Bootcamp, FundedNext Stellar / Express und mehrere Instant-Funding-Firmen geliefert. Der Custom-Modus ermöglicht es Ihnen, Regeln manuell anhand des Regel-PDFs jeder neuen Firma zu konfigurieren.",
    "seo_card4_t": "Kein Martingale. Kein Grid. Keine Durchschnittsbildung.",
    "seo_card4_d": "Günstige EAs, die auf Telegram verkauft werden, verbergen Martingale- oder Grid-Recovery-Strategien — sie sehen in Backtests profitabel aus, weil sie das Risiko in konto-sprengenden Extremereignissen vergraben. Prop Firms erkennen sie sofort und disqualifizieren das Konto. Prop Passer Gold verwendet nur strukturbasierte Entries mit harten Stop Losses — die Art von sauberer Logik, die Prop Firms offen unterstützen.",
    "seo_card5_t": "Für wen ist dieser EA?",
    "seo_card5_d": "Entwickelt für Teilnehmer an Prop Challenges, Inhaber von Funded Accounts, die Kapital schützen, und XAUUSD-Trader, die disziplinierte Automatisierung wünschen, ohne den Chart 10 Stunden am Tag zu beobachten. Es ist kein 'Schnell-reich-werden'-Tool — es ist ein Tool zur Disziplin-Durchsetzung. Wenn Sie garantierte Gewinne suchen, ist dies nichts für Sie.",
    "seo_card6_t": "Setup und Broker-Anforderungen",
    "seo_card6_d": "Läuft nur auf MetaTrader 5. Empfohlen auf einem VPS für 24/5 Uptime. Jeder zuverlässige ECN / Raw-Spread MT5 Broker funktioniert — einschließlich der Broker, die von FTMO, MyForexFunds, The5ers, FundedNext, FundingPips, Goat Funded Trader und ähnlichen Firmen verwendet werden. Der Einführungspreis beinhaltet eine einmalige Zahlung, eine lebenslange Lizenz, kostenlose Updates, ein Setup-PDF, ein Preset-Pack und priorisierten WhatsApp-Support.",
    "seo_quote": "Das Trading von Prop Accounts ist ein Zahlenspiel, das innerhalb strenger Grenzen stattfindet. Wer die Grenzen am längsten respektiert, gewinnt. Der Prop Passer Gold EA existiert, um diese Grenzen strukturell und nicht emotional zu machen. Das ist der ganze Pitch.",
    "seo_quote_author": "— Das Dhokiyas Team"
  },
  "ko": {
    "nav_features": "기능",
    "nav_dashboard": "대시보드",
    "nav_comparison": "비교",
    "nav_pricing": "가격",
    "nav_faq": "자주 묻는 질문",
    "nav_get_access": "지금 시작하기",
    "ann_launch_offer": "런칭 특가",
    "ann_save_today": "오늘 {amount} 절약하세요",
    "ann_left": "남음",
    "ann_grab": "지금 잡으세요 →",
    "hero_badge1": "Gold에 최적화 · 2025+ 시장 체제",
    "hero_badge2": "프로프 펌 트레이딩 준비 완료",
    "hero_badge_copies": "딱 {n}개 남았습니다",
    "hero_h1_a": "프로프 챌린지를 통과하고,",
    "hero_h1_b": "Gold를 거래하세요",
    "hero_h1_c": "훈련된 기계처럼.",
    "hero_sub": "Prop Passer Gold EA는 XAUUSD에 초점을 맞춘 MetaTrader 5 로봇으로, 프로프 펌 규칙(DD 상한선, 목표치 잠금, 거래당 리스크 보호, 프리미엄 온차트 대시보드)에 맞춰 설계되었습니다. No martingale. No grid. 오직 규칙 우선 실행만을 제공합니다.",
    "hero_cta_primary": "즉시 액세스하기",
    "hero_cta_secondary": "WhatsApp에서 무료 설정 지원",
    "hero_save": "출시",
    "hero_pill1": "Gold 집중",
    "hero_pill2": "DD 보호",
    "hero_pill3": "일회성 결제",
    "hero_card_buy": "{price}에 구매하기",
    "hero_card_trust": "즉시 배송 · 안전한 결제 · 평생 라이선스",
    "hero_card_sym": "심볼",
    "hero_card_plat": "플랫폼",
    "hero_card_strat": "전략",
    "hero_card_prot": "보호",
    "hero_card_strat_v": "구조 + 변동성",
    "hero_card_prot_v": "Prop 엔진",
    "hero_card_b1": "일일 DD + 최대 DD 보호",
    "hero_card_b2": "목표 달성 후 수익 목표 잠금",
    "hero_card_b3": "금요일 / 주말 보호",
    "hero_card_b4": "경제 캘린더 뉴스 필터",
    "problem_chip": "프로프 펌의 현실",
    "problem_h1_a": "10명 중 9명은",
    "problem_h1_b": "챌린지에 실패합니다. 진입이 나빠서가 아닙니다.",
    "problem_sub": "프로프 펌은 올바른 진입을 했다고 돈을 지불하지 않습니다. 올바른 진입을 규칙 내에서 했을 때 돈을 지불합니다. 아래의 모든 실패는 시장 문제가 아닌 행동 문제입니다 — 그리고 이 EA는 바로 이러한 문제들을 제거하도록 설계되었습니다.",
    "problem_disclaimer": "* 실패율은 공개적으로 보고된 프로프 펌 평가 데이터를 기반으로 합니다.",
    "fail1_title": "DD 규칙 위반",
    "fail1_desc": "손실 후 감정적인 한 번의 거래가 일일 DD를 위반합니다. 챌린지 종료 — 한 시간 전 계정이 수익 중이었다 해도.",
    "fail2_title": "목표 수익 반납",
    "fail2_desc": "8% 수익 목표를 달성한 후 '재미로' 계속 거래하여 주말에 2%로 마감합니다. EA는 목표 달성 후 새로운 거래를 자동 중단합니다.",
    "fail3_title": "약한 세션에서 과도한 거래",
    "fail3_desc": "Gold는 롤오버, 아시아 세션의 정체, 높은 스프레드 시간대에 횡보합니다. 세션 + 스프레드 필터가 진입을 자동으로 차단합니다.",
    "fail4_title": "손실 후 복수 거래",
    "fail4_desc": "'만회'하기 위해 랏 크기를 두 배로 늘립니다 → 더 큰 손실 → 최대 DD 도달. 거래당 리스크 상한선이 이를 수학적으로 불가능하게 만듭니다.",
    "features_chip": "리스크 우선 아키텍처",
    "features_h1_a": "프로프 챌린지의 현실에 맞춰",
    "features_h1_b": "설계되었습니다.",
    "features_sub": "회사는 직감에 돈을 지불하지 않습니다. 엄격한 한계 내에서의 규율에 돈을 지불합니다. 아래의 모든 모듈은 한 가지 이유로 존재합니다: 당신의 우위가 발휘될 만큼 오랫동안 계정 자격을 유지하기 위함입니다.",
    "feat1_title": "프로프 챌린지 보호 엔진",
    "feat1_desc": "내장된 사전 설정 + 맞춤형 규칙 모드. 일일 손실, 최대 DD, 심볼 손실 및 일관성을 추적하여 평가를 통과하는 가이드라인 내에 머무르도록 합니다.",
    "feat2_title": "일일 및 최대 DD 보호",
    "feat2_desc": "정적 및 트레일링 DD 모델을 모두 지원합니다. 실시간으로 손실 하한선을 계산하고 규칙을 위반할 수 있는 새로운 거래를 차단합니다.",
    "feat3_title": "수익 목표 잠금",
    "feat3_desc": "대부분의 트레이더는 목표를 달성한 후 수익을 되돌려줍니다. EA는 목표에 도달하면 새로운 진입을 자동으로 중단하여 진행 상황을 잠글 수 있습니다.",
    "feat4_title": "거래당 리스크 보호",
    "feat4_desc": "최소/최대 랏 제한이 있는 백분율 기반 또는 고정 랏 크기 조정. SL 거리가 설정된 한도보다 더 큰 리스크를 감수할 수 있는 거래를 차단합니다.",
    "feat5_title": "시장 품질 필터",
    "feat5_desc": "ATR 변동성, 스프레드, 세션 및 뉴스 필터는 Gold가 트레이더를 흔드는 위험한 조건에서 EA를 보호합니다.",
    "feat6_title": "금요일 및 주말 보호",
    "feat6_desc": "금요일 마감 전에 포지션을 자동 청산하고 주말 리스크 구간 근처의 진입을 차단합니다 — 즉시 자금 조달 규칙에 완벽합니다.",
    "feat7_title": "일관성 모니터",
    "feat7_desc": "일부 프로프 펌이 시행하는 일관성 규칙을 충족할 수 있도록 최고 일일 수익 대비 총 수익 비율을 추적합니다. 하루 만에 큰 수익을 노리는 복권식 거래는 없습니다.",
    "feat8_title": "No martingale · no grid",
    "feat8_desc": "손실 거래에 물타기 하지 않습니다. 모든 거래는 시장 구조를 기반으로 한 명확한 손절매를 가집니다 — 평가자들이 선호하는 깔끔한 로직입니다.",
    "feat9_title": "프리미엄 온차트 대시보드",
    "feat9_desc": "챌린지 모델, 남은 DD, 오늘 P/L, 목표 진행 상황, 스프레드, 뉴스 및 세션 상태를 한 눈에 볼 수 있습니다 — 수동 계산이 필요 없습니다.",
    "dashboard_chip": "프리미엄 온차트 인텔리전스",
    "dashboard_h1_a": "모든 규칙 —",
    "dashboard_h1_b": "실시간으로 확인하세요.",
    "dashboard_sub": "대부분의 봇은 추측하게 만듭니다. Prop Passer Gold는 당신에게 중요한 것을 정확히 보여줍니다: 남은 DD 공간, 수익 목표에 얼마나 근접했는지, 그리고 지금 시장이 거래하기에 안전한지 여부. 더 이상 암산도, 규칙 위반의 놀라움도 없습니다.",
    "dash_b1": "실시간 일일 / 최대 DD 게이지",
    "dash_b2": "수익 목표 진행 상황 — 도달 시 거래 중단",
    "dash_b3": "모든 진입 전 거래당 리스크 계산기",
    "dash_b4": "스프레드 · 뉴스 · 세션 필터 항상 활성화",
    "dash_b5": "까다로운 프로프 펌을 위한 일관성 점수",
    "dash_label1": "메인 EA 대시보드",
    "dash_label2": "DD 보호",
    "dash_label3": "리스크 미터",
    "dash_label4": "자산 곡선",
    "dash_label5": "Prop 규칙 패널",
    "comp_chip": "나란히 비교",
    "comp_h1_a": "트레이더들이 계속해서",
    "comp_h1_b": "계좌를 잃는 이유.",
    "comp_sub": "펀딩 성공과 실패의 차이는 진입이 아닙니다 — 진입 후 무엇이 일어나는지입니다. Prop Passer Gold가 승리하는 지점은 바로 여기입니다.",
    "comp_yes": "예",
    "comp_no": "아니요",
    "comp_partial": "부분적 / 경우에 따라 다름",
    "comp_capability": "기능",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "수동 트레이딩",
    "comp_col3": "일반 EA",
    "comp_row1": "일일 DD 상한선 준수",
    "comp_row2": "SL 위반 전 거래 차단",
    "comp_row3": "수익 목표 달성 후 자동 중단",
    "comp_row4": "No martingale / no grid",
    "comp_row5": "내장된 프로프 펌 사전 설정",
    "comp_row6": "금요일 / 주말 보호",
    "comp_row7": "경제 캘린더 뉴스 필터",
    "comp_row8": "일관성 모니터",
    "comp_row9": "감정 없는 24/5 실행",
    "comp_row10": "온차트 안전 대시보드",
    "how_chip": "15분 만에 배포",
    "how_h1_a": "결제부터",
    "how_h1_b": "첫 거래까지.",
    "how_sub": "코딩 불필요. Telegram 그룹 불필요. 개별 지도가 필요 없습니다. 설정 가이드가 모든 클릭을 안내합니다.",
    "how_cta": "지금 {price}에 시작하세요",
    "step_label": "단계",
    "step1_t": "즉시 다운로드",
    "step1_d": "한 번 결제하면 .ex5 파일, 설정 PDF, 프로프 펌 사전 설정 팩을 즉시 이메일로 받으실 수 있습니다.",
    "step2_t": "XAUUSD에 연결",
    "step2_d": "MetaTrader 5의 Gold 차트에 드래그하고, 챌린지 사전 설정(FTMO, MyFF, The5ers 등)을 선택하거나 사용자 지정하세요.",
    "step3_t": "엔진이 작동 시작",
    "step3_d": "모든 진입은 먼저 리스크 보호를 거칩니다 — 규칙을 위반할 수 있는 경우, 발생하기 전에 차단됩니다.",
    "step4_t": "목표 달성",
    "step4_d": "수익 목표에 도달하면 거래를 자동 중단합니다. 모든 것을 기록합니다. 당신은 자금 조달에 집중하세요.",
    "whofor_chip": "솔직한 적합성 확인",
    "whofor_h1_a": "구매 전",
    "whofor_h1_b": "이것을 읽어보세요.",
    "whofor_sub": "이 EA는 특정 유형의 트레이더를 위해 제작되었습니다. 왼쪽 열에 해당한다면 좋아하실 겁니다. 오른쪽 열에 해당한다면 — 돈을 절약하고 다른 곳을 찾아보세요.",
    "whofor_for_title": "이런 분들을 위해 제작되었습니다…",
    "whofor_not_title": "이런 분들에게는 적합하지 않습니다…",
    "for1": "프로프 챌린지 참가자 (FTMO, MyFF, The5ers, FundedNext 등)",
    "for2": "자본을 보호하려는 펀딩 계좌 보유자",
    "for3": "규율 있는 자동화를 원하는 XAUUSD / Gold 트레이더",
    "for4": "자신 계좌의 복수 거래에 지친 트레이더",
    "for5": "하루 10시간 차트를 볼 수 없는 파트타임 트레이더",
    "for6": "VPS를 운영할 만큼 진지한 트레이더",
    "not1": "보장된 수익을 기대하는 '벼락부자' 구매자",
    "not2": "마틴게일 또는 그리드 복구를 찾는 트레이더",
    "not3": "설정 가이드를 읽지 않을 사람",
    "not4": "프로프 펌 규칙 PDF를 무시하는 트레이더",
    "not5": "EA가 24시간 내에 돈을 찍어낼 것이라고 기대하는 사람",
    "proof_chip": "커뮤니티",
    "proof_h1_a": "도박을 멈춘",
    "proof_h1_b": "트레이더들.",
    "proof_sub": "결과는 브로커, 설정 및 시장 조건에 따라 달라지지만 — 기본 원칙은 동일합니다: 규칙 우선, 실행은 그 다음입니다.",
    "proof_disclaimer": "면책 조항: 트레이딩은 리스크를 수반합니다. 어떤 Expert Advisor도 수익 또는 챌린지 통과를 보장할 수 없습니다. 과거 성과는 미래 결과를 예측하지 않습니다. 라이브 또는 펀딩 계좌에서 사용하기 전에 항상 테스트하십시오.",
    "stat1_l": "특화된 심볼",
    "stat2_l": "현재 Gold 시장 체제",
    "stat3_l": "Martingale / grid",
    "stat4_l": "일회성 가격",
    "test1_role": "펀딩 계좌 보유 · Gold 트레이더",
    "test1_txt": "드디어 일일 DD를 존중하는 EA가 나왔네요. 한 번의 과도한 거래로 인한 손실 없이 페이즈 1을 통과했습니다.",
    "test2_role": "평가 단계",
    "test2_txt": "대시보드만으로도 가치가 있습니다. 목표 잠금 기능 덕분에 수익을 되돌려주는 일을 피할 수 있었습니다.",
    "test3_role": "프로프 챌린저",
    "test3_txt": "No martingale, no grid — 깔끔한 로직입니다. 드디어 Gold를 자동 조종으로 거래할 수 있게 되었네요.",
    "test4_role": "파트타임 트레이더",
    "test4_txt": "VPS 설정은 15분 걸렸습니다. 스프레드와 뉴스 필터 덕분에 횡보 구간을 피할 수 있습니다.",
    "bonus_chip": "무료 번들 제공",
    "bonus_h1_a": "다양한 보너스 — 추가 비용 없음.",
    "bonus_sub": "당신의 {price}로 EA와 아래 모든 것을 잠금 해제합니다. 추가 판매 없음. 제한 없음. 모두 즉시 다운로드 가능합니다.",
    "bonus_total": "총 실제 가치",
    "bonus_save": "오늘 {amount} 절약하세요",
    "bonus_free": "EA와 함께 무료 제공",
    "bonus_worth": "가치",
    "b1_t": "설정 가이드 PDF",
    "b1_d": "브로커별 설치 과정을 스크린샷과 함께 안내합니다.",
    "b2_t": "프로프 펌 사전 설정 팩",
    "b2_d": "FTMO, MyFF, The5ers, FundedNext를 위한 사전 구성된 .set 파일.",
    "b3_t": "XAUUSD 규칙 요약본",
    "b3_d": "챌린지 규모별 안전 리스크 범위가 포함된 1페이지 PDF.",
    "b4_t": "평생 업데이트",
    "b4_d": "모든 향후 버전이 평생 무료로 제공됩니다.",
    "pricing_chip": "가격",
    "pricing_h1_a": "일회성.",
    "pricing_h1_b": "구독료 없음.",
    "pricing_sub": "한 번의 프로프 챌린지 실패 비용의 일부에 불과합니다. 한 번 결제하고 평생 소유하세요.",
    "pricing_offer": "런칭 특가 · {n}개 남음",
    "pricing_save": "{amount} 절약 · 일회성",
    "pricing_cta": "즉시 액세스하기",
    "pricing_secure": "안전한 결제 · 즉시 파일 배송",
    "pricing_what_get": "제공되는 내용",
    "pricing_inc1": "Prop Passer Gold EA (MT5용 .ex5 파일)",
    "pricing_inc2": "단계별 설정 가이드 (PDF)",
    "pricing_inc3": "내장된 프로프 펌 사전 설정 + 맞춤형 규칙",
    "pricing_inc4": "프리미엄 온차트 대시보드",
    "pricing_inc5": "평생 액세스 — 구독 없음",
    "pricing_inc6": "시장이 발전함에 따른 무료 업데이트",
    "pricing_inc7": "우선 WhatsApp 지원",
    "faq_chip": "질문",
    "faq_h1_a": "구매자들이 실제로",
    "faq_h1_b": "묻는 질문들.",
    "faq1_q": "이 EA는 제 프로프 펌과 호환되나요?",
    "faq1_a": "예. 이 EA는 일반적인 챌린지 스타일(FTMO, MyForexFunds, The5ers, FundedNext 등)을 위한 내장된 사전 설정과 자체 수익 목표, 일일 DD, 최대 DD(정적 또는 트레일링), 심볼 손실 및 일관성 규칙을 설정할 수 있는 맞춤형 규칙 모드와 함께 제공됩니다. 배포하기 전에 항상 제공업체의 규칙 PDF와 대조하여 확인하십시오.",
    "faq2_q": "마틴게일, 그리드 또는 물타기를 사용하나요?",
    "faq2_a": "아니요. 모든 거래는 명확한 손절매와 구조 기반의 크기 조정을 가집니다. 손실 거래에 물타기, 그리드 복구, 두 배로 늘리기는 없습니다. 평가자들이 선호하는 깔끔한 로직입니다.",
    "faq3_q": "어떤 계좌와 브로커가 작동하나요?",
    "faq3_a": "현실적인 XAUUSD 스프레드와 수수료를 가진 신뢰할 수 있는 모든 MT5 브로커. ECN / 로우 스프레드 브로커를 권장합니다. 이 EA는 브로커에 구애받지 않습니다 — 당신은 거래하는 곳을 완전히 통제할 수 있습니다.",
    "faq4_q": "구매 후 어떻게 전달되나요?",
    "faq4_a": "즉시 다운로드. 결제 후 몇 분 이내에 .ex5 EA 파일, 단계별 설정 가이드(PDF), 프로프 펌 사전 설정 팩을 이메일로 받으실 수 있습니다. 수동 온보딩이나 기다림이 없습니다.",
    "faq5_q": "VPS가 필요한가요?",
    "faq5_a": "EA가 잠자는 동안에도 계속 실행될 수 있도록 24/5 작동을 위해 권장됩니다. 모든 표준 MT5 호환 VPS가 작동합니다. 설정 가이드에는 VPS 기본 사항이 포함되어 있습니다.",
    "faq6_q": "일회성 결제인가요?",
    "faq6_a": "예. 한 번 결제, 평생 라이선스입니다. 월별 요금, 숨겨진 갱신, 계좌별 제한이 없습니다. 향후 업데이트는 무료로 포함됩니다.",
    "faq7_q": "챌린지 통과를 보장하나요?",
    "faq7_a": "아니요 — 그러한 보장을 판매하는 사람은 거짓말을 하는 것입니다. 이 EA는 계좌를 실패하게 만드는 가장 일반적인 행동 실수를 제거하는 규칙 우선 실행 도구입니다. 결과는 브로커, 스프레드, 슬리피지, 선택한 설정 및 시장 조건에 따라 달라집니다.",
    "faq8_q": "경쟁업체가 {comp}를 청구하는데 왜 이렇게 저렴한가요?",
    "faq8_a": "이것은 첫 구매자들을 위한 런칭 가격입니다. 정가는 {full}입니다. 런칭 기간이 끝나면 가격은 정상으로 돌아옵니다. 얼리 어답터는 동일한 제품을 — 단지 일부 비용으로 얻게 됩니다.",
    "final_chip": "런칭 기간 · 딱 {n}개 남음",
    "final_h1_a": "프로프 챌린지에서",
    "final_h1_b": "실패하지 마세요,",
    "final_h1_c": "규칙 안에서 거래를 시작하세요.",
    "final_sub": "한 번 결제. 평생 액세스. 평가를 통과하는 바로 그 실행 엔진이 — 이제 당신의 Gold 차트에서 24/5로 작동하며, 계좌를 고갈시키는 감정적인 실수는 없습니다.",
    "final_save": "{amount} 절약 · 런칭 90% 할인",
    "final_cta": "즉시 액세스하기",
    "final_trust": "안전한 결제 · 즉시 .ex5 파일 배송 · 평생 라이선스",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "MetaTrader 5용 Gold 집중 Expert Advisor로, 프로프 챌린지 규칙(DD 상한선, 목표치 잠금, 리스크 보호, 프리미엄 대시보드)에 맞춰 설계되었습니다.",
    "footer_product": "제품",
    "footer_contact": "문의",
    "footer_setup": "무료 설정 지원",
    "footer_download": "앱 다운로드",
    "footer_sold_by": "{seller} 판매",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. 모든 권리 보유.",
    "footer_disclaimer": "트레이딩은 상당한 리스크를 수반합니다. 과거 성과는 미래 결과를 예측하지 않습니다. 어떤 EA도 챌린지 통과를 보장하지 않습니다.",
    "locale_title": "언어 선택",
    "locale_sub": "지역이 감지되었습니다. 계속하려면 선호하는 언어를 선택하세요. 메뉴에서 언제든지 변경할 수 있습니다.",
    "locale_continue_en": "영어로 계속하기",
    "locale_continue_other": "{lang}으로 계속하기",
    "lang_label": "언어",
    "currency_label": "통화",
    "live_feed": "라이브 피드"
  
,
    "seo_chip": "종합 가이드",
    "seo_h1_a": "프롭 펌 챌린지를 통과하는 방법",
    "seo_h1_b": "**Gold EA**로",
    "seo_intro": "FTMO, MyForexFunds, The5ers 또는 FundedNext 평가에 등록하는 대부분의 트레이더들은 잘못된 방향을 선택해서 실패하는 것이 아닙니다. 그들은 대개 한 번의 감정적인 거래 후에 규칙(일반적으로 일일 손실 제한 규칙, 최대 손실 제한 규칙 또는 일관성 규칙)을 위반하여 실패합니다. **Prop Passer Gold EA**는 바로 이 문제에 초점을 맞춰 개발되었습니다. 이는 XAUUSD에 특화된 MetaTrader 5 Expert Advisor로, 프롭 펌 규칙 준수를 의지의 문제가 아닌 소프트웨어 설정의 문제로 바꿉니다.",
    "seo_card1_t": "프롭 챌린지에 XAUUSD (골드)를 선택하는 이유?",
    "seo_card1_d": "Gold는 프롭 트레이더에게 필요한 것을 제공합니다: 높은 변동성, 깊은 유동성, 런던 / 뉴욕 / 아시아 세션 24시간 활동, 그리고 규칙 기반 실행에 보상하는 구조적 패턴. 대부분의 프롭 펌은 합리적인 스왑 및 커미션 비용으로 XAUUSD 거래를 허용합니다. 이는 1만 달러에서 20만 달러 규모의 평가 계좌에 이상적입니다.",
    "seo_card2_t": "EA가 프롭 펌 규칙을 어떻게 준수하게 하는가",
    "seo_card2_d": "모든 잠재적 거래는 주문 제출 전에 순차적인 게이트 검사를 거칩니다. 거래당 위험 계산기는 자본 한도(기본 0.5–1%)에 맞게 포지션 크기를 조정합니다. 일일 DD 가드는 최악의 손실을 예측하고 한도를 넘어서면 거래를 거부합니다. 최대 DD 가드는 고정 또는 트레일링 규칙에 대해 동일하게 작동합니다. 목표 이익 달성 잠금은 목표에 도달하면 새로운 거래를 시작하는 것을 멈춥니다.",
    "seo_card3_t": "프롭 펌 프리셋 포함",
    "seo_card3_d": "런치 패키지에는 FTMO (Phase 1, 2, Funded), MyForexFunds Rapid / Evaluation / Accelerated, The5ers Hyper Growth 및 Bootcamp, FundedNext Stellar / Express, 그리고 여러 즉시 펀딩 펌을 위한 사전 구성된 .set 파일이 포함되어 있습니다. 사용자 지정 모드를 사용하면 새로운 펌의 규칙 PDF에 따라 규칙을 수동으로 구성할 수 있습니다.",
    "seo_card4_t": "마틴게일 없음. 그리드 없음. 평준화 없음.",
    "seo_card4_d": "Telegram에서 판매되는 저렴한 EA는 마틴게일 또는 그리드 복구 전략을 숨깁니다 — 이는 계좌를 파산시키는 꼬리 이벤트에 위험을 숨기기 때문에 백테스트에서는 수익성이 있어 보입니다. 프롭 펌은 이를 즉시 감지하고 계좌를 실격 처리합니다. Prop Passer Gold는 프롭 펌이 공개적으로 지원하는 종류의 깔끔한 논리인, 엄격한 손절매를 가진 구조 기반 진입만 사용합니다.",
    "seo_card5_t": "이 EA는 누구를 위한 것인가요?",
    "seo_card5_d": "프롭 챌린지 참가자, 자본을 보호하려는 펀딩 계좌 보유자, 그리고 하루 10시간 차트를 보지 않고도 규율 있는 자동화를 원하는 XAUUSD 트레이더를 위해 만들어졌습니다. 이는 '빨리 부자 되는' 도구가 아니라, 규율을 강화하는 도구입니다. 보장된 수익을 찾으신다면, 이것은 당신을 위한 것이 아닙니다.",
    "seo_card6_t": "설치 및 브로커 요구사항",
    "seo_card6_d": "MetaTrader 5에서만 실행됩니다. 24/5 가동을 위해 VPS에서 사용하는 것을 권장합니다. FTMO, MyForexFunds, The5ers, FundedNext, FundingPips, Goat Funded Trader 및 유사한 펌에서 사용하는 브로커를 포함하여 모든 신뢰할 수 있는 ECN / 로우 스프레드 MT5 브로커에서 작동합니다. 출시 가격에는 일회성 결제, 평생 라이선스, 무료 업데이트, 설치 PDF, 프리셋 팩, 그리고 우선적인 WhatsApp 지원이 포함됩니다.",
    "seo_quote": "프롭 계좌 거래는 엄격한 한계 안에서 이루어지는 숫자 게임입니다. 한계를 가장 오래 존중하는 사람이 이깁니다. Prop Passer Gold EA는 그러한 한계를 감정적이 아닌 구조적으로 만들기 위해 존재합니다. 이것이 바로 모든 것입니다.",
    "seo_quote_author": "— The Dhokiyas 팀"
  },
  "fr": {
    "nav_features": "Fonctionnalités",
    "nav_dashboard": "Tableau de bord",
    "nav_comparison": "Comparer",
    "nav_pricing": "Tarifs",
    "nav_faq": "FAQ",
    "nav_get_access": "Accéder",
    "ann_launch_offer": "Offre de lancement",
    "ann_save_today": "Économisez {amount} aujourd'hui",
    "ann_left": "restants",
    "ann_grab": "Profitez-en →",
    "hero_badge1": "Conçu pour l'Or · Régime 2025+",
    "hero_badge2": "Prêt pour les prop firms",
    "hero_badge_copies": "Seulement {n} copies restantes",
    "hero_h1_a": "Réussissez les défis des prop firms.",
    "hero_h1_b": "Tradez le Gold",
    "hero_h1_c": "comme une machine disciplinée.",
    "hero_sub": "Prop Passer Gold EA est un robot MetaTrader 5 axé sur le XAUUSD, conçu autour des règles des prop firms — plafonds de drawdown, verrouillage de l'objectif, gardes de risque par transaction et tableau de bord graphique premium. Pas de martingale. Pas de grille. Juste une exécution basée sur les règles.",
    "hero_cta_primary": "Accès instantané",
    "hero_cta_secondary": "Aide à l'installation gratuite sur WhatsApp",
    "hero_save": "lancement",
    "hero_pill1": "Axé sur l'Or",
    "hero_pill2": "DD protégé",
    "hero_pill3": "Paiement unique",
    "hero_card_buy": "Achetez à {price}",
    "hero_card_trust": "Livraison instantanée · Paiement sécurisé · Licence à vie",
    "hero_card_sym": "Symbole",
    "hero_card_plat": "Plateforme",
    "hero_card_strat": "Stratégie",
    "hero_card_prot": "Protection",
    "hero_card_strat_v": "Structure + Volatilité",
    "hero_card_prot_v": "Moteur Prop",
    "hero_card_b1": "Protection DD journalier + DD max",
    "hero_card_b2": "Verrouillage de l'objectif de profit après atteinte",
    "hero_card_b3": "Protection Vendredi / week-end",
    "hero_card_b4": "Filtre d'actualités du calendrier économique",
    "problem_chip": "La réalité des prop firms",
    "problem_h1_a": "9 traders sur 10",
    "problem_h1_b": "échouent aux défis. Pas à cause de mauvaises entrées.",
    "problem_sub": "Les prop firms ne paient pas pour avoir raison. Elles paient pour respecter les règles lorsque vous avez raison. Chaque échec ci-dessous est un problème comportemental, pas un problème de marché — et chacun d'eux est ce que cet EA a été conçu pour éliminer.",
    "problem_disclaimer": "* Taux d'échec basés sur les données d'évaluation des prop firms rapportées publiquement.",
    "fail1_title": "Enfreindre les règles de drawdown",
    "fail1_desc": "Une transaction émotionnelle après une perte enfreint le DD journalier. Défi terminé — même si le compte était en profit une heure plus tôt.",
    "fail2_title": "Rendre l'objectif",
    "fail2_desc": "Atteindre l'objectif de profit de 8%, continuer à trader 'pour le plaisir', terminer la semaine à 2%. L'EA arrête automatiquement les nouvelles transactions après l'objectif.",
    "fail3_title": "Sur-trader les sessions faibles",
    "fail3_desc": "Le Gold est volatil pendant le rollover, le calme asiatique et les fenêtres à spread élevé. Les filtres de session + spread bloquent automatiquement les entrées.",
    "fail4_title": "Augmenter la taille après des pertes",
    "fail4_desc": "Doubler le lot pour 'regagner' → perte plus importante → DD max atteint. Le plafond de risque par transaction rend cela mathématiquement impossible.",
    "features_chip": "Architecture axée sur le risque",
    "features_h1_a": "Conçu pour la",
    "features_h1_b": "réalité des défis prop firms.",
    "features_sub": "Les firms ne paient pas pour l'intuition. Elles paient pour la discipline dans des limites strictes. Chaque module ci-dessous existe pour une raison : maintenir votre compte éligible assez longtemps pour que votre avantage se manifeste.",
    "feat1_title": "Moteur de protection des défis Prop",
    "feat1_desc": "Préréglages intégrés + mode de règles personnalisées. Suivi des pertes journalières, du drawdown max, des pertes par symbole et de la cohérence — pour que vous restiez dans les limites qui permettent de réussir les évaluations.",
    "feat2_title": "Garde de drawdown journalier & max",
    "feat2_desc": "Prend en charge les modèles de DD statiques et glissants. Calcule les seuils de perte en temps réel et bloque les nouvelles transactions qui pourraient enfreindre la règle.",
    "feat3_title": "Verrouillage de l'objectif de profit",
    "feat3_desc": "La plupart des traders redonnent les profits après avoir atteint l'objectif. L'EA peut arrêter automatiquement les nouvelles entrées une fois l'objectif atteint — verrouillant la progression.",
    "feat4_title": "Protection du risque par transaction",
    "feat4_desc": "Taille de lot basée sur un pourcentage ou fixe avec des limites min/max. Bloque les transactions dont la distance du SL risquerait plus que votre plafond.",
    "feat5_title": "Filtres de qualité du marché",
    "feat5_desc": "Les filtres de volatilité ATR, de spread, de session et d'actualités maintiennent l'EA hors des conditions toxiques où le Gold fait perdre les traders.",
    "feat6_title": "Protection Vendredi & week-end",
    "feat6_desc": "Ferme automatiquement les positions avant la coupure du vendredi et bloque les entrées près de la fenêtre de risque du week-end — parfait pour les règles de financement instantané.",
    "feat7_title": "Moniteur de cohérence",
    "feat7_desc": "Suivi du ratio meilleur jour/total pour que vous puissiez respecter les règles de cohérence que certaines prop firms imposent. Pas de transactions de loterie sur un seul jour.",
    "feat8_title": "Pas de martingale · pas de grille",
    "feat8_desc": "Pas de moyennes sur les perdants. Chaque transaction a un stop loss strict basé sur la structure du marché — une logique propre que les évaluateurs apprécient.",
    "feat9_title": "Tableau de bord graphique premium",
    "feat9_desc": "Visualisez le modèle de défi, le DD restant, le P/L du jour, la progression de l'objectif, le spread, les actualités et l'état de la session en un coup d'œil — pas de calcul manuel.",
    "dashboard_chip": "Intelligence graphique premium",
    "dashboard_h1_a": "Chaque règle —",
    "dashboard_h1_b": "visible en temps réel.",
    "dashboard_sub": "La plupart des robots vous laissent deviner. Prop Passer Gold vous montre exactement ce qui compte : l'espace de drawdown qu'il vous reste, à quel point vous êtes proche de l'objectif de profit et si le marché est même sûr à trader en ce moment. Fini le calcul mental. Fini les surprises de rupture de règles.",
    "dash_b1": "Jauges de drawdown journalier / max en direct",
    "dash_b2": "Progression de l'objectif de profit — arrête le trading lorsqu'il est atteint",
    "dash_b3": "Calculateur de risque par transaction avant chaque entrée",
    "dash_b4": "Filtres Spread · actualités · session toujours actifs",
    "dash_b5": "Score de cohérence pour les prop firms strictes",
    "dash_label1": "Tableau de bord principal de l'EA",
    "dash_label2": "Garde de Drawdown",
    "dash_label3": "Compteur de risque",
    "dash_label4": "Courbe d'équité",
    "dash_label5": "Panneau des règles Prop",
    "comp_chip": "Comparaison",
    "comp_h1_a": "Pourquoi les traders",
    "comp_h1_b": "continuent de perdre des comptes.",
    "comp_sub": "La différence entre un compte financé et un compte échoué n'est pas les entrées — c'est ce qui se passe après l'entrée. C'est là que Prop Passer Gold gagne.",
    "comp_yes": "Oui",
    "comp_no": "Non",
    "comp_partial": "Partiel / dépend",
    "comp_capability": "Capacité",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "Trading manuel",
    "comp_col3": "EA génériques",
    "comp_row1": "Respecte le plafond de drawdown journalier",
    "comp_row2": "Bloque la transaction avant la rupture du SL",
    "comp_row3": "Arrêt automatique après l'objectif de profit",
    "comp_row4": "Pas de martingale / pas de grille",
    "comp_row5": "Préréglages prop firm intégrés",
    "comp_row6": "Protection Vendredi / week-end",
    "comp_row7": "Filtre d'actualités du calendrier économique",
    "comp_row8": "Moniteur de cohérence",
    "comp_row9": "Exécution sans émotion 24h/5j",
    "comp_row10": "Tableau de bord de sécurité graphique",
    "how_chip": "Déployez en 15 minutes",
    "how_h1_a": "Du paiement à la",
    "how_h1_b": "première transaction.",
    "how_sub": "Pas de code. Pas de groupes Telegram. Pas besoin d'être accompagné. Le guide d'installation vous accompagne à chaque étape.",
    "how_cta": "Commencez maintenant à {price}",
    "step_label": "ÉTAPE",
    "step1_t": "Téléchargement instantané",
    "step1_d": "Payez une fois — vous recevez le fichier .ex5, le PDF d'installation et le pack de préréglages prop firm immédiatement dans votre boîte de réception.",
    "step2_t": "Attacher à XAUUSD",
    "step2_d": "Glissez sur un graphique Gold dans MetaTrader 5, choisissez votre préréglage de défi (FTMO, MyFF, The5ers…) ou personnalisez.",
    "step3_t": "Le moteur prend le relais",
    "step3_d": "Chaque entrée passe d'abord par la garde de risque — si elle peut enfreindre votre règle, elle est bloquée avant que cela n'arrive.",
    "step4_t": "Atteignez votre objectif",
    "step4_d": "Arrête automatiquement le trading après avoir atteint l'objectif de profit. Enregistre tout. Vous vous concentrez sur l'obtention de financement.",
    "whofor_chip": "Vérification honnête",
    "whofor_h1_a": "Lisez ceci",
    "whofor_h1_b": "avant d'acheter.",
    "whofor_sub": "Cet EA est conçu pour un type de trader spécifique. Si vous êtes dans la colonne de gauche, vous l'adorerez. Si vous êtes dans celle de droite — économisez votre argent et passez votre chemin.",
    "whofor_for_title": "Conçu pour vous si…",
    "whofor_not_title": "Pas pour vous si…",
    "for1": "Participants aux défis Prop (FTMO, MyFF, The5ers, FundedNext, etc.)",
    "for2": "Détenteurs de comptes financés protégeant leur capital",
    "for3": "Traders XAUUSD / Gold qui veulent une automatisation disciplinée",
    "for4": "Traders fatigués de 'revenge trading' sur leurs propres comptes",
    "for5": "Traders à temps partiel qui ne peuvent pas surveiller les graphiques 10 heures par jour",
    "for6": "Toute personne suffisamment sérieuse pour utiliser un VPS",
    "not1": "Acheteurs 'devenir riche rapidement' s'attendant à des profits garantis",
    "not2": "Traders recherchant la martingale ou la récupération de grille",
    "not3": "Personnes qui ne liront pas le guide d'installation",
    "not4": "Traders qui ignorent les PDF de règles des prop firms",
    "not5": "Quiconque s'attend à ce que l'EA imprime de l'argent en 24 heures",
    "proof_chip": "Communauté",
    "proof_h1_a": "Des traders qui",
    "proof_h1_b": "ont arrêté de jouer.",
    "proof_sub": "Les résultats dépendent du courtier, des paramètres et des conditions du marché — mais la stratégie est la même : les règles d'abord, l'exécution ensuite.",
    "proof_disclaimer": "Avertissement : Le trading implique des risques. Aucun Expert Advisor ne peut garantir de profit ni garantir la réussite d'un défi. Les performances passées ne préjugent pas des résultats futurs. Toujours tester avant d'utiliser sur un compte réel ou financé.",
    "stat1_l": "Symbole spécialisé",
    "stat2_l": "Régime Gold actuel",
    "stat3_l": "Martingale / grille",
    "stat4_l": "Prix unique",
    "test1_role": "Financé · Trader Gold",
    "test1_txt": "Enfin un EA qui respecte le DD journalier. Passé la Phase 1 sans un seul jour de 'overtrading' rouge.",
    "test2_role": "Évaluation",
    "test2_txt": "Le tableau de bord seul en vaut la peine. Le verrouillage de l'objectif m'a évité de rendre une semaine gagnante.",
    "test3_role": "Challenger Prop",
    "test3_txt": "Pas de martingale, pas de grille — logique propre. Le Gold est enfin tradable en pilote automatique.",
    "test4_role": "Trader à temps partiel",
    "test4_txt": "L'installation a pris 15 minutes sur VPS. Le filtre de spread et d'actualités me garde hors des zones de hachage.",
    "bonus_chip": "Inclus gratuitement",
    "bonus_h1_a": "de bonus — zéro coût supplémentaire.",
    "bonus_sub": "Votre {price} débloque l'EA plus tout ce qui suit. Rien n'est vendu en supplément. Rien n'est bloqué. Tout est en téléchargement instantané.",
    "bonus_total": "Valeur réelle totale",
    "bonus_save": "Vous économisez {amount} aujourd'hui",
    "bonus_free": "Gratuit avec l'EA",
    "bonus_worth": "Valeur",
    "b1_t": "Guide d'installation PDF",
    "b1_d": "Procédure d'installation courtier par courtier avec captures d'écran.",
    "b2_t": "Pack de préréglages prop firm",
    "b2_d": "Fichiers .set préconfigurés pour FTMO, MyFF, The5ers, FundedNext.",
    "b3_t": "Anti-sèche des règles XAUUSD",
    "b3_d": "PDF d'une page avec les zones de risque sûres par taille de défi.",
    "b4_t": "Mises à jour à vie",
    "b4_d": "Chaque future version vous sera livrée gratuitement — pour toujours.",
    "pricing_chip": "Tarifs",
    "pricing_h1_a": "Unique.",
    "pricing_h1_b": "Pas d'abonnements.",
    "pricing_sub": "Une fraction du coût d'un défi prop firm échoué. Payez une fois, possédez-le à vie.",
    "pricing_offer": "Offre de lancement · {n} copies restantes",
    "pricing_save": "Économisez {amount} · paiement unique",
    "pricing_cta": "Accès instantané",
    "pricing_secure": "Paiement sécurisé · Livraison instantanée des fichiers",
    "pricing_what_get": "Ce que vous obtenez",
    "pricing_inc1": "Prop Passer Gold EA (fichier .ex5 pour MT5)",
    "pricing_inc2": "Guide d'installation étape par étape (PDF)",
    "pricing_inc3": "Préréglages prop firm intégrés + règles personnalisées",
    "pricing_inc4": "Tableau de bord graphique premium",
    "pricing_inc5": "Accès à vie — pas d'abonnement",
    "pricing_inc6": "Mises à jour gratuites à mesure que le marché évolue",
    "pricing_inc7": "Support WhatsApp prioritaire",
    "faq_chip": "Questions",
    "faq_h1_a": "Les choses",
    "faq_h1_b": "que les acheteurs demandent vraiment.",
    "faq1_q": "Cet EA est-il compatible avec ma prop firm ?",
    "faq1_a": "Oui. L'EA est livré avec des préréglages intégrés pour les styles de défis courants (FTMO, MyForexFunds, The5ers, FundedNext et similaires) et un mode de règles personnalisées où vous définissez vos propres objectif de profit, DD journalier, DD max (statique ou trailing), règles de perte par symbole et de cohérence. Toujours vérifier par rapport au PDF des règles de votre fournisseur avant de déployer.",
    "faq2_q": "Utilise-t-il la martingale, la grille ou la moyenne ?",
    "faq2_a": "Non. Chaque transaction a un stop loss strict et un dimensionnement basé sur la structure. Pas de moyenne sur les perdants, pas de récupération de grille, pas de doublement. Une logique propre que les évaluateurs préfèrent.",
    "faq3_q": "Quels comptes et courtiers fonctionnent ?",
    "faq3_a": "Tout courtier MT5 fiable avec des spreads et des commissions XAUUSD réalistes. Les courtiers ECN / à spreads bruts sont recommandés pour une exécution serrée. L'EA est indépendant du courtier — vous gardez un contrôle total sur l'endroit où vous tradez.",
    "faq4_q": "Comment est-il livré après l'achat ?",
    "faq4_a": "Téléchargement instantané. Après paiement, vous recevez le fichier EA .ex5, le guide d'installation étape par étape (PDF) et le pack de préréglages prop firm par e-mail en quelques minutes. Pas d'intégration manuelle, pas d'attente.",
    "faq5_q": "Ai-je besoin d'un VPS ?",
    "faq5_a": "Recommandé pour un fonctionnement 24h/5j afin que l'EA continue de fonctionner pendant que vous dormez. Tout VPS standard compatible MT5 fonctionne. Le guide d'installation couvre les bases du VPS.",
    "faq6_q": "Est-ce un paiement unique ?",
    "faq6_a": "Oui. Un seul paiement, licence à vie. Pas de frais mensuels, pas de renouvellements cachés, pas de limites par compte. Les futures mises à jour sont incluses gratuitement.",
    "faq7_q": "Cela garantira-t-il que je réussisse un défi ?",
    "faq7_a": "Non — et quiconque vous vend cette garantie ment. Cet EA est un outil d'exécution axé sur les règles qui élimine les erreurs comportementales les plus courantes qui font échouer les comptes. Les résultats dépendent du courtier, du spread, du slippage, de vos paramètres choisis et des conditions du marché.",
    "faq8_q": "Pourquoi est-ce si bon marché alors que les concurrents facturent {comp} ?",
    "faq8_a": "C'est un prix de lancement pour la première vague d'acheteurs. Le prix complet est {full}. Une fois la fenêtre de lancement fermée, le prix reviendra à la normale. Les premiers adoptants obtiennent le même produit — juste à une fraction du coût.",
    "final_chip": "Fenêtre de lancement · Seulement {n} copies restantes",
    "final_h1_a": "Arrêtez d'échouer",
    "final_h1_b": "aux défis prop firms.",
    "final_h1_c": "Commencez à trader dans le respect des règles.",
    "final_sub": "Un seul paiement. Accès à vie. Le même moteur d'exécution qui réussit les évaluations — maintenant fonctionnant sur votre graphique Gold, 24h/5j, sans les erreurs émotionnelles qui épuisent les comptes.",
    "final_save": "Économisez {amount} · 90% de réduction au lancement",
    "final_cta": "Accès instantané",
    "final_trust": "Paiement sécurisé · Livraison instantanée du fichier .ex5 · Licence à vie",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "Un Expert Advisor axé sur le Gold pour MetaTrader 5, conçu autour des règles des défis prop — plafonds de drawdown, verrouillage de l'objectif, gardes de risque et tableau de bord premium.",
    "footer_product": "Produit",
    "footer_contact": "Contact",
    "footer_setup": "Aide à l'installation gratuite",
    "footer_download": "Téléchargez notre application",
    "footer_sold_by": "Vendu par {seller}",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. Tous droits réservés.",
    "footer_disclaimer": "Le trading implique des risques substantiels. Les performances passées ne préjugent pas des résultats futurs. Aucun EA ne garantit la réussite d'un défi.",
    "locale_title": "Choisissez votre langue",
    "locale_sub": "Nous avons détecté votre région. Choisissez votre langue préférée pour continuer. Vous pouvez la modifier à tout moment depuis le menu.",
    "locale_continue_en": "Continuer en anglais",
    "locale_continue_other": "Continuer en {lang}",
    "lang_label": "Langue",
    "currency_label": "Devise",
    "live_feed": "Fil d'actualité en direct"
  
,
    "seo_chip": "Le guide complet",
    "seo_h1_a": "Comment réussir les défis des sociétés de prop trading avec un",
    "seo_h1_b": "EA Or",
    "seo_intro": "La plupart des traders qui s'inscrivent à une évaluation `FTMO`, `MyForexFunds`, `The5ers` ou `FundedNext` n'échouent pas parce qu'ils choisissent la mauvaise direction. Ils échouent parce qu'ils enfreignent une règle — généralement la règle de drawdown quotidien, la règle de drawdown maximal, ou la règle de cohérence — après une seule transaction émotionnelle. **Prop Passer Gold EA** est conçu autour de ce problème précis. C'est un Expert Advisor pour `MetaTrader 5` axé sur le `XAUUSD` qui transforme le respect des règles des sociétés de prop trading d'un problème de volonté en un paramètre logiciel.",
    "seo_card1_t": "Pourquoi le `XAUUSD` (Or) pour les défis de prop trading ?",
    "seo_card1_d": "L'Or offre ce dont les traders de prop trading ont besoin : une forte volatilité, une liquidité profonde, une activité 24 heures sur 24 lors des sessions de Londres / New York / Asie, et des schémas structurels qui récompensent une exécution basée sur des règles. La plupart des sociétés de prop trading autorisent le `XAUUSD` avec des coûts de swap et de commission raisonnables — idéal pour les comptes d'évaluation de 10K$ à 200K$.",
    "seo_card2_t": "Comment l'`EA` applique les règles des sociétés de prop trading",
    "seo_card2_d": "Chaque transaction potentielle passe par une série de vérifications avant la soumission de l'ordre. Le calculateur de risque par transaction dimensionne la position pour qu'elle corresponde à votre plafond de capital (par défaut 0,5–1%). Le garde-fou de `DD` quotidien projette la perte dans le pire des cas et rejette la transaction si elle dépasse le seuil. Le garde-fou de `DD` maximal fait de même pour les règles statiques ou suiveuses. Le verrouillage de l'objectif de profit empêche l'ouverture de nouvelles transactions une fois votre objectif atteint.",
    "seo_card3_t": "Préréglages pour sociétés de prop trading inclus",
    "seo_card3_d": "Le pack de lancement est livré avec des fichiers `.set` pré-configurés pour `FTMO` (Phase 1, 2, Funded), `MyForexFunds` Rapid / Evaluation / Accelerated, `The5ers` Hyper Growth et Bootcamp, `FundedNext` Stellar / Express, et plusieurs sociétés de financement instantané. Le mode personnalisé vous permet de configurer manuellement les règles par rapport au `PDF` des règles de toute nouvelle société.",
    "seo_card4_t": "Pas de martingale. Pas de grille. Pas de moyenne.",
    "seo_card4_d": "Les `EAs` bon marché vendus sur `Telegram` dissimulent la martingale ou la récupération par grille — ils semblent rentables dans les backtests parce qu'ils enterrent le risque dans des événements extrêmes qui font sauter les comptes. Les sociétés de prop trading les détectent instantanément et disqualifient le compte. `Prop Passer Gold` utilise uniquement des entrées basées sur la structure avec des stop losses stricts — le genre de logique claire que les sociétés de prop trading soutiennent ouvertement.",
    "seo_card5_t": "À qui s'adresse cet `EA` ?",
    "seo_card5_d": "Conçu pour les participants aux défis de prop trading, les détenteurs de comptes financés qui protègent leur capital, et les traders `XAUUSD` qui souhaitent une automatisation disciplinée sans surveiller le graphique 10 heures par jour. Ce n'est pas un outil pour « devenir riche rapidement » — c'est un outil de renforcement de la discipline. Si vous recherchez des profits garantis, ce n'est pas pour vous.",
    "seo_card6_t": "Configuration et exigences du courtier",
    "seo_card6_d": "Fonctionne uniquement sur `MetaTrader 5`. Recommandé sur un `VPS` pour une disponibilité 24h/24 et 5j/7. Tout courtier `ECN` / `MT5` à spreads bruts fiable fonctionne — y compris les courtiers utilisés par `FTMO`, `MyForexFunds`, `The5ers`, `FundedNext`, `FundingPips`, `Goat Funded Trader` et des sociétés similaires. Le prix de lancement comprend un paiement unique, une licence à vie, des mises à jour gratuites, un `PDF` de configuration, un pack de préréglages, et un support `WhatsApp` prioritaire.",
    "seo_quote": "Le trading de comptes de prop trading est un jeu de chiffres qui se joue dans des limites strictes. Celui qui respecte les limites le plus longtemps gagne. `Prop Passer Gold EA` existe pour rendre ces limites structurelles, et non émotionnelles. C'est tout le pitch.",
    "seo_quote_author": "— L'équipe Dhokiyas"
  },
  "it": {
    "nav_features": "Funzionalità",
    "nav_dashboard": "Dashboard",
    "nav_comparison": "Compara",
    "nav_pricing": "Prezzi",
    "nav_faq": "FAQ",
    "nav_get_access": "Ottieni accesso",
    "ann_launch_offer": "Offerta di lancio",
    "ann_save_today": "Risparmia {amount} oggi",
    "ann_left": "rimanenti",
    "ann_grab": "Approfittane →",
    "hero_badge1": "Progettato per Gold · Regime 2025+",
    "hero_badge2": "Pronto per le prop-firm",
    "hero_badge_copies": "Solo {n} copie rimaste",
    "hero_h1_a": "Supera le challenge delle prop firm.",
    "hero_h1_b": "Fai trading su Gold",
    "hero_h1_c": "come una macchina disciplinata.",
    "hero_sub": "Prop Passer Gold EA è un robot per MetaTrader 5 focalizzato su XAUUSD, progettato attorno alle regole delle prop-firm: limiti di drawdown, blocco del target, protezione del rischio per operazione e una dashboard on-chart premium. Niente martingale. Niente grid. Solo un'esecuzione che privilegia le regole.",
    "hero_cta_primary": "Ottieni accesso immediato",
    "hero_cta_secondary": "Assistenza gratuita per l'installazione su WhatsApp",
    "hero_save": "lancio",
    "hero_pill1": "Focalizzato su Gold",
    "hero_pill2": "DD protetto",
    "hero_pill3": "Pagamento unico",
    "hero_card_buy": "Acquista a {price}",
    "hero_card_trust": "Consegna immediata · Pagamento sicuro · Licenza a vita",
    "hero_card_sym": "Simbolo",
    "hero_card_plat": "Piattaforma",
    "hero_card_strat": "Strategia",
    "hero_card_prot": "Protezione",
    "hero_card_strat_v": "Struttura + Volatilità",
    "hero_card_prot_v": "Motore Prop",
    "hero_card_b1": "Drawdown giornaliero + protezione DD massimo",
    "hero_card_b2": "Blocco del target di profitto dopo il completamento",
    "hero_card_b3": "Protezione venerdì / weekend",
    "hero_card_b4": "Filtro notizie calendario economico",
    "problem_chip": "La realtà delle prop firm",
    "problem_h1_a": "9 su 10",
    "problem_h1_b": "trader falliscono le challenge. Non per ingressi sbagliati.",
    "problem_sub": "Le prop firm non pagano per avere ragione. Pagano per essere all'interno delle regole quando hai ragione. Ogni singolo fallimento qui sotto è un problema comportamentale, non un problema di mercato — e ognuno di essi è ciò che questo EA è stato progettato per eliminare.",
    "problem_disclaimer": "* Tassi di fallimento basati su dati di valutazione delle prop firm pubblicamente riportati.",
    "fail1_title": "Violare le regole di drawdown",
    "fail1_desc": "Un'operazione emotiva dopo una perdita viola il DD giornaliero. Challenge fallita — anche se il conto era in profitto un'ora prima.",
    "fail2_title": "Restituire il target",
    "fail2_desc": "Raggiungere l'8% di profitto, continuare a fare trading 'per divertimento', chiudere la settimana al 2%. L'EA blocca automaticamente nuove operazioni dopo il target.",
    "fail3_title": "Operare eccessivamente in sessioni deboli",
    "fail3_desc": "Gold si muove a 'dente di sega' durante il rollover, la calma asiatica e finestre ad alto spread. I filtri di sessione + spread bloccano automaticamente gli ingressi.",
    "fail4_title": "Aumentare le dimensioni dopo le perdite",
    "fail4_desc": "Raddoppiare il lotto per 'recuperare' → perdita maggiore → DD massimo raggiunto. Il limite di rischio per operazione rende questo matematicamente impossibile.",
    "features_chip": "Architettura incentrata sul rischio",
    "features_h1_a": "Progettato per la",
    "features_h1_b": "realtà delle prop challenge.",
    "features_sub": "Le aziende non pagano per l'istinto. Pagano per la disciplina all'interno di limiti rigidi. Ogni modulo qui sotto esiste per una ragione: mantenere il tuo conto idoneo abbastanza a lungo perché il tuo vantaggio si realizzi.",
    "feat1_title": "Motore di protezione per prop challenge",
    "feat1_desc": "Preset integrati + modalità regole personalizzate. Traccia la perdita giornaliera, il drawdown massimo, la perdita sul simbolo e la consistenza — così rimani all'interno dei binari che superano le valutazioni.",
    "feat2_title": "Protezione Drawdown giornaliero e massimo",
    "feat2_desc": "Supporta modelli di DD sia statici che trailing. Calcola i livelli di perdita in tempo reale e blocca nuove operazioni che potrebbero violare la regola.",
    "feat3_title": "Blocco del target di profitto",
    "feat3_desc": "La maggior parte dei trader restituisce i profitti dopo aver raggiunto il target. L'EA può bloccare automaticamente nuovi ingressi una volta raggiunto il target — bloccando il progresso.",
    "feat4_title": "Protezione Rischio per operazione",
    "feat4_desc": "Dimensionamento del lotto basato su percentuale o fisso con limiti min/max di lotto. Blocca le operazioni la cui distanza di SL rischierebbe più del tuo limite.",
    "feat5_title": "Filtri di qualità del mercato",
    "feat5_desc": "I filtri di volatilità ATR, spread, sessione e notizie mantengono l'EA lontano da condizioni tossiche dove Gold blocca i trader.",
    "feat6_title": "Protezione venerdì e weekend",
    "feat6_desc": "Chiude automaticamente le posizioni prima della chiusura del venerdì e blocca gli ingressi vicino alla finestra di rischio del weekend — perfetto per le regole di finanziamento istantaneo.",
    "feat7_title": "Monitor di consistenza",
    "feat7_desc": "Traccia il rapporto miglior giorno/totale così puoi rispettare le regole di consistenza che alcune prop firm applicano. Niente operazioni 'da lotteria' in un solo giorno.",
    "feat8_title": "Niente martingale · niente grid",
    "feat8_desc": "Nessuna mediazione sui perdenti. Ogni operazione ha uno stop loss rigido basato sulla struttura del mercato — logica pulita che gli analisti apprezzano.",
    "feat9_title": "Dashboard on-chart premium",
    "feat9_desc": "Visualizza modello challenge, DD rimanente, P/L di oggi, progresso target, spread, notizie e stato della sessione a colpo d'occhio — nessun calcolo manuale.",
    "dashboard_chip": "Intelligenza on-chart premium",
    "dashboard_h1_a": "Ogni regola —",
    "dashboard_h1_b": "visibile in tempo reale.",
    "dashboard_sub": "La maggior parte dei bot ti lascia nel dubbio. Prop Passer Gold ti mostra esattamente ciò che conta: quanto margine di drawdown ti rimane, quanto sei vicino al target di profitto e se il mercato è sicuro per operare in questo momento. Niente più calcoli mentali. Niente più sorprese per violazioni delle regole.",
    "dash_b1": "Indicatori live di drawdown giornaliero / massimo",
    "dash_b2": "Progresso target di profitto — interrompe il trading quando raggiunto",
    "dash_b3": "Calcolatore rischio per operazione prima di ogni ingresso",
    "dash_b4": "Filtri spread · notizie · sessione sempre attivi",
    "dash_b5": "Punteggio di consistenza per prop firm rigorose",
    "dash_label1": "Dashboard principale EA",
    "dash_label2": "Protezione Drawdown",
    "dash_label3": "Misuratore di rischio",
    "dash_label4": "Curva di equity",
    "dash_label5": "Pannello regole Prop",
    "comp_chip": "Fianco a fianco",
    "comp_h1_a": "Perché i trader continuano a",
    "comp_h1_b": "perdere conti.",
    "comp_sub": "La differenza tra finanziati e falliti non sono gli ingressi — è ciò che accade dopo l'ingresso. Ecco dove Prop Passer Gold vince.",
    "comp_yes": "Sì",
    "comp_no": "No",
    "comp_partial": "Parziale / dipende",
    "comp_capability": "Capacità",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "Trading manuale",
    "comp_col3": "EA generici",
    "comp_row1": "Rispetta il limite di drawdown giornaliero",
    "comp_row2": "Blocca l'operazione prima della violazione di SL",
    "comp_row3": "Si ferma automaticamente dopo il target di profitto",
    "comp_row4": "Niente martingale / niente grid",
    "comp_row5": "Preset integrati per prop firm",
    "comp_row6": "Protezione venerdì / weekend",
    "comp_row7": "Filtro notizie calendario economico",
    "comp_row8": "Monitor di consistenza",
    "comp_row9": "Esecuzione senza emozioni 24/5",
    "comp_row10": "Dashboard di sicurezza on-chart",
    "how_chip": "Implementa in 15 minuti",
    "how_h1_a": "Dal carrello al",
    "how_h1_b": "primo trade.",
    "how_sub": "Nessuna codifica. Nessun gruppo Telegram. Non è necessaria alcuna assistenza. La guida all'installazione ti accompagna in ogni click.",
    "how_cta": "Inizia ora a {price}",
    "step_label": "PASSO",
    "step1_t": "Download istantaneo",
    "step1_d": "Paga una volta — riceverai immediatamente nella tua casella di posta il file .ex5, il PDF di configurazione e il pacchetto di preset per prop-firm.",
    "step2_t": "Allega a XAUUSD",
    "step2_d": "Trascina su un grafico Gold in MetaTrader 5, scegli il tuo preset challenge (FTMO, MyFF, The5ers…) o personalizza.",
    "step3_t": "Il motore prende il controllo",
    "step3_d": "Ogni ingresso passa prima dalla protezione dal rischio — se può violare la tua regola, viene bloccato prima che accada.",
    "step4_t": "Raggiungi il tuo target",
    "step4_d": "Ferma automaticamente il trading dopo aver raggiunto il target di profitto. Registra tutto. Tu ti concentri sull'essere finanziato.",
    "whofor_chip": "Verifica onesta dell'idoneità",
    "whofor_h1_a": "Leggi questo",
    "whofor_h1_b": "prima di acquistare.",
    "whofor_sub": "Questo EA è costruito per un tipo specifico di trader. Se ti trovi nella colonna di sinistra, lo amerai. Se ti trovi in quella di destra — risparmia i tuoi soldi e scorri via.",
    "whofor_for_title": "Fatto per te se…",
    "whofor_not_title": "Non per te se…",
    "for1": "Partecipanti alle prop challenge (FTMO, MyFF, The5ers, FundedNext, ecc.)",
    "for2": "Titolari di conti finanziati che proteggono il loro capitale",
    "for3": "Trader XAUUSD / Gold che desiderano un'automazione disciplinata",
    "for4": "Trader stanchi di fare 'revenge trading' sui propri conti",
    "for5": "Trader part-time che non possono guardare i grafici 10 ore al giorno",
    "for6": "Chiunque sia abbastanza serio da usare un VPS",
    "not1": "Acquirenti 'arricchisciti velocemente' che si aspettano profitti garantiti",
    "not2": "Trader alla ricerca di martingale o recupero con grid",
    "not3": "Persone che non leggeranno la guida all'installazione",
    "not4": "Trader che ignorano i PDF delle regole delle prop firm",
    "not5": "Chiunque si aspetti che l'EA stampi denaro in 24 ore",
    "proof_chip": "Community",
    "proof_h1_a": "Trader che",
    "proof_h1_b": "hanno smesso di scommettere.",
    "proof_sub": "I risultati dipendono dal broker, dalle impostazioni e dalle condizioni di mercato — ma il principio è lo stesso: prima le regole, poi l'esecuzione.",
    "proof_disclaimer": "Disclaimer: Il trading comporta rischi. Nessun Expert Advisor può garantire profitto o garantire il superamento di qualsiasi challenge. Le performance passate non predicono i risultati futuri. Testare sempre prima di utilizzare su un conto live o finanziato.",
    "stat1_l": "Simbolo specializzato",
    "stat2_l": "Regime attuale di Gold",
    "stat3_l": "Martingale / grid",
    "stat4_l": "Prezzo una tantum",
    "test1_role": "Finanziato · Trader di Gold",
    "test1_txt": "Finalmente un EA che rispetta il DD giornaliero. Ho superato la Fase 1 senza un singolo giorno di overtrading in rosso.",
    "test2_role": "Valutazione",
    "test2_txt": "Solo la dashboard vale il prezzo. Il blocco del target mi ha salvato dal restituire una settimana vincente.",
    "test3_role": "Prop challenger",
    "test3_txt": "Niente martingale, niente grid — logica pulita. Gold finalmente si sente negoziabile in auto-pilot.",
    "test4_role": "Trader part-time",
    "test4_txt": "L'installazione ha richiesto 15 minuti su VPS. Il filtro spread e notizie mi tiene fuori dalle zone di chop.",
    "bonus_chip": "Incluso gratuitamente",
    "bonus_h1_a": "di bonus — zero costi extra.",
    "bonus_sub": "Il tuo {price} sblocca l'EA più tutto ciò che segue. Nessun upsell. Nessun contenuto bloccato. Tutto con download istantaneo.",
    "bonus_total": "Valore reale totale",
    "bonus_save": "Risparmi {amount} oggi",
    "bonus_free": "Gratuito con l'EA",
    "bonus_worth": "Valore",
    "b1_t": "PDF guida all'installazione",
    "b1_d": "Procedura dettagliata di installazione per ogni broker con screenshot.",
    "b2_t": "Pacchetto preset per prop-firm",
    "b2_d": "File .set pre-configurati per FTMO, MyFF, The5ers, FundedNext.",
    "b3_t": "Foglio riassuntivo regole XAUUSD",
    "b3_d": "PDF di una pagina con fasce di rischio sicure per dimensione della challenge.",
    "b4_t": "Aggiornamenti a vita",
    "b4_d": "Ogni futura versione ti verrà spedita gratuitamente — per sempre.",
    "pricing_chip": "Prezzi",
    "pricing_h1_a": "Una tantum.",
    "pricing_h1_b": "Nessun abbonamento.",
    "pricing_sub": "Una frazione del costo di una prop challenge fallita. Paga una volta, possiedilo per sempre.",
    "pricing_offer": "Offerta di lancio · {n} copie rimaste",
    "pricing_save": "Risparmia {amount} · una tantum",
    "pricing_cta": "Ottieni accesso immediato",
    "pricing_secure": "Pagamento sicuro · Consegna immediata del file",
    "pricing_what_get": "Cosa ottieni",
    "pricing_inc1": "Prop Passer Gold EA (file .ex5 per MT5)",
    "pricing_inc2": "Guida all'installazione passo-passo (PDF)",
    "pricing_inc3": "Preset integrati per prop firm + regole personalizzate",
    "pricing_inc4": "Dashboard on-chart premium",
    "pricing_inc5": "Accesso a vita — nessun abbonamento",
    "pricing_inc6": "Aggiornamenti gratuiti con l'evoluzione del mercato",
    "pricing_inc7": "Supporto WhatsApp prioritario",
    "faq_chip": "Domande",
    "faq_h1_a": "Le cose",
    "faq_h1_b": "che gli acquirenti chiedono davvero.",
    "faq1_q": "Questo EA è compatibile con la mia prop firm?",
    "faq1_a": "Sì. L'EA viene fornito con preset integrati per stili di challenge comuni (FTMO, MyForexFunds, The5ers, FundedNext e simili) e una modalità di regole personalizzate in cui puoi impostare il tuo target di profitto, DD giornaliero, DD massimo (statico o trailing), perdita sul simbolo e regole di consistenza. Verifica sempre con il PDF delle regole del tuo fornitore prima di implementarlo.",
    "faq2_q": "Utilizza martingale, grid o mediazione?",
    "faq2_a": "No. Ogni operazione ha uno stop loss rigido e un dimensionamento basato sulla struttura. Nessuna mediazione sui perdenti, nessun recupero con grid, nessun raddoppio. Logica pulita che gli analisti preferiscono.",
    "faq3_q": "Quali conti e broker funzionano?",
    "faq3_a": "Qualsiasi broker MT5 affidabile con spread e commissioni XAUUSD realistici. I broker ECN / raw-spread sono raccomandati per un'esecuzione precisa. L'EA è indipendente dal broker — mantieni il pieno controllo su dove fare trading.",
    "faq4_q": "Come viene consegnato dopo l'acquisto?",
    "faq4_a": "Download istantaneo. Dopo il pagamento riceverai il file .ex5 dell'EA, la guida all'installazione passo-passo (PDF) e il pacchetto di preset per prop-firm via email in pochi minuti. Nessun onboarding manuale, nessuna attesa.",
    "faq5_q": "Ho bisogno di un VPS?",
    "faq5_a": "Consigliato per l'operatività 24/5 in modo che l'EA continui a funzionare mentre dormi. Qualsiasi VPS standard compatibile con MT5 funziona. La guida all'installazione copre le basi del VPS.",
    "faq6_q": "È un pagamento una tantum?",
    "faq6_a": "Sì. Un unico pagamento, licenza a vita. Nessun costo mensile, nessun rinnovo nascosto, nessun limite per conto. Gli aggiornamenti futuri sono inclusi gratuitamente.",
    "faq7_q": "Garantirà che supererò una challenge?",
    "faq7_a": "No — e chiunque ti venda questa garanzia sta mentendo. Questo EA è uno strumento di esecuzione basato sulle regole che rimuove gli errori comportamentali più comuni che portano al fallimento dei conti. I risultati dipendono dal broker, dallo spread, dallo slippage, dalle impostazioni scelte e dalle condizioni di mercato.",
    "faq8_q": "Perché è così economico quando i concorrenti fanno pagare {comp}?",
    "faq8_a": "Questo è un prezzo di lancio per la prima ondata di acquirenti. Il prezzo intero è {full}. Una volta chiusa la finestra di lancio, il prezzo tornerà a quello normale. I primi acquirenti ottengono lo stesso prodotto — solo a una frazione del costo.",
    "final_chip": "Finestra di lancio · Solo {n} copie rimaste",
    "final_h1_a": "Smetti di fallire",
    "final_h1_b": "le prop challenge.",
    "final_h1_c": "Inizia a fare trading rispettando le regole.",
    "final_sub": "Un unico pagamento. Accesso a vita. Lo stesso motore di esecuzione che supera le valutazioni — ora in funzione sul tuo grafico Gold, 24/5, senza gli errori emotivi che prosciugano i conti.",
    "final_save": "Risparmia {amount} · 90% di sconto lancio",
    "final_cta": "Ottieni accesso immediato",
    "final_trust": "Pagamento sicuro · Consegna istantanea del file .ex5 · Licenza a vita",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "Un Expert Advisor focalizzato su Gold per MetaTrader 5, progettato attorno alle regole delle prop challenge — limiti di drawdown, blocco del target, protezioni dal rischio e una dashboard premium.",
    "footer_product": "Prodotto",
    "footer_contact": "Contatto",
    "footer_setup": "Aiuto configurazione gratuita",
    "footer_download": "Scarica la nostra app",
    "footer_sold_by": "Venduto da {seller}",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. Tutti i diritti riservati.",
    "footer_disclaimer": "Il trading comporta rischi sostanziali. Le performance passate non predicono i risultati futuri. Nessun EA garantisce il superamento di qualsiasi challenge.",
    "locale_title": "Scegli la tua lingua",
    "locale_sub": "Abbiamo rilevato la tua regione. Scegli la tua lingua preferita per continuare. Puoi cambiarla in qualsiasi momento dal menu.",
    "locale_continue_en": "Continua in inglese",
    "locale_continue_other": "Continua in {lang}",
    "lang_label": "Lingua",
    "currency_label": "Valuta",
    "live_feed": "Feed in diretta"
  
,
    "seo_chip": "La guida completa",
    "seo_h1_a": "Come superare le sfide delle prop firm con un",
    "seo_h1_b": "EA Gold",
    "seo_intro": "La maggior parte dei trader che si iscrivono a una valutazione di FTMO, MyForexFunds, The5ers o FundedNext non falliscono perché scelgono la direzione sbagliata. Falliscono perché infrangono una regola — di solito la regola del drawdown giornaliero, la regola del drawdown massimo o la regola della coerenza — dopo un singolo trade emotivo. **Prop Passer Gold EA** è stato progettato proprio per risolvere questo problema. È un Expert Advisor per MetaTrader 5 focalizzato su XAUUSD che trasforma il rispetto delle regole delle prop firm da un problema di forza di volontà a un'impostazione software.",
    "seo_card1_t": "Perché XAUUSD (Gold) per le sfide delle prop firm?",
    "seo_card1_d": "Il Gold offre ciò di cui i prop trader hanno bisogno: alta volatilità, profonda liquidità, attività 24 ore su 24 nelle sessioni di Londra / New York / Asia, e pattern strutturali che premiano un'esecuzione basata su regole. La maggior parte delle prop firm consente XAUUSD con costi di swap e commissione ragionevoli — ideale per conti di valutazione da $10K a $200K.",
    "seo_card2_t": "Come l'EA applica le regole delle prop firm",
    "seo_card2_d": "Ogni potenziale trade passa attraverso una verifica sequenziale prima dell'invio dell'ordine. Il calcolatore del rischio per trade dimensiona la posizione per rientrare nel tuo limite di capitale (default 0.5–1%). Il daily DD guard proietta la perdita peggiore e rifiuta il trade se supera il limite minimo. Il Max DD guard fa lo stesso per le regole statiche o trailing. Il blocco del profit target interrompe l'apertura di nuovi trade una volta raggiunto il tuo obiettivo.",
    "seo_card3_t": "Preset delle prop firm inclusi",
    "seo_card3_d": "Il pacchetto di lancio include file .set preconfigurati per FTMO (Phase 1, 2, Funded), MyForexFunds Rapid / Evaluation / Accelerated, The5ers Hyper Growth e Bootcamp, FundedNext Stellar / Express, e diverse prop firm a finanziamento istantaneo. La modalità personalizzata ti consente di configurare manualmente le regole per il PDF delle regole di qualsiasi nuova firm.",
    "seo_card4_t": "Nessun martingale. Nessuna grid. Nessuna mediazione.",
    "seo_card4_d": "Gli EA economici venduti su Telegram nascondono Martingale o recovery a grid — appaiono profittevoli nei backtest perché nascondono il rischio in eventi estremi che azzerano il conto. Le prop firm li rilevano istantaneamente e squalificano l'account. Prop Passer Gold utilizza solo entrate basate sulla struttura con stop loss rigidi — il tipo di logica pulita che le prop firm supportano apertamente.",
    "seo_card5_t": "A chi è rivolto questo EA?",
    "seo_card5_d": "Progettato per chi affronta le sfide delle prop firm, per i titolari di conti funded che proteggono il capitale e per i trader XAUUSD che desiderano un'automazione disciplinata senza dover monitorare il grafico 10 ore al giorno. Non è uno strumento per 'arricchirsi velocemente' — è uno strumento per l'applicazione della disciplina. Se cerchi profitti garantiti, questo non fa per te.",
    "seo_card6_t": "Requisiti di configurazione e broker",
    "seo_card6_d": "Funziona solo su MetaTrader 5. Raccomandato su un VPS per un uptime 24/5. Qualsiasi broker ECN / raw-spread affidabile per MT5 funziona — inclusi i broker utilizzati da FTMO, MyForexFunds, The5ers, FundedNext, FundingPips, Goat Funded Trader e prop firm simili. Il prezzo di lancio include pagamento una tantum, licenza a vita, aggiornamenti gratuiti, PDF di configurazione, preset pack e supporto prioritario via WhatsApp.",
    "seo_quote": "Fare trading su conti prop è un gioco di numeri giocato entro limiti rigidi. Chi rispetta i limiti più a lungo vince. Prop Passer Gold EA esiste per rendere quei limiti strutturali, non emotivi. Questo è l'intero concetto.",
    "seo_quote_author": "— Il team Dhokiyas"
  },
  "tr": {
    "nav_features": "Özellikler",
    "nav_dashboard": "Kontrol Paneli",
    "nav_comparison": "Karşılaştır",
    "nav_pricing": "Fiyatlandırma",
    "nav_faq": "SSS",
    "nav_get_access": "Erişim Sağla",
    "ann_launch_offer": "Lansman teklifi",
    "ann_save_today": "Bugün {amount} tasarruf edin",
    "ann_left": "kaldı",
    "ann_grab": "Hemen Yakala →",
    "hero_badge1": "Gold için tasarlandı · 2025+ rejimi",
    "hero_badge2": "Prop-firm uyumlu",
    "hero_badge_copies": "Yalnızca {n} kopya kaldı",
    "hero_h1_a": "Prop challenge'larını geçin.",
    "hero_h1_b": "Gold ticareti yapın",
    "hero_h1_c": "disiplinli bir makine gibi.",
    "hero_sub": "Prop Passer Gold EA, XAUUSD odaklı bir MetaTrader 5 robotudur. Prop firması kuralları — drawdown limitleri, hedef kilitleme, işlem başına risk koruması ve birinci sınıf bir grafik üzeri kontrol paneli etrafında tasarlanmıştır. Martingale yok. Grid yok. Sadece kurallara öncelik veren bir uygulama.",
    "hero_cta_primary": "Anında erişim sağlayın",
    "hero_cta_secondary": "WhatsApp üzerinden ücretsiz kurulum desteği",
    "hero_save": "lansman",
    "hero_pill1": "Gold odaklı",
    "hero_pill2": "DD korumalı",
    "hero_pill3": "Tek seferlik ödeme",
    "hero_card_buy": "{price} fiyatına satın alın",
    "hero_card_trust": "Anında teslimat · Güvenli ödeme · Ömür boyu lisans",
    "hero_card_sym": "Sembol",
    "hero_card_plat": "Platform",
    "hero_card_strat": "Strateji",
    "hero_card_prot": "Koruma",
    "hero_card_strat_v": "Yapı + Volatilite",
    "hero_card_prot_v": "Prop Engine",
    "hero_card_b1": "Günlük DD + maksimum DD koruması",
    "hero_card_b2": "Hedefe ulaşıldıktan sonra kar hedefi kilidi",
    "hero_card_b3": "Cuma / hafta sonu koruması",
    "hero_card_b4": "Ekonomik takvim haber filtresi",
    "problem_chip": "Prop firması gerçekliği",
    "problem_h1_a": "10'da 9",
    "problem_h1_b": "trader challenge'larda başarısız oluyor. Kötü girişler yüzünden değil.",
    "problem_sub": "Prop firmaları haklı olduğunuz için ödeme yapmaz. Haklı olduğunuzda kurallar içinde kaldığınız için ödeme yaparlar. Aşağıdaki her başarısızlık, bir piyasa sorunu değil, davranışsal bir sorundur — ve bu EA, bu sorunların her birini ortadan kaldırmak için tasarlanmıştır.",
    "problem_disclaimer": "* Başarısızlık oranları, halka açık prop firması değerlendirme verilerine dayanmaktadır.",
    "fail1_title": "DD kurallarını ihlal etmek",
    "fail1_desc": "Bir kaybın ardından yapılan duygusal bir işlem günlük DD'yi ihlal eder. Challenge biter — hesap bir saat önce karda olsa bile.",
    "fail2_title": "Hedefi geri vermek",
    "fail2_desc": "%8 kar hedefine ulaşın, 'eğlence olsun diye' ticarete devam edin, haftayı %2'de bitirin. EA hedefe ulaştıktan sonra yeni işlemleri otomatik durdurur.",
    "fail3_title": "Zayıf seanslarda aşırı işlem yapmak",
    "fail3_desc": "Gold, rollover, Asya sessizliği ve yüksek spreadli pencerelerde dalgalanır. Seans + spread filtreleri girişleri otomatik olarak engeller.",
    "fail4_title": "Kaybın ardından intikam alma amaçlı işlem boyutu artışı",
    "fail4_desc": "'Geri kazanmak' için lotu iki katına çıkarmak → daha büyük kayıp → maksimum DD'ye ulaşmak. İşlem başına risk limiti bunu matematiksel olarak imkansız kılar.",
    "features_chip": "Risk öncelikli mimari",
    "features_h1_a": "Şunlar için tasarlandı:",
    "features_h1_b": "prop challenge gerçekliği.",
    "features_sub": "Firmalar sezgi için ödeme yapmaz. Onlar, katı sınırlar içindeki disiplin için ödeme yaparlar. Aşağıdaki her modül tek bir nedenden dolayı var: avantajınızın ortaya çıkması için hesabınızı yeterince uzun süre uygun tutmak.",
    "feat1_title": "Prop challenge koruma motoru",
    "feat1_desc": "Dahili ön ayarlar + özel kural modu. Günlük kaybı, maksimum DD'yi, sembol kaybını ve tutarlılığı izler — böylece değerlendirmeleri geçmenizi sağlayan sınırlar içinde kalırsınız.",
    "feat2_title": "Günlük ve maksimum DD koruması",
    "feat2_desc": "Hem statik hem de takip eden DD modellerini destekler. Kayıp tabanlarını gerçek zamanlı hesaplar ve kuralı ihlal edebilecek yeni işlemleri engeller.",
    "feat3_title": "Kar hedefi kilidi",
    "feat3_desc": "Çoğu trader, hedefe ulaştıktan sonra karlarını geri verir. EA, hedefe ulaşıldığında yeni girişleri otomatik olarak durdurabilir — ilerlemeyi kilitler.",
    "feat4_title": "İşlem başına risk koruması",
    "feat4_desc": "Minimum/maksimum lot limitleri ile yüzde tabanlı veya sabit lot boyutlandırma. SL mesafesi limitinizden fazla risk oluşturacak işlemleri engeller.",
    "feat5_title": "Piyasa kalitesi filtreleri",
    "feat5_desc": "ATR volatilite, spread, seans ve haber filtreleri, EA'yı Gold'un trader'ları dalgalandırabileceği toksik koşullardan uzak tutar.",
    "feat6_title": "Cuma ve hafta sonu koruması",
    "feat6_desc": "Cuma kapanışından önce pozisyonları otomatik olarak kapatır ve hafta sonu risk penceresi yakınındaki girişleri engeller — anında fonlama kuralları için mükemmeldir.",
    "feat7_title": "Tutarlılık monitörü",
    "feat7_desc": "En iyi gün-toplam oranını izler, böylece bazı prop firmalarının uyguladığı tutarlılık kurallarını karşılayabilirsiniz. Tek günlük piyango işlemleri yok.",
    "feat8_title": "Martingale yok · grid yok",
    "feat8_desc": "Kaybeden işlemlere ortalama alma yok. Her işlem, piyasa yapısına dayalı katı bir SL'ye sahiptir — değerlendiricilerin beğendiği temiz bir mantık.",
    "feat9_title": "Premium grafik üzeri kontrol paneli",
    "feat9_desc": "Challenge modelini, kalan DD'yi, bugünkü P/L'yi, hedef ilerlemesini, spread'i, haber ve seans durumunu bir bakışta görün — manuel hesaplamaya gerek yok.",
    "dashboard_chip": "Premium grafik üzeri zeka",
    "dashboard_h1_a": "Her kural —",
    "dashboard_h1_b": "gerçek zamanlı görünür.",
    "dashboard_sub": "Çoğu bot sizi tahmin etmeye bırakır. Prop Passer Gold, tam olarak neyin önemli olduğunu gösterir: ne kadar DD alanınız kaldığını, kar hedefine ne kadar yakın olduğunuzu ve piyasanın şu anda işlem yapmak için güvenli olup olmadığını. Artık zihinsel matematik yok. Artık kural ihlali sürprizleri yok.",
    "dash_b1": "Canlı günlük / maksimum DD göstergeleri",
    "dash_b2": "Kar hedefi ilerlemesi — hedefe ulaşıldığında ticareti durdurur",
    "dash_b3": "Her girişten önce işlem başına risk hesaplayıcı",
    "dash_b4": "Spread · haber · seans filtreleri her zaman açık",
    "dash_b5": "Katı prop firmaları için tutarlılık skoru",
    "dash_label1": "Ana EA kontrol paneli",
    "dash_label2": "Drawdown guard",
    "dash_label3": "Risk ölçer",
    "dash_label4": "Öz sermaye eğrisi",
    "dash_label5": "Prop kuralları paneli",
    "comp_chip": "Yan yana",
    "comp_h1_a": "Trader'lar neden sürekli",
    "comp_h1_b": "hesap kaybediyor?",
    "comp_sub": "Fonlanmış ve başarısız arasındaki fark girişler değil — girişten sonra ne olduğudur. Prop Passer Gold işte burada kazanır.",
    "comp_yes": "Evet",
    "comp_no": "Hayır",
    "comp_partial": "Kısmi / duruma bağlı",
    "comp_capability": "Yetenek",
    "comp_col1": "Prop Passer Gold EA",
    "comp_col2": "Manuel işlem",
    "comp_col3": "Jenerik EA'lar",
    "comp_row1": "Günlük DD limitine uyar",
    "comp_row2": "SL ihlalinden önce işlemi engeller",
    "comp_row3": "Kar hedefinden sonra otomatik durur",
    "comp_row4": "Martingale yok / grid yok",
    "comp_row5": "Dahili prop firması ön ayarları",
    "comp_row6": "Cuma / hafta sonu koruması",
    "comp_row7": "Ekonomik takvim haber filtresi",
    "comp_row8": "Tutarlılık monitörü",
    "comp_row9": "Duygudan arındırılmış işlem 24/5",
    "comp_row10": "Grafik üzeri güvenlik kontrol paneli",
    "how_chip": "15 dakikada devreye alın",
    "how_h1_a": "Ödemeden",
    "how_h1_b": "ilk işleme.",
    "how_sub": "Kodlama yok. Telegram grupları yok. Elden tutma gereksinimi yok. Kurulum kılavuzu her tıklamada size yol gösterir.",
    "how_cta": "Şimdi {price} ile başlayın",
    "step_label": "ADIM",
    "step1_t": "Anında indirme",
    "step1_d": "Tek seferlik ödeme yapın — .ex5 dosyası, kurulum PDF'i ve prop-firması ön ayar paketi anında e-posta kutunuza gelir.",
    "step2_t": "XAUUSD'ye ekleyin",
    "step2_d": "MetaTrader 5'te bir Gold grafiğine sürükleyin, challenge ön ayarınızı (FTMO, MyFF, The5ers…) seçin veya özel olarak ayarlayın.",
    "step3_t": "Motor devralır",
    "step3_d": "Her giriş önce risk koruyucusundan geçer — eğer kuralınızı ihlal edebilirse, gerçekleşmeden önce engellenir.",
    "step4_t": "Hedefinize ulaşın",
    "step4_d": "Kar hedefine ulaştıktan sonra ticareti otomatik durdurur. Her şeyi kaydeder. Siz fonlanmaya odaklanın.",
    "whofor_chip": "Dürüst uygunluk kontrolü",
    "whofor_h1_a": "Bunu okuyun",
    "whofor_h1_b": "satın almadan önce.",
    "whofor_sub": "Bu EA belirli bir trader türü için yapılmıştır. Sol sütundaysanız, onu seveceksiniz. Sağ sütundaysanız — paranızı saklayın ve uzaklaşın.",
    "whofor_for_title": "Şu durumlarda sizin için tasarlandı...",
    "whofor_not_title": "Şu durumlarda sizin için değil...",
    "for1": "Prop challenge katılımcıları (FTMO, MyFF, The5ers, FundedNext, vb.)",
    "for2": "Sermayelerini koruyan fonlanmış hesap sahipleri",
    "for3": "Disiplinli otomasyon isteyen XAUUSD / Gold trader'ları",
    "for4": "Kendi hesaplarında intikam ticareti yapmaktan yorulan trader'lar",
    "for5": "Günde 10 saat grafik izleyemeyen yarı zamanlı trader'lar",
    "for6": "Bir VPS çalıştırmaya yetecek kadar ciddi olan herkes",
    "not1": "Garantili kar bekleyen 'hızlı zengin ol' alıcıları",
    "not2": "Martingale veya grid ile kurtarma arayan trader'lar",
    "not3": "Kurulum kılavuzunu okumayacak kişiler",
    "not4": "Prop firması kural PDF'lerini göz ardı eden trader'lar",
    "not5": "EA'nın 24 saat içinde para basmasını bekleyen herkes",
    "proof_chip": "Topluluk",
    "proof_h1_a": "Kumarı bırakan",
    "proof_h1_b": "trader'lar.",
    "proof_sub": "Sonuçlar brokere, ayarlara ve piyasa koşullarına bağlıdır — ancak oyun planı aynıdır: önce kurallar, sonra uygulama.",
    "proof_disclaimer": "Yasal Uyarı: İşlem yapmak risk içerir. Hiçbir Expert Advisor karı veya herhangi bir challenge'ı geçmeyi garanti edemez. Geçmiş performans gelecek sonuçları tahmin etmez. Canlı veya fonlanmış bir hesapta kullanmadan önce her zaman test edin.",
    "stat1_l": "Uzmanlaşmış sembol",
    "stat2_l": "Mevcut Gold rejimi",
    "stat3_l": "Martingale / grid",
    "stat4_l": "Tek seferlik fiyat",
    "test1_role": "Fonlanmış · Gold trader'ı",
    "test1_txt": "Nihayet günlük DD'ye saygı duyan bir EA. Tek bir aşırı işlem günü kırmızı görmeden Faz 1'i geçtim.",
    "test2_role": "Değerlendirme",
    "test2_txt": "Sadece kontrol paneli bile buna değer. Hedef kilidi, kazançlı bir haftayı geri vermekten beni kurtardı.",
    "test3_role": "Prop challenge katılımcısı",
    "test3_txt": "Martingale yok, grid yok — temiz mantık. Gold nihayet otomatik pilotta işlenebilir geliyor.",
    "test4_role": "Yarı zamanlı trader",
    "test4_txt": "Kurulum VPS'te 15 dakikaydı. Spread ve haber filtresi beni dalgalanma bölgelerinden uzak tutuyor.",
    "bonus_chip": "Ücretsiz olarak pakete dahil",
    "bonus_h1_a": "bonuslar — sıfır ek maliyet.",
    "bonus_sub": "{price} fiyatınız EA'yı ve aşağıdaki her şeyi açar. Ek satış yok. Kısıtlama yok. Hepsi anında indirilebilir.",
    "bonus_total": "Toplam gerçek değer",
    "bonus_save": "Bugün {amount} tasarruf edersiniz",
    "bonus_free": "EA ile ücretsiz",
    "bonus_worth": "Değerinde",
    "b1_t": "Kurulum kılavuzu PDF",
    "b1_d": "Ekran görüntüleri ile broker bazında kurulum rehberi.",
    "b2_t": "Prop firması ön ayar paketi",
    "b2_d": "FTMO, MyFF, The5ers, FundedNext için önceden yapılandırılmış .set dosyaları.",
    "b3_t": "XAUUSD kural hile kağıdı",
    "b3_d": "Challenge boyutuna göre güvenli risk bantlarını içeren tek sayfalık PDF.",
    "b4_t": "Ömür boyu güncellemeler",
    "b4_d": "Her gelecek sürüm size ücretsiz olarak gönderilir — sonsuza dek.",
    "pricing_chip": "Fiyatlandırma",
    "pricing_h1_a": "Tek seferlik.",
    "pricing_h1_b": "Abonelik yok.",
    "pricing_sub": "Tek bir başarısız prop challenge ücretinin bir kısmı. Bir kez ödeyin, ömür boyu sahip olun.",
    "pricing_offer": "Lansman teklifi · {n} kopya kaldı",
    "pricing_save": "{amount} tasarruf edin · tek seferlik",
    "pricing_cta": "Anında erişim sağlayın",
    "pricing_secure": "Güvenli ödeme · Anında dosya teslimatı",
    "pricing_what_get": "Ne elde edersiniz",
    "pricing_inc1": "Prop Passer Gold EA (MT5 için .ex5 dosyası)",
    "pricing_inc2": "Adım adım kurulum kılavuzu (PDF)",
    "pricing_inc3": "Dahili prop firması ön ayarları + özel kurallar",
    "pricing_inc4": "Premium grafik üzeri kontrol paneli",
    "pricing_inc5": "Ömür boyu erişim — abonelik yok",
    "pricing_inc6": "Piyasa geliştikçe ücretsiz güncellemeler",
    "pricing_inc7": "Öncelikli WhatsApp desteği",
    "faq_chip": "Sorular",
    "faq_h1_a": "Gerçekten",
    "faq_h1_b": "alıcıların sorduğu şeyler.",
    "faq1_q": "Bu EA prop firmamla uyumlu mu?",
    "faq1_a": "Evet. EA, yaygın challenge stilleri (FTMO, MyForexFunds, The5ers, FundedNext ve benzeri) için dahili ön ayarlarla ve kendi kar hedefinizi, günlük DD'yi, maksimum DD'yi (statik veya takip eden), sembol kaybını ve tutarlılık kurallarını belirlediğiniz özel bir kural moduyla birlikte gelir. Dağıtımdan önce her zaman sağlayıcınızın kural PDF'ine karşı doğrulayın.",
    "faq2_q": "Martingale, grid veya ortalama kullanıyor mu?",
    "faq2_a": "Hayır. Her işlemin katı bir stop loss'u ve yapıya dayalı boyutlandırması vardır. Kaybeden işlemlere ortalama alma yok, grid kurtarma yok, ikiye katlama yok. Değerlendiricilerin tercih ettiği temiz bir mantık.",
    "faq3_q": "Hangi hesaplar ve broker'lar çalışır?",
    "faq3_a": "Gerçekçi XAUUSD spreadleri ve komisyonları olan herhangi bir güvenilir MT5 broker'ı. ECN / raw-spread broker'lar sıkı işlem yürütme için önerilir. EA broker'dan bağımsızdır — nerede işlem yapacağınızın tam kontrolü sizde kalır.",
    "faq4_q": "Satın aldıktan sonra nasıl teslim edilir?",
    "faq4_a": "Anında indirme. Ödemeden sonra, .ex5 EA dosyasını, adım adım kurulum kılavuzunu (PDF) ve prop firması ön ayar paketini dakikalar içinde e-posta yoluyla alırsınız. Manuel kurulum yok, bekleme yok.",
    "faq5_q": "VPS'ye ihtiyacım var mı?",
    "faq5_a": "24/5 çalışma için önerilir, böylece EA siz uyurken çalışmaya devam eder. Herhangi bir standart MT5 uyumlu VPS çalışır. Kurulum kılavuzu VPS temel bilgilerini kapsar.",
    "faq6_q": "Tek seferlik bir ödeme mi?",
    "faq6_a": "Evet. Tek ödeme, ömür boyu lisans. Aylık ücret yok, gizli yenilemeler yok, hesap başına limit yok. Gelecekteki güncellemeler ücretsiz olarak dahildir.",
    "faq7_q": "Bir challenge'ı geçeceğimi garanti eder mi?",
    "faq7_a": "Hayır — ve bu garantiyi size satan herkes yalan söylüyordur. Bu EA, hesapların başarısız olmasına neden olan en yaygın davranışsal hataları ortadan kaldıran, kurallar öncelikli bir işlem aracıdır. Sonuçlar broker'a, spread'e, slippage'a, seçtiğiniz ayarlara ve piyasa koşullarına bağlıdır.",
    "faq8_q": "Rakipler {comp} talep ederken neden bu kadar ucuz?",
    "faq8_a": "Bu, ilk alıcı dalgası için bir lansman fiyatıdır. Tam fiyatı {full}. Lansman süresi sona erdiğinde fiyat normale döner. Erken benimseyenler aynı ürünü — sadece maliyetin bir kısmına — alır.",
    "final_chip": "Lansman dönemi · Yalnızca {n} kopya kaldı",
    "final_h1_a": "Başarısız olmayı",
    "final_h1_b": "bırakın.",
    "final_h1_c": "Kurallar içinde işlem yapmaya başlayın.",
    "final_sub": "Tek ödeme. Ömür boyu erişim. Değerlendirmeleri geçen aynı işlem motoru — şimdi Gold grafiğinizde, 24/5, hesapları tüketen duygusal hatalar olmadan çalışıyor.",
    "final_save": "{amount} tasarruf edin · lansmana özel %90 indirim",
    "final_cta": "Anında erişim sağlayın",
    "final_trust": "Güvenli ödeme · Anında .ex5 dosya teslimatı · Ömür boyu lisans",
    "footer_product_tag": "XAUUSD · MT5 · v1.23",
    "footer_about": "Prop challenge kuralları — drawdown limitleri, hedef kilidi, risk korumaları ve premium bir kontrol paneli etrafında tasarlanmış, MetaTrader 5 için Gold odaklı bir Expert Advisor.",
    "footer_product": "Ürün",
    "footer_contact": "İletişim",
    "footer_setup": "Ücretsiz kurulum desteği",
    "footer_download": "Uygulamamızı indirin",
    "footer_sold_by": "{seller} tarafından satılır",
    "footer_copyright": "© {year} Dhokiya's Research Analyst. Tüm hakları saklıdır.",
    "footer_disclaimer": "İşlem yapmak önemli risk içerir. Geçmiş performans gelecek sonuçları tahmin etmez. Hiçbir EA herhangi bir challenge'ı geçmeyi garanti etmez.",
    "locale_title": "Dilinizi seçin",
    "locale_sub": "Bölgeniz tespit edildi. Devam etmek için tercih ettiğiniz dili seçin. Bunu menüden istediğiniz zaman değiştirebilirsiniz.",
    "locale_continue_en": "İngilizce devam et",
    "locale_continue_other": "{lang} dilinde devam et",
    "lang_label": "Dil",
    "currency_label": "Para Birimi",
    "live_feed": "Canlı Akış"
  
,
    "seo_chip": "Kapsamlı rehber",
    "seo_h1_a": "Prop firm challenge'larını bir",
    "seo_h1_b": "Gold EA ile geçme rehberi",
    "seo_intro": "FTMO, MyForexFunds, The5ers veya FundedNext değerlendirmelerine katılan çoğu trader, yanlış yön seçtikleri için başarısız olmazlar. Tek bir duygusal işlemden sonra bir kuralı — genellikle günlük drawdown, maksimum drawdown veya tutarlılık kuralını — çiğnedikleri için başarısız olurlar. **Prop Passer Gold EA** tam da bu soruna odaklanarak geliştirilmiştir. Prop firm kural uyumunu bir irade probleminden yazılım ayarına dönüştüren, XAUUSD odaklı bir MetaTrader 5 Expert Advisor'ıdır.",
    "seo_card1_t": "Prop challenge'ları için neden XAUUSD (Altın)?",
    "seo_card1_d": "Altın, prop trader'ların ihtiyaç duyduğu her şeyi sunar: yüksek volatilite, derin likidite, 24 saatlik Londra / New York / Asya seansı aktivitesi ve kural tabanlı uygulamayı ödüllendiren yapısal paternler. Çoğu prop firm, makul swap ve komisyon maliyetleriyle XAUUSD'ye izin verir — 10K$'dan 200K$'a kadar olan değerlendirme hesapları için idealdir.",
    "seo_card2_t": "EA, prop firm kurallarını nasıl uygular?",
    "seo_card2_d": "Her potansiyel işlem, emir gönderilmeden önce sıralı bir kontrol sürecinden geçer. İşlem başına risk hesaplayıcısı, pozisyonu öz sermaye limitinize (varsayılan %0.5–1) uyacak şekilde ayarlar. Günlük DD koruması, en kötü senaryo kaybını öngörür ve bu sınırı aşarsa işlemi reddeder. Maksimum DD koruması, sabit veya değişken kurallar için aynı şeyi yapar. Kâr hedefi kilidi, hedefiniz karşılandığında yeni işlem açmayı durdurur.",
    "seo_card3_t": "Prop firm ön ayarları dahildir",
    "seo_card3_d": "Lansman paketi, FTMO (Phase 1, 2, Funded), MyForexFunds Rapid / Evaluation / Accelerated, The5ers Hyper Growth ve Bootcamp, FundedNext Stellar / Express ve çeşitli anında fonlama firmaları için önceden yapılandırılmış .set dosyaları ile birlikte gelir. Özel mod, herhangi bir yeni firmanın kural PDF'ine göre kuralları manuel olarak yapılandırmanıza olanak tanır.",
    "seo_card4_t": "Martingale yok. Grid yok. Ortalama alma yok.",
    "seo_card4_d": "Telegram'da satılan ucuz EA'lar martingale veya grid kurtarma stratejilerini gizler — geçmiş testlerde kârlı görünürler çünkü riski hesabı patlatan kuyruk olaylarına gömerler. Prop firmalar bunları anında tespit eder ve hesabı diskalifiye eder. Prop Passer Gold, yalnızca katı stop loss'larla yapı tabanlı girişler kullanır — prop firmaların açıkça desteklediği türden temiz bir mantık.",
    "seo_card5_t": "Bu EA kimler için?",
    "seo_card5_d": "Prop challenge'lara katılanlar, sermayesini koruyan fonlu hesap sahipleri ve günün 10 saatini grafik izlemeden disiplinli otomasyon isteyen XAUUSD trader'ları için tasarlandı. Bu bir 'hızlı zengin olma' aracı değil — bir disiplin uygulama aracıdır. Garanti kâr arıyorsanız, bu sizin için değildir.",
    "seo_card6_t": "Kurulum ve broker gereksinimleri",
    "seo_card6_d": "Yalnızca MetaTrader 5 üzerinde çalışır. 24/5 kesintisiz çalışma için bir VPS üzerinde kullanılması önerilir. FTMO, MyForexFunds, The5ers, FundedNext, FundingPips, Goat Funded Trader ve benzeri firmaların kullandığı broker'lar da dahil olmak üzere herhangi bir güvenilir ECN / raw-spread MT5 broker'ı çalışır. Lansman fiyatı tek seferlik ödeme, ömür boyu lisans, ücretsiz güncellemeler, kurulum PDF'i, ön ayar paketi ve öncelikli WhatsApp desteği içerir.",
    "seo_quote": "Prop hesap ticareti, katı sınırlar içinde oynanan bir sayı oyunudur. Sınırlara en uzun süre saygı duyan kazanır. Prop Passer Gold EA, bu sınırları duygusal değil, yapısal hale getirmek için vardır. Tüm açıklama budur.",
    "seo_quote_author": "— The Dhokiyas ekibi"
  }
};

export const LANGUAGES = [
  { code: "en", name: "English", native: "English", flag: "🇺🇸" },
  { code: "es", name: "Spanish", native: "Español", flag: "🇪🇸" },
  { code: "ru", name: "Russian", native: "Русский", flag: "🇷🇺" },
  { code: "zh", name: "Chinese", native: "中文", flag: "🇨🇳" },
  { code: "pt", name: "Portuguese", native: "Português", flag: "🇵🇹" },
  { code: "ja", name: "Japanese", native: "日本語", flag: "🇯🇵" },
  { code: "de", name: "German", native: "Deutsch", flag: "🇩🇪" },
  { code: "ko", name: "Korean", native: "한국어", flag: "🇰🇷" },
  { code: "fr", name: "French", native: "Français", flag: "🇫🇷" },
  { code: "it", name: "Italian", native: "Italiano", flag: "🇮🇹" },
  { code: "tr", name: "Turkish", native: "Türkçe", flag: "🇹🇷" },
];

export function detectLanguage() {
  if (typeof navigator === 'undefined') return 'en';
  const locales = [navigator.language, ...(navigator.languages || [])];
  for (const loc of locales) {
    const code = (loc || '').toLowerCase().split('-')[0];
    if (TRANSLATIONS[code]) return code;
  }
  return 'en';
}

export function format(str, vars = {}) {
  return Object.keys(vars).reduce((s, k) => s.replaceAll(`{${k}}`, vars[k]), str);
}
